// Generated payor list from stedi_payers_2025-10-30.csv
// Includes DisplayName and Names column values
// Case-insensitive duplicates removed
export const STEDI_PAYOR_OTHER =
  "Other (Write name and number into Additional Info)";

export const STEDI_PAYORS = [
  STEDI_PAYOR_OTHER,
  "1199 National Benefit Fund",
  "137654 California Incorporated",
  "2020 Eyecare",
  "21st Century Insurance",
  "22125 Roscoe Corporation",
  "4DS Limited Partnership Doing Business As Georgian Hotel",
  "6 Degrees Health Incorporated",
  "90 Degrees Benefits",
  "A J Edmund Company Incorporated",
  "A W S Construction",
  "A-G Administrators LLC",
  "AAA Minnesota Iowa",
  "AAA North California Nevada and Utah Insurance Exchange",
  "AARP Dental Insurance Plan",
  "AARP Hospital Indemnity Plans",
  "AARP Medicare Supplement by UnitedHealthcare",
  "AARP Medicare Supplement Plans",
  "AARP MedicareComplete insured through UnitedHealthcare",
  "AARP MedicareComplete insured through UnitedHealthcare / Oxford Medicare Network",
  "AARP MedicareComplete insured through UnitedHealthcare / Oxford Mosaic Network",
  "AARP UnitedHealthCare Insurance Company",
  "ABC Construction Company",
  "Abilene Independent School District Run Off",
  "Abilene Independent School District Self Insured",
  "AblePay Health",
  "Absolute Total Care",
  "Acadia Insurance Company",
  "Accelerated Claims Inc",
  "Accendo Insurance Company",
  "Access Administrator",
  "Access Community Health Network",
  "Access Health Services",
  "Access Independent Practice Association",
  "Access Integra",
  "Access IPA",
  "Access Medical Group",
  "Access Primary Care Medical Group",
  "Accident Fund Insurance Company of America",
  "Acclaim",
  "Acclaim Independent Practice Association",
  "Accord Human Resources California",
  "Accord Human Resources Oklahoma",
  "Accountable Healthcare Independent Physician Association (AHIPA)",
  "Accountable Healthcare Independent Practice Association (AHIPA)",
  "Accountable IPA",
  "Accurate Air Systems",
  "Accuride Corporation",
  "ACE Medicare Supplement",
  "Ace Property & Casualty Insurance Medicare Supplement",
  "ACE Property and Casualty Insurance Company",
  "ACEC Health Plans (Salt Lake City)",
  "ACEC Health Plans (Salt Lake City, Utah)",
  "ACIG Insurance Company",
  "Acme Truck Parts",
  "ACS Benefit Services Inc",
  "ACS Benefits Services",
  "ACS Consulting Services Incorporated",
  "Activa Benefit Services LLC",
  "Active Care UCS",
  "Active Care United Clinical Services",
  "ActivHealthCare",
  "Actuarial Management Resources (AMR)",
  "Acuity Mutual Insurance Company",
  "Ad Compensation",
  "AD-COMP",
  "Adelanto Correctional Facility California",
  "Adelanto School District California",
  "Administaff",
  "Administración de Compensaciones por Accidentes de Automóviles",
  "Administrative Claim Service Incorporated",
  "Administrative Concepts Inc",
  "Administrative Concepts Incorporated",
  "Administrative District Council 1 Welfare fund",
  "Administrative Services Incorporated",
  "Administrative Services Only",
  "Adminone LLC",
  "ADP Total Source Incorporated",
  "ADP TotalSource Incorporated",
  "Advance America Cash Advance Centers",
  "Advance Paper Box Company",
  "Advance Services Incorporated",
  "Advanced Data Solutions Incorporated",
  "Advanced Engine Management Incorporated",
  "Advanced Physicians Independent Practice Association",
  "Advanced Real Estate Services",
  "Advantage Care IPA",
  "Advantage Dental",
  "Advantage Medical Group",
  "Advantek Benefit Administrators",
  "Advent Health Medical Corporation",
  "Adventek Benefit Administrators",
  "AdventHealth Rocky Mountain",
  "AdventHealth Transplant Program",
  "AdventHealth Value Based Bundle Management, LLC",
  "AdventHealth Waterman",
  "Adventist Health Plan",
  "Adventist Health Plan (AHP) Provider Network",
  "Adventist Health Plan Provider Network",
  "Adventist Health System West (Roseville California)",
  "Adventist HealthCare Network",
  "Adventist White Memorial (Crown City Medical Group)",
  "Adventist White Memorial (Southland San Gabriel Valley)",
  "Advisory Health Administrators",
  "Advocare Managed Care Organization Incorporated",
  "Advocare MCO Incorporated",
  "Advocate Health Partners",
  "Advocate Medical Group",
  "Advocate Physician Partners",
  "Aegis Administrative Services",
  "Aerospace Service and Controls",
  "Aetna",
  "Aetna Administrator Medicare Supplement",
  "Aetna Affordable Health Choices (SM) - SRC",
  "Aetna Affordable Health Choices (SM) SRC",
  "Aetna Better Health",
  "Aetna Better Health - PA",
  "Aetna Better Health California",
  "Aetna Better Health Florida",
  "Aetna Better Health Illinois",
  "Aetna Better Health Kansas",
  "Aetna Better Health Kentucky",
  "Aetna Better Health Louisiana",
  "Aetna Better Health Maryland",
  "Aetna Better Health Michigan",
  "Aetna Better Health New Jersey",
  "Aetna Better Health New York",
  "Aetna Better Health of Michigan (J8) - Joint Venture Hospital Laboratory",
  "Aetna Better Health of Michigan (J8) - JVHL",
  "Aetna Better Health Ohio",
  "Aetna Better Health Oklahoma",
  "Aetna Better Health Pennsylvania",
  "Aetna Better Health Texas",
  "Aetna Better Health Virginia",
  "Aetna Better Health West Virginia",
  "Aetna Dental Medicare",
  "Aetna Dmo",
  "Aetna EAP",
  "Aetna Genworth Life Insurance Company",
  "Aetna Insurance Company",
  "Aetna Medicaid Illinois",
  "Aetna Medicare Advantage",
  "Aetna Medicare Replacement",
  "Aetna OhioRise Medicaid Managed Care Entity",
  "Aetna Retiree Medical Plan - Administrator",
  "Aetna Senior Supplemental",
  "Aetna Senior Supplemental Insurance",
  "Aetna Signature Administrators GEHA",
  "Aetna SSI",
  "Aetna Strategic Resource Company",
  "Aetna Texas Medicaid and Children's Health Insurance Program",
  "Aetna US Healthcare (J1) - Joint Venture Hospital Laboratory",
  "Aetna US Healthcare (J1) - JVHL",
  "Affiliated Doctors of Orange County (ADOC)",
  "Affiliated Partners Independent Practice Association",
  "Affiliated Partners IPA",
  "Affiliated Physicians Independent Practice Association",
  "Affiliated Physicians IPA",
  "Affinity Medical Group",
  "AFLAC",
  "AFLAC Dental",
  "Aflac Medicare Supplemental",
  "AG Facilities Operations LLC",
  "AGC International Union Operating Engineers Local 701",
  "AgeRight Advantage",
  "AgeWell New York",
  "AGIA Inc",
  "Agri Beef Company",
  "AIDS Health Foundation (AHF)",
  "AIDS Healthcare Foundation (AHF)",
  "AIDS Healthcare Foundation Ryan White",
  "AIG Chartis",
  "Air Liquide USA LLC",
  "Aither Health",
  "AKM Medical Group",
  "Alameda Alliance",
  "Alameda Alliance for Health",
  "Alameda Alliance for Health - Dental",
  "Alamitos Independent Practice Association",
  "Alamo Heights Independent School District",
  "Alan Sturm & Associates",
  "Alan Sturm and Associates",
  "Alaska Carpenters",
  "Alaska Children's Services Incorporated",
  "Alaska Hotel Employees Restaurant and Camp Employees",
  "Alaska Laborers Construction Industry Trust",
  "Alaska National Insurance",
  "Alaska Pipe Traders Local 375",
  "Alaska Public Employees Association",
  "Alaska United Food and Commercial Workers Trust",
  "Albuquerque Public Schools",
  "Alcoa Fasteners Systems",
  "Aledo Independent School District",
  "Alexian Brothers Community Services Tennessee",
  "Alexian PACE",
  "Alicare",
  "Align Network (One Call Physical Therapy)",
  "Align Networks (One Call Physical Therapy)",
  "Align Senior Care (Florida)",
  "Align Senior Care California",
  "Align Senior Care Michigan",
  "Align Senior Care Virginia",
  "Aligned Community Physicians",
  "Alignment Health Plan (Fee for Service)",
  "Alignment HealthCare",
  "Alivi Health",
  "Alivi Therapy Network",
  "All American Medical Group",
  "All Care Medical Group",
  "All Savers",
  "All Savers Alternate Funding",
  "All Savers Insurance",
  "All Savers Life Insurance Company",
  "All Smiles Community Oral Health",
  "All United Medical Group",
  "AllCare Advantage",
  "AllCare Health Coordinated Care Organization",
  "AllCare Independent Practice Association",
  "AllCare IPA",
  "AllCare Program of All-inclusive Care for the Elderly",
  "AllCare Programs of All-inclusive Care for the Elderly",
  "Allegeant",
  "Allegheny Technologies",
  "Allegiance Benefit Plan Management Incorporated",
  "Allegiance Benefit Plan Management, Inc.",
  "Allen Canning",
  "Alliance Alpha Care Gold",
  "Alliance AlphaCare Gold",
  "Alliance Behavioral Healthcare",
  "Alliance Coal Health Plan",
  "Alliance Health Systems",
  "Alliance HealthPlans of WI",
  "Alliance HealthPlans of Wisconsin",
  "Alliance Independent Practice Association",
  "Alliance Physicians Medical Group",
  "Alliance Physicians of the High Desert",
  "Alliant Health Plans Georgia",
  "Allianz",
  "Allianz Global Assistance",
  "Allied - Allstate Benefits",
  "Allied - Christian Brothers Services",
  "Allied Benefit Systems",
  "Allied Benefit Systems Incorporated",
  "Allied Claims Administration Incorporated",
  "Allied Construction",
  "Allied Insurance Companies",
  "Allied Metal Crafts Security Plan Trust Fund",
  "Allied National, Inc",
  "Allied Pacific of California",
  "Allied Physicians Medical Group",
  "Allied Property and Casualty Insurance Company",
  "Allina Health",
  "Allina Health Aetna",
  "Allmerica Financial Benefits Insurance Company",
  "Allstate (All States Except New Jersey)",
  "Allways Health Partners",
  "AlohaCare",
  "Alpha Property Management Incorporated",
  "AlphaCare",
  "AlphaCare Medical Group",
  "Alta Bates Medical Group",
  "Alta HealthCare",
  "Altais Care Network",
  "AltaMed",
  "Alternative Insurance Resources",
  "Alternative Insurance Resources Incorporated",
  "Alternative Opportunities",
  "Alternative Risk Management (ARM)",
  "Alterwood Advantage",
  "Altus Dental",
  "Alvey Systems (AON Risk)",
  "Alvey Systems (AON Risk) (Auto Only)",
  "Always Care Benefits",
  "AMA Insurance Agency",
  "Amalgamated Life",
  "Amanda Health",
  "Ambetter",
  "Ambetter from Buckeye Community Health Plan",
  "Ambetter from CeltiCare Health",
  "Ambetter from Coordinated Care",
  "Ambetter from Fidelis Care",
  "Ambetter from Health Net",
  "Ambetter from Magnolia Health Plan",
  "Ambetter from Managed Health Services",
  "Ambetter from Peach State Health Plan",
  "Ambetter from Sunshine Health",
  "Ambetter from Superior HealthPlan",
  "Ambetter of Arkansas",
  "AMC Plus",
  "AMCO Insurance Company",
  "AmeraPlan",
  "AmeriBen IEC Group",
  "AmeriBen Solutions",
  "AmeriBen Solutions Incorporated",
  "America First",
  "America's 1st Choice Health Plans of South Carolina",
  "America's Health Plan",
  "America's PPO/America's TPA",
  "America's Preferred Provider Organization (Arizona)",
  "Americaid Community Care (Maryland)",
  "Americaid Community Care (New Jersey)",
  "American Behavioral",
  "American Benefits Corporation",
  "American Chiropractic Independent Practice Association of New York",
  "American Chiropractic IPA of New York",
  "American Chiropractic Network",
  "American Chiropractic Network Independent Practice Association New York",
  "American Claims Management (ACM)",
  "American Coin Merchandising Incorporated",
  "American Cyanamid",
  "American Family Health Providers",
  "American Family Insurance Company",
  "American Family Insurance Group",
  "American Family Life Assurance Company",
  "American Fidelity Assurance Company",
  "American Founders Life Insurance Company",
  "American Furniture Warehouse",
  "American General",
  "American Health Advantage Idaho",
  "American Health Advantage Mississippi",
  "American Health Advantage of Florida",
  "American Health Advantage of Indiana",
  "American Health Advantage of Louisiana",
  "American Health Advantage of Missouri",
  "American Health Advantage Tennessee",
  "American Health Advantage Texas",
  "American Health Advantage Utah",
  "American Health Plans of Pennsylvannia",
  "American Health Resources",
  "American HealthCare Alliance",
  "American Home Craft",
  "American Income Life Insurance Company",
  "American Insurance Administrators (AIA)",
  "American Insurance Company of Texas",
  "American International Group Chartis",
  "American Interstate",
  "American Liberty Insurance Company",
  "American Medical Association Insurance Agency",
  "American Medical Security",
  "American Mining Insurance Group LLC",
  "American National Insurance Company",
  "American National Life Insurance Company of Texas",
  "American National Property and Casualty Company",
  "American Network Insurance",
  "American Plan Administrators",
  "American Postal Workers Union",
  "American Primary Care Independent Practice Association",
  "American Primary Care IPA",
  "American Progressive",
  "American Public Life (APL)",
  "American Public Life Insurance Company",
  "American Republic Insurance Company",
  "American Republic Insurance Company (ARIC)",
  "American Retirement Life Insurance Company Medica",
  "American Specialty Companies",
  "American Specialty Health",
  "American Specialty Insurance Medical Information Bureau",
  "American Specialty Insurance Medical Information Bureau (MIB)",
  "American Therapy Administrators",
  "American Tile and Brick Veneer",
  "American Tow and Auto Repair Doing Business As",
  "American Whole Health Networks",
  "American Worker Health Plus",
  "AmeriCare Community Care (New Jersey)",
  "Americas Choice Healthplans (NMA)",
  "Americas Health Plan",
  "Americas Preferred Provider Organization (ARAZ)",
  "AmeriChoice by United HealthCare New York",
  "AmeriChoice by UnitedHealthcare New York",
  "AmeriChoice Community Care (Maryland)",
  "AmeriChoice of New Jersey",
  "AmeriChoice of Pennsylvania",
  "AmeriChoice Pennsylvania (Medicaid Children's Health Insurance Program)",
  "Americo Financial Life & Annuity Insurance Company",
  "Amerigroup",
  "Amerigroup (Claims)",
  "Amerigroup - DC,GA,NM,AZ,IA,NJ,TN,TX,WA",
  "Amerigroup Community Care",
  "Amerigroup Corporation",
  "Amerigroup Houston",
  "Amerigroup Multiple States",
  "Amerigroup-Medicaid",
  "Amerigroup-WellPoint",
  "AmeriHealth Administrators",
  "AmeriHealth Administrators & Inter-County",
  "Amerihealth Carita Iowa",
  "AmeriHealth Caritas Delaware",
  "AmeriHealth Caritas District of Columbia",
  "AmeriHealth Caritas Florida",
  "AmeriHealth Caritas Health Plan New Hampshire",
  "AmeriHealth Caritas Louisiana",
  "AmeriHealth Caritas Louisiana (LA Care)",
  "AmeriHealth Caritas Louisiana (LaCare)",
  "AmeriHealth Caritas NE Aligned",
  "AmeriHealth Caritas Nebraska Aligned",
  "AmeriHealth Caritas Nebraska Community HealthChoices",
  "AmeriHealth Caritas New Hampshire",
  "AmeriHealth Caritas Next - Product of AmeriHealth Caritas Florida",
  "AmeriHealth Caritas Next Delaware",
  "AmeriHealth Caritas Next Florida",
  "AmeriHealth Caritas Next North Carolina",
  "AmeriHealth Caritas Next, a product of AmeriHealth Caritas Florida",
  "AmeriHealth Caritas Next, Delaware",
  "AmeriHealth Caritas North Carolina",
  "AmeriHealth Caritas Northeast (AmeriHealth Northeast)",
  "AmeriHealth Caritas Northeast (combined with Line of Business 0500)",
  "AmeriHealth Caritas Northwest (Pennsylvania New West) (combined with Line of Business 0500)",
  "AmeriHealth Caritas Ohio Medicaid Managed Care Entity",
  "AmeriHealth Caritas Ohio Medicaid Managed Care Entity (Transportation Only)",
  "AmeriHealth Caritas Ohio Medicaid MCE",
  "AmeriHealth Caritas Ohio Medicaid MCE (Transportation Only)",
  "Amerihealth Caritas PA Community Healthchoices",
  "AmeriHealth Caritas Pennsylvania",
  "AmeriHealth Caritas Pennsylvania Aligned",
  "AmeriHealth Caritas Pennsylvania Community HealthChoices",
  "AmeriHealth Caritas Pennsylvania Dental",
  "AmeriHealth Caritas Southwest",
  "AmeriHealth Caritas VIP Care",
  "AmeriHealth Caritas VIP Care (HMO-SNP)",
  "AmeriHealth Caritas VIP Care - Delaware DSNP",
  "AmeriHealth Caritas VIP Care - Florida DSNP",
  "AmeriHealth Caritas VIP Care - Florida Dual Eligible Special Needs Plan",
  "AmeriHealth Caritas VIP Care Delaware DSNP",
  "AmeriHealth Caritas VIP Care Delaware Dual Eligible Special Needs Plan",
  "AmeriHealth Caritas VIP Care Delaware Dual Special Needs Plan",
  "AmeriHealth Caritas VIP Care Plus",
  "AmeriHealth Caritas VIP Care Plus (Michigan)",
  "AmeriHealth Delaware",
  "AmeriHealth HMO New Jersey and Delaware",
  "AmeriHealth Mercy Health Plan",
  "AmeriHealth Non-Health Maintenance Organization (Preferred Provider Organization) Delaware",
  "AmeriHealth Non-Health Maintenance Organization (Preferred Provider Organization) New Jersey",
  "AmeriHealth Non-HMO (PPO) Delaware",
  "AmeriHealth Non-HMO (PPO) New Jersey",
  "Ameriprise Auto and Home Insurance",
  "Amerisafe Risk Services Incorporated",
  "Amerisure Insurance",
  "Ameritas",
  "Ameritas Dental First Reliance Standard Life",
  "Ameritas Group - Standard Insurance",
  "Ameritas Life Insurance Corporation",
  "AmFirst Insurance",
  "AmFirst Insurance Company",
  "AMG Independent Practice Association (Ava Medical Group)",
  "AmGUARD Insurance Company - Berkshire Hathaway GUARD Insurance Companies Doing Business As",
  "AmGuard Insurance Company Doing Business As (DBA) Guard",
  "AmGuard Insurance Company doing business as Guard",
  "AmGuard Insurance Company Guard DBA",
  "Amica Mutual Insurance Company",
  "Amida Care",
  "Amidicare",
  "Amplifon America's",
  "Amplifon Americas",
  "AmTrust North America",
  "AMVI Medical Group",
  "Anaco",
  "Anaheim Memorial Independent Practice Association (MHCAN)",
  "ANAIC Cibus",
  "Anatomy",
  "Anchor (ClaimsBridge)",
  "Anchor Benefit Consulting",
  "Anchor Benefit Consulting Inc.",
  "Anchor Benefit Consulting Incorporated",
  "Anchor Claims Management",
  "Ancillary Benefit Systems Arizona",
  "Ancillary Care Services",
  "Angel Medical Group",
  "Angeles IPA",
  "Angelo Brothers Company California",
  "Angle Health",
  "Angle Health Insurance",
  "Angle Insurance Company of Utah",
  "Anheuser-Busch",
  "ANPAC",
  "Antelope Valley Medical Associates (Regal)",
  "Antelope Valley RET",
  "Anthem - Georgia",
  "Anthem - Georgia (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield (Ohio Medicaid)",
  "Anthem Blue Cross Blue Shield Colorado",
  "Anthem Blue Cross Blue Shield Colorado Dental",
  "Anthem Blue Cross Blue Shield Connecticut",
  "Anthem Blue Cross Blue Shield Connecticut (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Connecticut Dental",
  "Anthem Blue Cross Blue Shield Dental",
  "Anthem Blue Cross Blue Shield Indiana",
  "Anthem Blue Cross Blue Shield Indiana (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Indiana Dental",
  "Anthem Blue Cross Blue Shield Kentucky",
  "Anthem Blue Cross Blue Shield Kentucky (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Kentucky Dental",
  "Anthem Blue Cross Blue Shield Maine",
  "Anthem Blue Cross Blue Shield Maine (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Maine Dental",
  "Anthem Blue Cross Blue Shield Missouri",
  "Anthem Blue Cross Blue Shield Missouri (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Missouri Dental",
  "Anthem Blue Cross Blue Shield Nevada",
  "Anthem Blue Cross Blue Shield Nevada (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Nevada Dental",
  "Anthem Blue Cross Blue Shield New Hampshire",
  "Anthem Blue Cross Blue Shield New Hampshire (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield New Hampshire Dental",
  "Anthem Blue Cross Blue Shield of California",
  "Anthem Blue Cross Blue Shield of Georgia",
  "Anthem Blue Cross Blue Shield of New York",
  "Anthem Blue Cross Blue Shield of Wisconsin (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Ohio",
  "Anthem Blue Cross Blue Shield Ohio (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Ohio Dental",
  "Anthem Blue Cross Blue Shield Virginia",
  "Anthem Blue Cross Blue Shield Virginia (Medicaid Reclamation)",
  "Anthem Blue Cross Blue Shield Virginia Dental",
  "Anthem Blue Cross Blue Shield Wisconsin",
  "Anthem Blue Cross Blue Shield Wisconsin Dental",
  "Anthem Blue Cross California",
  "Anthem Blue Cross California Dental",
  "Anthem Blue Cross of New York Dental",
  "Anthem BlueCross BlueShield Kentucky",
  "Anthem Dental",
  "Anthem Georgia Dental",
  "Anthem HealthKeepers",
  "Anthem Maine Health",
  "Anthem MaineHealth",
  "Anthem Medicaid Nevada",
  "Anthem Medicaid Reclamation Electronic Remittance Advice",
  "Anthem Medicaid Reclamation ERA",
  "Anthem-Georgia Dental",
  "Antidote Health Plan",
  "APAC (Pinnacle Health Resources)",
  "Apex Benefit Services",
  "Apex Health",
  "Apipa (Arizona Physicians IPA) - Claims Only",
  "Apipa (Arizona Physicians IPA) - Pre Determinations Only",
  "ApolloCare Partners of Nevada",
  "Apostrophe Health",
  "Apperson Print Management",
  "AppleCare Medical Management",
  "Applied Underwriters",
  "Apricus",
  "APS Healthcare Puerto Rico Inc",
  "Aramark",
  "ARC Administrators",
  "Arcadia Healthcare Solutions - Integrated Provider Group",
  "Arcadia Healthcare Solutions - IPG",
  "Arcadia Healthcare Solutions - National Provider Agreement",
  "Arcadia Healthcare Solutions - NPA",
  "Arcadia Methodist Independent Practice Association",
  "Arcadian Development Incorporated",
  "Arcadian Management Services",
  "ArcBest Corporation",
  "Archbold Medical Center",
  "Archcare Senior Life",
  "Archer Daniels Midland Company",
  "Arden Cleeland Doing Business As Avril Agency",
  "Areas USA Incorporated",
  "Argent",
  "Argonaut Insurance Company (Argo)",
  "Argus Dental and Vision",
  "Arise Health Plan",
  "Arizona and 21st Corporation doing business as Berkley East Convalescent Hospital",
  "Arizona Blue",
  "Arizona Blue (Blue Cross Blue Shield Arizona)",
  "Arizona Complete Health",
  "Arizona Complete Health (Complete Care Plan)",
  "Arizona Health Care Cost Containment System (AHCCCS)",
  "Arizona Physicians Independent Practice Association",
  "Arizona Physicians IPA (UHC) Community Plan",
  "Arizona Priority Care Plus",
  "Arizona School Alliance",
  "Arkansas Blue Cross Blue Shield",
  "Arkansas Empower Healthcare Solutions",
  "Arkansas Superior Select",
  "Arkansas Total Care",
  "Armadacare",
  "Arnett Health Plans",
  "Arnot Ogden Medical Center (UCS)",
  "Array Health",
  "ArrowPoint",
  "Arroyo Parkway 76 and Atwater 76",
  "Arroyo Vista Family Health Center",
  "Arta Western",
  "Artex Manufacturing Company",
  "ASA GEHA",
  "Ascension Amita",
  "Ascension Complete",
  "Ascension Living Hope PACE",
  "Ascension Living PACE Michigan",
  "Ascension Living Program of All-inclusive Care for the Elderly Michigan",
  "Ascension Living St Vincent PACE Incorporated",
  "Ascension Living St. Vincent PACE Incorporated",
  "Ascension SmartHealth",
  "Asian American Medical Group",
  "Asian Community Medical Group Incorporated",
  "Asociacion De Maestros(PROSSAM)",
  "Aspire Health Plan",
  "Aspirus Arise Health Plan",
  "Aspirus Health Plan (Medicare Advantage)",
  "Aspirus Medicare Advantage",
  "ASR Health Benefits",
  "ASR Health Benefits (ASR)",
  "ASRM",
  "Asserta Health",
  "Assist Health Group Inc",
  "Associacion de Maestros Puerto Rico",
  "Associated Adminstrators LLC",
  "Associated Dignity Medical Group Professional Corporation",
  "Associated Hispanic Physicians Southern California",
  "Associated Physicians Medical Group Incorporated",
  "Associates for Health Care Incorporated",
  "Assurance Company of America (Commercial Only)",
  "ASSURANT EMPLOYEE BENEFITS",
  "Assurant Employee Benefits (Now Sun Life)",
  "ASSURANT HEALTH",
  "Assurant Health (Now Sun Life)",
  "Assured Benefits Administrators",
  "Astiva Health",
  "Asuris Northwest Health",
  "Athens",
  "Atheria",
  "Atlantic Coast Life Insurance",
  "Atlantic Medical Insurance",
  "Atlantic Mutual Insurance",
  "Atlantis EyeCare",
  "Atlas Life Insurance Company",
  "Atrio Health Plans",
  "Audio Digest Foundation and",
  "AudioNet - National Elevator",
  "AudioNet America",
  "AudioNet National Elevator",
  "AudioNet UAW Ford Retirees GM Employees",
  "AudioNet UAW GM Retirees",
  "AudioNet United Auto Workers General Motors Retirees",
  "AudioNet United Auto Workers General Motors Retirees Chrysler Employees and Retirees",
  "AultCare",
  "Aultra Administrative Group",
  "Aultra Administrative Services",
  "Austin Mutual Insurance",
  "Austin Regional Clinic Employee Benefit Plan",
  "Auto Club Group",
  "Auto Club Group Insurance Company",
  "Auto Club Insurance (ACIA)",
  "Auto Club Insurance Association",
  "Auto Club Property Casualty Insurance Company",
  "Auto Marine Engineering Incorporated",
  "Auto Outlet Incorporated",
  "Auto Owners Insurance Company",
  "Auto Owners Property Owners Insurance Company",
  "Auto-Owners Homeowners Insurance Company",
  "Auto-Owners Insurance Company",
  "Auto-Owners Insurance Southern-Owners Company",
  "Auto-Owners Life Insurance Company",
  "Auto-Owners Property Owners Insurance Company",
  "Auto-Owners Southern-Owners Company",
  "Automated Benefit Services",
  "Automated Group Administration Incorporated",
  "Automated Group Administrators",
  "Automobile Dealers Insurance Company Incorporated",
  "Automotive Machinists Local 289 Health and Welfare Fund",
  "Auxiant",
  "Auxiant - Valenz",
  "Auxilio Salud Plus Inc",
  "Avalon Healthcare Solutions Capital Blue Cross",
  "Avalon Healthcare Solutions North Carolina",
  "Avalon Healthcare Solutions South Carolina",
  "Avalon Healthcare Solutions Vermont",
  "Avalon Independent Practice Association",
  "Avanta Independent Practice Association",
  "Avente Health Solutions",
  "Avera Health Plans",
  "Avesis",
  "Avesis Insurance Incorporated",
  "Avir Incorporated",
  "AvMed",
  "AvMed Incorporated",
  "Axminster Medical Group",
  "Ayers Trucking",
  "AZ Blue",
  "B Smart Health Solutions",
  "B. B. King's Blues Club and Restaurant",
  "BadgerCare",
  "Baker Tanks Incorporated",
  "Bakersfield Family Medical Center",
  "Bakery and Confectionery Union and Industry International Health",
  "Bank of America",
  "Bank Plus Corporation",
  "Bankers Conseco Life Insurance Company",
  "Bankers Fidelity Life Insurance Company",
  "Bankers Life and Casualty",
  "Banner Health",
  "Banner Health (HealthNet Senior)",
  "Banner Health (UnitedHealthcare Medicare Advantage)",
  "Banner Health and Aetna",
  "Banner Health and Aetna Health Insurance Company",
  "Banner Health and Dental",
  "Banner Medicare Advantage Plus",
  "BANNER MEDICARE ADVANTAGE PLUS (PPO)",
  "Banner Medicare Advantage Prime",
  "Banner Plan Administration (Choice Plus and Select 500)",
  "Banner University Family Care (University of Arizona Health Plans)",
  "Baptist Cardiac Program",
  "BariNet (L&W)",
  "Barinet (Laurel and Walnut)",
  "Barnes",
  "Barrett Business Services Incorporated (BBSI)",
  "BART San Francisco Bay Area Rapid Transit",
  "BAS Recycling Incorporated",
  "Basic Plus",
  "Basic Resources Incorporated",
  "Basil Castrovinci Associates",
  "Bass Pro Group LLC",
  "Batla Food Group Incorporated",
  "Bay Area Rapid Transit San Francisco Bay Area Rapid Transit",
  "Bay Bridge Administrators",
  "BayCare Select Health Plans Inc",
  "BayCare Select Health Plans Incorporated",
  "BC HAWAII",
  "BC Michigan Complete",
  "BCBS DC and National Capital Area",
  "BCBS Georgia",
  "BCBS Hawaii - HMSA",
  "BCBS HMO",
  "BCBS Michigan Medicare Plus Blue PPO (KC) - Joint Venture Hospital Laboratory",
  "BCBS Michigan Medicare Plus Blue PPO (KC) - JVHL",
  "BCBS New Jersey",
  "BCBS New York Central Syracuse",
  "BCBS New York Northeastern",
  "BCBS New York Western",
  "BCBS of New York (Excellus)",
  "BCBS Puerto Rico - Medicare Advantage",
  "BCBS South Dakota",
  "BCBS Tennessee",
  "BCBS Tennessee HMO",
  "BCBS Western New York Medicaid/CHP",
  "BCBSIL Community Health Plans",
  "BCBSM Healthy Kids Dental (DentaQuest)",
  "BCG Community Care Plan",
  "Beacon Bay Enterprises Incorporated",
  "Beacon Health Options",
  "Beacon Health Strategies",
  "Beacon Mutual",
  "Beacon of Life",
  "Bealls Incorporated Midwest Employers",
  "Bear Valley Unified School District California",
  "Beaver Medical Group",
  "BEC Enterprises Incorporated",
  "Beeville Independent School District",
  "Behavioral Health Systems",
  "Bell Atlantic",
  "Bell Trucking Company Incorporated",
  "Bella Vista Medical Group",
  "Bellville Independent School District",
  "Bemus Landscape Incorporated",
  "Benavides Independent School District",
  "Benchmark Insurance",
  "BeneBay",
  "Benedent / Benemax",
  "Benefit & Risk Management (BRMS - CA)",
  "Benefit Administrative Services (BAS)",
  "Benefit Administrative Systems",
  "Benefit and Risk Management Services",
  "Benefit Assistance Corporation",
  "Benefit Concepts",
  "Benefit Coordinators Corporation (Pittsburgh PA)",
  "Benefit Health Plan Life",
  "Benefit Inc.",
  "Benefit Management Group Nevada",
  "Benefit Management Inc of KS",
  "Benefit Management Incorporated of Kansas",
  "Benefit Management Services",
  "Benefit Management Systems Incorporated",
  "Benefit Plan Administrators (Roanoke Virginia)",
  "Benefit Plan Administrators - ClaimsBridge",
  "Benefit Plan Administrators - Hylton Payroll",
  "Benefit Plan Administrators Company (Eau Claire Wisconsin)",
  "Benefit Plan Administrators Company (Eau Claire, Wisconsin)",
  "Benefit Plan Administrators Eau Claire Incorporated (UCS)",
  "Benefit Plan Administrators Eau Claire Incorporated (United Contractors and Staff)",
  "Benefit Solutions Inc.",
  "Benefit Systems and Services Incorporated",
  "Benefit Systems and Services Incorporated (BSSI)",
  "Benefit, Inc.",
  "Benefits Management Group",
  "Benefits, Inc.",
  "Benefits, Inc. (Sturm and Associates) Sturm & Associates",
  "BENEFITSMART",
  "BeneSys Incorporated",
  "Benveo (First Health Network)",
  "Benveo (MultiPlan)",
  "Berkley Agribusiness Risk Specialists",
  "Berkley Entertainment",
  "Berkley National Insurance Company",
  "Berkley Net Underwriters LLC",
  "Berkley Regional Insurance Company",
  "Berkley Risk Administrators Company LLC",
  "Berkley Specialty Underwriters",
  "Berkley Valley Convalescent Hospital",
  "Berkshire Hathaway GUARD Insurance Companies",
  "Berkshire Hathaway Homestate Companies (BHHC)",
  "Bernardo Heights Country Club",
  "Berry's Sawmill",
  "Berwind Corporation",
  "Best Doctors Insurance",
  "Best Life and Health Insurance Company",
  "Better Care Incorporated",
  "Better Health Plans - Three Rivers Administrative Services (TRAS)",
  "Beverly Hills Carmel",
  "Beverly Hospital",
  "Beverly Hospital - Imperial Health Holdings",
  "Bienvivir Senior Health Plan",
  "Big 5 Corporation",
  "Big Lots Associates Benefit Plan",
  "Big Spring Independent School District",
  "Bighorn Construction",
  "Bind",
  "Birdville Independent School District",
  "Bituminous Fire and Marine",
  "Bituminous Insurance Company",
  "Black Hawk",
  "Blackhawk",
  "Block Vision Eye Specialists",
  "Block Vision Incorporated",
  "Bloomingdale's",
  "Blue Advantage of Louisiana",
  "Blue Benefit Administrators Massachusetts",
  "Blue Care Family Plan",
  "Blue Care Network (BCBSM MA/BNCA - Medicare Advantage)",
  "Blue Care Network - Non Joint Venture Hospital Laboratories Network",
  "Blue Care Network - Non Joint Venture Hospital Laboratory Network - Joint Venture Hospital Laboratory",
  "Blue Care Network BCN Commercial Labs (JJ) - Joint Venture Hospital Laboratory",
  "Blue Care Network BCN Commercial Labs (JJ) - JVHL",
  "Blue Care Network JVHL Network (J9) - Joint Venture Hospital Laboratory",
  "Blue Care Network JVHL Network (J9) - JVHL",
  "Blue Chip of Rhode Island",
  "Blue Choice South Carolina",
  "Blue Cross Blue Shield (Anthem) Dental",
  "Blue Cross Blue Shield Alabama",
  "Blue Cross Blue Shield Alabama Institutional",
  "Blue Cross Blue Shield Alabama Professional",
  "Blue Cross Blue Shield Anthem Vivity",
  "Blue Cross Blue Shield Arkansas",
  "Blue Cross Blue Shield Delaware",
  "Blue Cross Blue Shield Delaware Highmark Health Options Incorporated",
  "Blue Cross Blue Shield FEP BlueDental",
  "Blue Cross Blue Shield Illinois",
  "Blue Cross Blue Shield Kansas",
  "Blue Cross Blue Shield Kansas (Health Maintenance Organization Federal Employee Program)",
  "Blue Cross Blue Shield Kansas (Health Maintenance Organization Regular)",
  "Blue Cross Blue Shield Kansas (Health Maintenance Organization Senior Plan)",
  "Blue Cross Blue Shield Kansas (HMO FEP)",
  "Blue Cross Blue Shield Kansas (HMO REGULAR)",
  "Blue Cross Blue Shield Kansas (HMO SENIOR PLAN)",
  "Blue Cross Blue Shield Louisiana",
  "Blue Cross Blue Shield Louisiana Blue Advantage",
  "Blue Cross Blue Shield Massachusetts",
  "Blue Cross Blue Shield Michigan Dental",
  "Blue Cross Blue Shield Michigan Institutional",
  "Blue Cross Blue Shield Michigan Professional",
  "Blue Cross Blue Shield Minnesota",
  "Blue Cross Blue Shield Mississippi",
  "Blue Cross Blue Shield Mississippi State and Teacher Employees'",
  "Blue Cross Blue Shield Montana",
  "Blue Cross Blue Shield Nebraska",
  "Blue Cross Blue Shield New Mexico",
  "Blue Cross Blue Shield North Carolina",
  "Blue Cross Blue Shield North Dakota",
  "Blue Cross Blue Shield of Connecticut- Family Plan",
  "Blue Cross Blue Shield of Florida",
  "Blue Cross Blue Shield of Georgia",
  "Blue Cross Blue Shield of Hawaii",
  "Blue Cross Blue Shield of Indiana (Anthem) Dental",
  "Blue Cross Blue Shield of Indiana (FEP)",
  "Blue Cross Blue Shield of Kansas City",
  "Blue Cross Blue Shield of Kentucky (Anthem) Dental",
  "Blue Cross Blue Shield of Kentucky (FEP)",
  "Blue Cross Blue Shield of Maryland / Carefirst",
  "Blue Cross Blue Shield of Michigan",
  "Blue Cross Blue Shield of Michigan - Medicare Advantage",
  "Blue Cross Blue Shield of Michigan and Blue Care Network",
  "Blue Cross Blue Shield of Michigan Complete",
  "Blue Cross Blue Shield of Minnesota (FEP)",
  "Blue Cross Blue Shield of Minnesota - Commercial and Medicare",
  "Blue Cross Blue Shield of Minnesota Blue Plus Medicaid",
  "Blue Cross Blue Shield of New Hampshire",
  "Blue Cross Blue Shield of New York (Empire)",
  "Blue Cross Blue Shield of Ohio (Anthem) Dental",
  "Blue Cross Blue Shield of Ohio (FEP)",
  "Blue Cross Blue Shield of Rochester Area",
  "Blue Cross Blue Shield of South Carolina Planned Administrators",
  "Blue Cross Blue Shield of Tennessee",
  "Blue Cross Blue Shield of Texas",
  "Blue Cross Blue Shield of Virginia (Trigon)",
  "Blue Cross Blue Shield of Washington DC",
  "Blue Cross Blue Shield of Western New York",
  "Blue Cross Blue Shield Oklahoma",
  "Blue Cross Blue Shield Pennsylvania BlueCard Par Point Services (POS)",
  "Blue Cross Blue Shield Pennsylvania Northeast",
  "Blue Cross Blue Shield Pennsylvania Northwest",
  "Blue Cross Blue Shield Preferred Health Professionals (BCBSKC)",
  "Blue Cross Blue Shield Preferred Health Professionals (Blue Cross Blue Shield Kansas City)",
  "Blue Cross Blue Shield Puerto Rico (Triple-S Salud)",
  "Blue Cross Blue Shield Rhode Island",
  "Blue Cross Blue Shield South Carolina",
  "Blue Cross Blue Shield South Carolina Federal Employee Program",
  "Blue Cross Blue Shield South Carolina Medicare Blue",
  "Blue Cross Blue Shield South Carolina State Health Plan",
  "Blue Cross Blue Shield State and School Employees",
  "Blue Cross Blue Shield Tennessee (Chattanooga HMO Plans)",
  "Blue Cross Blue Shield Texas Medicaid STAR Children's Health Insurance Program",
  "Blue Cross Blue Shield Texas Medicaid STAR CHIP",
  "Blue Cross Blue Shield Texas Medicaid State of Texas Access Reform Children's Health Insurance Program",
  "Blue Cross Blue Shield Vermont",
  "Blue Cross Blue Shield West Virginia",
  "Blue Cross Blue Shield Wyoming",
  "Blue Cross Community Centennial",
  "Blue Cross Community Health Plans",
  "Blue Cross Community Options",
  "Blue Cross Complete (KP) - Joint Venture Hospital Laboratory",
  "Blue Cross Complete (KP) - JVHL",
  "Blue Cross Idaho",
  "Blue Cross Idaho (True Blue)",
  "Blue Cross Idaho Health Services Incorporated",
  "Blue Cross Illinois Medicare Advantage",
  "Blue Cross Medicare Advantage",
  "Blue Cross Montana Medicare Advantage",
  "Blue Cross ND (North Dakota Dental Service)",
  "Blue Cross Nebraska",
  "Blue Cross New Mexico Medicare Advantage",
  "Blue Cross of Idaho Medicare Advantage",
  "Blue Cross Oklahoma Medicare Advantage",
  "Blue Cross Texas Medicare Advantage",
  "Blue Cross United States Virgin Islands",
  "Blue Medicare Advantage",
  "Blue Ridge Independence at Home PACE",
  "Blue Ridge Independence at Home Program of All-Inclusive Care for the Elderly",
  "Blue Shield California Promise Health Plan",
  "Blue Shield Nebraska",
  "Blue Shield Nebraska Medicare Advantage Plan",
  "Blue Shield of California",
  "Blue Shield of California - Federal",
  "Blue Shield of Idaho (Regence)",
  "Blue Shield of Pennsylvania",
  "Blue Shield of Pennsylvania - Dental Plus",
  "Blue Shield Washington - Regence",
  "BlueChoice HealthPlan",
  "BlueChoice HealthPlan Medicaid",
  "BlueChoice HealthPlan of South Carolina",
  "BlueCross BlueShield of Puerto Rico (Triple-S Salud) - Commercial and Medicaid",
  "BlueCross BlueShield of South Carolina Federal Employee Program",
  "BlueCross BlueShield of Tennessee (Chattanooga HMO Plans)",
  "BlueCross BlueShield State Employees Health Plan",
  "BlueRide Non-Emergency Transportation",
  "BMW Manufacturing Corporation",
  "BMW North America",
  "Board Ford Incorporated",
  "Bobrick Washroom",
  "Boilermakers National Health and Welfare",
  "Boise Cascade Company",
  "Bollinger Incorporated",
  "Boncura Health Solutions",
  "Boomy Health",
  "Boon Chapman Benefit Administrators",
  "Boon-Chapman",
  "Boon-Chapman Benefit Administrators",
  "Boston Medical Center Healthnet",
  "Boston Medical Center HealthNet Plan",
  "Boston University Dental Health Plan",
  "Boulder Administration Services",
  "Boulder Community Hospital",
  "Bowsmith Incorporated",
  "BPS First Health",
  "Brackett Independent School District",
  "Brady Independent School District",
  "Brain and Spine Network",
  "Brake Parts Supply and Distribution",
  "Brand New Day (Fee-For-Service)",
  "Braven Health",
  "Bravo Health",
  "Breckenridge Independent School District",
  "BreckPoint",
  "Bremco Construction",
  "BrickStreet Insurance",
  "BridgeSpan",
  "BridgeSpan Health",
  "Bridgeview",
  "Bridgeway Health Solutions",
  "Bridgeway Health Solutions of Arizona",
  "Bright Healthcare",
  "Brintnall's Incorporated",
  "Brion Corporation",
  "Bristol West",
  "Britcay",
  "Broadspire",
  "Brokerage Concepts",
  "Brokers National",
  "Brooks County Independent School District",
  "Brookshire Independent Practice Association",
  "Brotherhood Mutual Insurance",
  "Broward County Heart Screening Program",
  "BROWARD HEALTH SOUTH FLORIDA COMMUNITY CARE NETWORK NBHD",
  "Brown & Toland Health Services",
  "Brown & Toland Sutter",
  "Brown and Toland Health Services",
  "Brown and Toland Medical Group",
  "Brown and Toland Sutter Select",
  "Brownfield Independent School District",
  "Brownsville Independent School District",
  "Brownyard Group Incorporated (Arch Insurance)",
  "Brunswick Corporation",
  "Bryan Independent School",
  "BSI Companies",
  "Buckeye Health Plan",
  "Buckeye Medicaid Ohio",
  "Buckeye Ohio Medicaid",
  "Buffets Incorporated Country Buffet",
  "Buffets Incorporated Fire Mountain",
  "Buffets Incorporated Granny's Buffet",
  "Buffets Incorporated Hometown Buffet",
  "Buffets Incorporated Old Country Buffet",
  "Buffets Incorporated Ryan's",
  "Builders Group of Minnesota",
  "Builders Supply Palm Springs",
  "Bunch and Associates",
  "Bureau of Prisons",
  "Burleson County Alternative School",
  "Burleson-Milam Cooperative",
  "Burlingame Country Club",
  "Burlington Coat Factory Warehouse",
  "Burrows Incorporated",
  "Burton Way Carmel",
  "Business Administrators & Consultants",
  "Businessmen's Assurance (Nebraska)",
  "Butler Benefit Service Incorporated",
  "Butler Benefit Services Incorporated",
  "Bycor General Contract",
  "Bywater",
  "C and O Employees Hospital Association",
  "C P P Incorporated",
  "C TAP Incorporated",
  "Cacique Incorporated",
  "Cadet Uniform Supply",
  "Caduceus Medical Group (Regal)",
  "Cal Care Independent Practice Association",
  "Caldwell Independent School District",
  "California Care (Humboldt Del Norte)",
  "California Chamber of Commerce",
  "California Clinical Research Emphasis Humboldt Del Norte",
  "California CRE Humboldt Del Norte",
  "California Eye Care New Century Health",
  "California Fair Services Authority",
  "California Hawaii Tech Floors Incorporated",
  "California Health and Wellness",
  "California Home Health And Hospice Medicare California Part A",
  "California Independent Practice Association",
  "California Insurance Guarantee Association (CIGA)",
  "California Kids Care",
  "California Linen Rental Company",
  "California Only Bancroft NeuroHealth",
  "California Pacific Medical Center",
  "California Pacific Physicians Medical Group Incorporated",
  "California Water Service Company",
  "Callahan McCune",
  "CalOptima",
  "CalOptima - OneCare Dental",
  "CalOptima Direct",
  "CalViva",
  "Calvo's SelectCare",
  "Calvos Selectcare",
  "Cambridge Integrated Services",
  "Cameron Manufacturing and Design Incorporated (UCS)",
  "Cameron Manufacturing and Design Incorporated (University of California Santa Barbara)",
  "Campbell Union School District",
  "Cannon Cochran Management Services Inc.",
  "Canon Cochran Management Services Incorporated",
  "Canopy Health",
  "Canyon Independent School District",
  "Cap Management",
  "Cap Management Systems",
  "Capistrano Unified School District (California)",
  "Capital Blue Cross Pennsylvania",
  "Capital District Physicians Health Plan",
  "Capital Health Plan",
  "Capitol Administrators (GTESS)",
  "Capitol Indemnity",
  "Capitol Insurance Companies",
  "CapRock Health Plans",
  "Caps Sig",
  "Captrue Benefits",
  "Cardiovascular Care Providers Incorporated (CVCP)",
  "Care 1st Health Plan Arizona",
  "Care Access Health Plan",
  "Care Advantage",
  "Care Improvement Plus",
  "Care Improvement Plus South Central Insurance Co.",
  "Care Management Company",
  "Care N Care",
  "Care N' Care",
  "Care to Care",
  "Care Wisconsin Health Plan",
  "Care1st Health Plan - Medicare Advantage Dental",
  "Care1st Health Plan - PHP Los Angeles & San Bernardino County Dental",
  "Care1st Health Plan Arizona",
  "Care1st Health Plan Arizona (Arizona Health Care Cost Containment System Complete Care)",
  "Care1st Health Plan Arizona (Right Health Benefits Association)",
  "Care1st Health Plan California",
  "CareCentrix",
  "CareCentrix Blue Cross Blue Shield Michigan",
  "CareCentrix Cigna",
  "CareCentrix Florida Blue",
  "CareCentrix Horizon",
  "CareCentrix WellCare",
  "CareCore National",
  "CareCore Oxford Radiology",
  "CareCore West Central New York Radiology",
  "CareCore Western Central New York Radiology",
  "CareFactor",
  "CareFirst Administrators",
  "CareFirst Administrators/NCAS - Fairfax, VA",
  "CareFirst BCBS Medicare Advantage",
  "CareFirst Blue Cross Blue Shield",
  "CareFirst Blue Cross Blue Shield Community Health Plan Maryland",
  "CareFirst Blue Cross Blue Shield Maryland",
  "CareFirst BlueCross BlueShield Community Health Plan Maryland",
  "CareFirst BlueCross BlueShield District of Columbia (NCA)",
  "CareFirst BlueCross BlueShield Medicare Advantage",
  "CareFirst Medicare Advantage",
  "Careington Benefit Solutions",
  "Carelon Aetna Home Health",
  "Carelon Anthem Home Health",
  "Carelon Behavioral Health",
  "Carelon Behavioral Health Maryland",
  "Carelon Behavioral Health MBHP",
  "Carelon Health - Advanced Primary Care",
  "Carelon Health - Palliative Care",
  "Carelon Health of Pennsylvania",
  "Caremore",
  "CareOregon",
  "CarePartners of Connecticut",
  "CarePlus",
  "CarePlus Health Plans",
  "CareSource (Family Health Management)",
  "CareSource (Formerly Family Health Management)",
  "CareSource Arkansas",
  "CareSource Humana",
  "CareSource Indiana",
  "CareSource Indiana Health Indiana Plan (Healthy Indiana Plan)",
  "CareSource Indiana Hoosier Healthwise (HHW)",
  "CareSource Indiana Marketplace",
  "CareSource Indiana Medicare Advantage",
  "CareSource Kentucky",
  "CareSource Kentucky Marketplace",
  "CareSource Medicaid Kentucky",
  "CareSource Medicaid Ohio",
  "CareSource Medicare Advantage Kentucky",
  "CareSource Medicare Advantage Ohio",
  "CareSource Michigan Marketplace",
  "CareSource North Carolina",
  "CareSource of Georgia",
  "CareSource of Michigan Medicaid",
  "CareSource Ohio",
  "CareSource Ohio Community Transition Plan",
  "CareSource Ohio Dual Eligible (MyCare)",
  "CareSource Ohio Marketplace",
  "CareSource Ohio Medicaid Managed Care Entity",
  "CareSource West Virginia",
  "Careworks",
  "CareWorks Consultants Incorporated (CareWorks USA and CCI)",
  "Careworks Consultants Incorporated - Ohio only",
  "Careworks USA - Ohio only",
  "Carhartt",
  "Caring Group Solutions Health",
  "Cariten Healthcare",
  "Cariten Senior Health",
  "Carl Warren Carolina United National Labor",
  "Carl Warren Universal Limousine Transportation",
  "Carolina Behavioral Health Alliance",
  "Carolina Complete Health",
  "Carolina SeniorCare",
  "Carolina Summit Healthcare Incorporated",
  "Carpenters Benefit Plan",
  "Carpenters Combined Funds",
  "Carpenters Health and Welfare Trust Fund of St Louis",
  "Carpenters Health And Welfare Trust Funds",
  "Carriage Motors Incorporated",
  "Carrizo Springs Consolidated Independent School District",
  "Cascade Health Alliance",
  "Casitas Municipal Water District (California)",
  "Castle Group California Incorporated",
  "Catania Hijar Corporation",
  "Caterpillar Inc.",
  "Caterpillar Incorporated",
  "Catholic Diocese of San Diego",
  "Catholic Health System PACE",
  "Catholic Life Insurance",
  "Catholic Mutual Preferred Professional Insurance Company",
  "Catholic Mutual Virginia Surety Company Incorporated",
  "Catholic United Financial",
  "Catilize Health",
  "CBA Blue (CBA Blue Healthcare Trust)",
  "CBA Blue/Blue Benefit Administrators",
  "CBHNP HealthChoices",
  "CC Development Group Incorporated",
  "CCA Health Michigan",
  "CCA Health of California Fee-for-Service",
  "CCI - Ohio only",
  "CCMSI (Cannon Cochran Management Services)",
  "CDO Technologies",
  "CDS Group Health",
  "Cedar Valley Community Health Plan",
  "Cedars Sinai Medical Network Services",
  "Cedars-Sinai Health System",
  "Cedars-Sinai Medical Network Services",
  "CEHAS Plan Administrators",
  "Celtic Insurance",
  "Celticare Health",
  "Cement Masons and Plasterers Health and Welfare Trust",
  "Cement Masons Union Local 502",
  "CenCal Health",
  "Cendant Corporation",
  "Cenpatico Behavioral Health",
  "Centauri Health Solutions (NHI Billing Services Inc)",
  "Centene",
  "Centene Medicare",
  "Centene Ohio Medicaid Managed Care Entity",
  "Centene TPA",
  "Center for Elders' Independence (CEI)",
  "Center Independent Practice Association",
  "Center IPA",
  "Center Point Independent School District",
  "CenterLight Healthcare",
  "Centers Plan for Healthy Living",
  "Centinela Valley Independent Practice Association",
  "Centinela Valley IPA",
  "Centivo",
  "Central Benefit National",
  "Central CA Phys Partners Astrana",
  "Central California Alliance for Health",
  "Central California Health",
  "Central Contra Costa Transit Authority",
  "Central Data Services",
  "Central Health Managed Services Organization",
  "Central Health Management Services Organization",
  "Central Health Medicare Plan",
  "Central Hockey League",
  "Central Pennsylvania Teamsters Health & Welfare Fund",
  "Central Reserve Life",
  "Central Reserve Life Insurance Company",
  "Central Reserve Life Insurance Company (Medicare Supplement)",
  "Central Senior Care",
  "Central States Fund",
  "Central States Health and Life (TeamCare)",
  "Central States Health and Welfare Fund",
  "Central States Indemnity",
  "Central States Trucking Association Comprehensive Care Services",
  "Central Valley Health Plan",
  "Central Valley Medical Group",
  "Central Valley Medical Providers (CVMEDPRO)",
  "Centric Healthcare Services",
  "Centrix",
  "Centrix Benefit Administrators",
  "Centurion LLC",
  "Century Lighting Incorporated",
  "Century PHO",
  "Centurypath",
  "Certified Undercar Parts Incorporated",
  "CG United (Barbados Eastern Carribean)",
  "CGS Administrators - Kentucky",
  "CGS Administrators - Ohio",
  "CGS Health",
  "Chaffey Joint Union High School District (California)",
  "Chaffey Medical Group",
  "Champion Chevrolet",
  "Champion Health Plan",
  "Champion Payer Solutions",
  "CHAMPVA HAC",
  "CHAMPVA Health Administration Center Medicare Crossover",
  "CHAMPVA Spina Bifida Children of Women Vietnam Veterans",
  "Chandler SP Verdes",
  "Chapman Convalescent",
  "Charles Taylor",
  "Charming Shoppes Incorporated",
  "CHCS Services Incorporated",
  "Check Into Cash California",
  "Chesapeake and Ohio Employees Hospital Association",
  "Chesapeake Insurance",
  "Chesterfield Resources",
  "Chesterfield Services Incorporated",
  "Chicago Health Systems",
  "Chicago Regional Council of Carpenters",
  "Children First Medical Group",
  "Children of Women Vietnam Veterans VA Health Administration Center",
  "Children with Special Healthcare Needs (CSHCN)",
  "Children's Community Health Plan Wisconsin",
  "Children's Hospital Colorado",
  "Children's Hospital of Orange County First Aid",
  "Children's Hospital of Orange County Health Alliance",
  "Children's Mercy PCN",
  "Children's Mercy Pediatric Care Network",
  "Children's Mercy Preferred Care Network",
  "Children's Physicians Medical Group",
  "Children's Rehabilitative Services (CRS)",
  "Children's Specialist of San Diego II",
  "Chinatown Service Centre",
  "Chinese Community Health Plan",
  "Chino Auto Parts (A Corporation)",
  "Chiropractic Association of South Dakota",
  "Chiropractic Association of South Dakota Sanford Health Plan",
  "Chiropractic Care of Minnesota Incorporated",
  "Chiropractic Health Plan (CHP)",
  "CHOC Children's Hospital Orange County Health Alliance",
  "Choice Medical Group",
  "Choice Physicians Network - Amada Health",
  "Choice Physician Network",
  "Choice Physicians Network (Nivano Physicians)",
  "Choice Physicians Network Advent Health Medical Corporation",
  "Choice Physicians Network First Choice",
  "Choice Plus (TRW)",
  "Choiceone Independent Practice Association",
  "Chorus Community Health Plan (CCHP)",
  "Christian Brothers High School",
  "Christian Brothers Services",
  "Christian Care Ministries",
  "Christian Health Aid",
  "Christian Ministry Plan",
  "Christiana Care Value Based Reimbursement",
  "Christiana Care Value-Based Reimbursement",
  "Christus Health Medicare Advantage",
  "Christus Health Plan Medicaid",
  "CHRISTUS Health Plan Texas Health Insurance Exchange",
  "CHRISTUS Health Plan Texas HIX",
  "CHS Alta POD by MedPoint",
  "Chubb and Son",
  "Chubb Services",
  "Chula Vista Elementary School District",
  "Church Mutual Insurance Company (Auto Only)",
  "Church Mutual Insurance Company (Liability Only)",
  "Church Mutual Insurance Company (Workers' Compensation Only)",
  "CIGA",
  "Cigna",
  "Cigna (DHMO)",
  "Cigna Arizona Medicare Advantage",
  "Cigna Behavioral Health",
  "Cigna Dental (HMO)",
  "Cigna Dental DPPO",
  "Cigna Dental HMO",
  "Cigna DHMO",
  "Cigna Evernorth",
  "Cigna Health and Life Insurance Company (CHLIC)",
  "CIGNA HealthCare for Seniors - AZ Medicare",
  "Cigna HealthSpring",
  "Cigna HealthSpring (Bravo Health Elder Health)",
  "Cigna International",
  "Cigna Supplemental",
  "CIM Insurance Corporation",
  "Cincinnati Insurance",
  "Cinqcare Connect",
  "Citizens Choice Health Plan (Fee for Service)",
  "Citizens Insurance Company of America",
  "Citrus Valley Health Partners",
  "Citrus Valley Independent Practice Association",
  "Citrus Valley Physicians Group",
  "Citrus World Incorporated",
  "City and County of San Francisco (CCSF)",
  "City of Ames",
  "City of Arlington",
  "City of Ashland",
  "City of Atlanta",
  "City of Banning (California)",
  "City of Barstow (California)",
  "City of Beaverton",
  "City of Belmont (Self Insured)",
  "City of Blythe (California)",
  "City of Brea",
  "City of Campbell",
  "City of Carlsbad",
  "City of Carmel-by-the-Sea",
  "City of Carson",
  "City of Charlotte",
  "City of Chula Vista",
  "City of Colton",
  "City of Coronado",
  "City of Dallas",
  "City of Del Mar",
  "City of Des Moines",
  "City of Desert Hot Springs (California)",
  "City of Edinburg, Texas",
  "City of El Paso",
  "City of Encinitas",
  "City of Escondido",
  "City of Fort Worth (Texas)",
  "City of Fountain Valley (California)",
  "City of Glendale (Arizona)",
  "City of Grand Junction",
  "City of Hillsboro",
  "City of Houston",
  "City of Imperial Beach",
  "City of Imperial Beach (Voucher)",
  "City of Irving",
  "City of Jacksonville",
  "City of La Mesa 11 (California)",
  "City of Laguna Hills (California)",
  "City of Lemon Grove",
  "City of Los Altos",
  "City of Los Angeles",
  "City of Merced",
  "City of Miami Beach (Florida)",
  "City of Minneapolis",
  "City of Monrovia (California)",
  "City of Montebello (California)",
  "City of Murieta (California)",
  "City of National City",
  "City of Oceanside",
  "City of Omaha (Nebraska)",
  "City of Ontario",
  "City of Orange",
  "City of Perris (California)",
  "City of Pompano Beach (Florida)",
  "City of Redding (California)",
  "City of Rialto",
  "City of Rialto California",
  "City of Richardson",
  "City of Salinas",
  "City of San Diego",
  "City of San Jacinto (California)",
  "City of San Mateo (California)",
  "City of Santee",
  "City of Snyder (Texas)",
  "City of Solana Beach",
  "City of South San Francisco",
  "City of St. Paul (Minnesota)",
  "City of Stanton (California)",
  "City of Stockton (California)",
  "City of Topeka (Kansas)",
  "City of Upland (California)",
  "City of Visalia",
  "City of Vista",
  "City of Waco",
  "City of West Covina (California)",
  "City of West Des Moines",
  "City of West Palm Beach (Florida)",
  "City of Westminster (California)",
  "City of Wichita Falls",
  "City of Yorba Linda (California)",
  "City of Yuma",
  "Civil Constructors",
  "Civilian Health and Medical Program of the Department of Veterans Affairs Health Administration Center",
  "Civilian Health and Medical Program of the Department of Veterans Affairs Spina Bifida Children of Women Vietnam Veterans",
  "Clackamas County Mental Health",
  "Claims Administrative Services (CAS)",
  "Claims Choice Administrators LLC",
  "Claims Development Corporation",
  "Claims Management Service Incorporated",
  "ClaimsBridge High Performance Network",
  "ClaimsBridge Payer 3",
  "ClaimsWare Incorporated (ManageMed)",
  "Clarksville Independent School District",
  "Classic Residence by Hyatt",
  "Clausen Enterprises Incorporated",
  "Clean Steel Incorporated",
  "Clear Health Alliance",
  "Clear Spring Health",
  "Clear Spring Health Illinois",
  "Clearwater",
  "Cleugh's Rhubarb Ranch Incorporated",
  "Clever Care Health Plan",
  "Clifton Health Systems DBA Actin Care Groups",
  "Clifton Health Systems Doing Business As Actin Care Groups",
  "Clinica Medica San Miguel",
  "Clinical Specialties Incorporated",
  "Clinicas del Camino Real",
  "Clougherty Packing LLC",
  "Clover Health",
  "CLW Pacific Incorporated",
  "CMFG Life Insurance",
  "CMS",
  "CMS MBI Lookup",
  "CNA Insurance",
  "CNA Insurance (Auto Only)",
  "Co Ordinated Benefits Plan",
  "Co-Operative Benefit Services",
  "Co-ordinated Benefits Plan",
  "Coach USA",
  "Coachella Medical Group",
  "Coachella Valley Physicians",
  "Coachella Valley Water District (California)",
  "Coast Converters",
  "Coastal Administrative Services (CAS)",
  "Coastal Care Services",
  "Coastal Community Physician Network (CCPN) (Regal)",
  "Coastal Third Party Administrator Incorporated",
  "Coastal TPA Incorporated",
  "CoastalCare",
  "Coca Cola Enterprises Incorporated",
  "Coca-Cola Enterprises Incorporated",
  "Coeur Plan Services",
  "Cofinity - Group Resources",
  "Collective Health Administrators",
  "Collin County",
  "Colonial Healthcare",
  "Colonial Life",
  "Colonial Medical",
  "Colonial Medical Eastern Carribean",
  "Colonial Penn Life",
  "Colorado Access",
  "Colorado Casualty",
  "Colorado Choice Health Plans",
  "Colorado Community Health Alliance",
  "Colorado Contractors Program",
  "Colorado Department of Healthcare Policy & Financing",
  "Colorado Grande Casino",
  "Colorado Health Insurance Cooperative",
  "Colorado Healthcare Association Safety National Casualty Corporation",
  "Colorado Medicaid",
  "Colorado Medical Assistance Program",
  "Colorado Prime Corporation",
  "Columbia Sussex Corporation",
  "Columbine Health Plan",
  "Columbine Health Systems",
  "Combined Insurance Company",
  "Combined Sterling",
  "Comfort Systems USA",
  "Commercial Travelers",
  "Common Ground Health Cooperative",
  "Commonwealth Care Alliance (CCA)",
  "Commonwealth Care Alliance of Michigan (Formerly Reliance Health)",
  "Commonwealth Energy Corporation",
  "Commonwealth of Massachusetts - GIC",
  "CommuniCare Advantage",
  "Community Behavioral Health",
  "Community Behavioral Health Network of Pennsylvania HealthChoices",
  "Community Care Alliance of Illinois",
  "Community Care Associates",
  "Community Care Behavioral Health Organization",
  "Community Care Collaborative",
  "Community Care Health Plan of Kansas",
  "Community Care Incorporated (Wisconsin)",
  "Community Care Incorporated Family Care (Wisconsin)",
  "Community Care Independent Physician Association",
  "Community Care Independent Practice Association",
  "Community Care IPA",
  "Community Care Managed Health Care Plans Oklahoma",
  "Community Care Of Oklahoma",
  "Community Care Plan",
  "Community Care Plan (Broward Health Physician Practice Utilization Committee)",
  "Community Care Plan (Broward Health Preferred Provider Universal Care)",
  "Community Care Plan (Commercial)",
  "Community Care Plan (Florida Healthy Kids)",
  "Community Care Plan (Medicaid)",
  "Community Care Plan (Palm Beach Health District)",
  "Community Development Commission (California)",
  "Community Eye Care",
  "Community Family Care",
  "Community First Health Plans",
  "Community Health Alliance",
  "Community Health Alliance Tennessee",
  "Community Health Center Network",
  "Community Health Choice",
  "Community Health Choice (Marketplace)",
  "Community Health Choice (Medicaid Dual Special Needs Plan)",
  "Community Health Choice Texas HIM",
  "Community Health Group",
  "Community Health Network",
  "Community Health Plan - HMO Dental & PPO Dental",
  "Community Health Plan - PPO Dental & PPO Family Dental",
  "Community Health Plan of Washington",
  "Community Health Systems Alta Pioneer by MedPoint",
  "Community HealthFirst Medicare Advantage",
  "Community Medical Group of the West Valley (Regal)",
  "Community Options",
  "Community Preferred Healthcare",
  "CommunityConnect HealthPlan",
  "Companion Life",
  "Companion Life Insurance Company",
  "Companion Life Insurance Company of California (LOB CLIC)",
  "Companion Property and Casualty Insurance Company",
  "Compare (Wisconsin BadgerCare Only)",
  "Compass Group USA Incorporated",
  "Compass Health Administrators",
  "Compbenefits",
  "Compiq Solutions",
  "Complementary Healthcare Plan",
  "Complete Senior Care",
  "Comprehensive Care Management",
  "Comprehensive Care Service (CCSTPA)",
  "ComPsych",
  "CompuSys of Colorado",
  "CompWest",
  "Con Way Incorporated",
  "Con-way Incorporated",
  "Concentrix Insurance Solutions",
  "Concordia Care Incorporated",
  "Conifer Health Solutions",
  "ConnectiCare",
  "ConnectiCare Medicare",
  "Connecticut Behavioral Health Partnership",
  "Connecticut Carpenters Health Fund",
  "Connecticut Carpenters Health Plan",
  "Connecticut Department of Social Services",
  "Connecticut General (CIGNA)",
  "Connecticut General Medical Claims",
  "Connecticut Medical Assistance Program",
  "Connex TCT LLC",
  "Consociate Group",
  "Consociate Group (Decatur IL)",
  "Consociate Group (Decatur)",
  "Consociate Health",
  "Consolidated Associates Railroad",
  "Consolidated Health Plans",
  "Consumers Choice Health South Carolina",
  "Consumers' Choice Health SC",
  "Container Graphics Corporation",
  "Contech Construction Products",
  "Contessa Health",
  "Contessa Health Security Health Plan",
  "Contigo Health",
  "Continental Airlines",
  "Continental Benefits",
  "Continental Dental",
  "Continental General Insurance Company",
  "Continental General Insurance Company Medicare Supplement",
  "Continental Maintenance Industries",
  "Continental Western Insurance Company (CWG)",
  "Continuum Health Solutions LLC",
  "Continuum Health Solutions LLC - Worker Compensation",
  "Contra Costa Behavioral Health Plan",
  "Contra Costa County Schools Insurance Group (CCCSIG)",
  "Contra Costa Health Plan",
  "Convergys Corporation",
  "Cook and Solis Construction",
  "Cook Children's Health Plan",
  "Cook Children's Health Plan STAR",
  "Cook Children's Star Plan",
  "Cook Group Health Plan",
  "Cook Group Solutions",
  "Cook Medical Group",
  "Cooperative Benefit Administrators Blue",
  "Coordinated Care",
  "CopperPoint Mutual Insurance Company",
  "Core Benefits Multimatic Tennessee LLC",
  "Core Management Resources General Partnership",
  "Core Management Resources GP",
  "CoreCivic",
  "CoreCivic (formerly Corrections Corporation of America)",
  "CoreSource",
  "CoreSource (FMH)",
  "CoreSource (Free-standing Medical Hospital)",
  "CoreSource (Little Rock)",
  "CoreSource (NC & IN)",
  "CoreSource - Internal",
  "CoreSource Detroit",
  "CoreSource Little Rock",
  "Coresource of Ohio",
  "Corinthian Colleges",
  "Cornerstone Hospice and Palliative Care, Inc.",
  "Cornerstone Preferred Resources",
  "Corporate Benefit Services of America (CBSA)",
  "Corporate Benefits Service, Inc (North Carolina)",
  "Corporate Plan Management Incorporated",
  "CorrectCare (Georgia Correctional Healthcare Adult Health)",
  "CorrectCare (Louisiana Prisons and Parish Jails)",
  "CorrectCare Integrated Health (California Prison HealthCare Services)",
  "CorrectCare Integrated Health (Non-Louisiana Jails)",
  "Correctional Health Partners",
  "Correctional Management Services",
  "Corrections Corporation of America",
  "Corrections Corporation of America (CCA)",
  "Cost Plus Wellness",
  "Cottingham and Butler Claims Services Incorporated",
  "Cotulla Independent School District",
  "Country Casualty Insurance Company",
  "Country Insurance Modern Services Casualty Insurance Company",
  "Country Insurance Mountain States Insurance",
  "Country Insurance Mutual Service Insurance Preferred Insurance Company",
  "Country Life Insurance Company",
  "Country Mutual Insurance Company",
  "Country Preferred Insurance Company",
  "Country Villa Health Services Skilled Nursing Care Center",
  "Country Villa Oxnard Health",
  "County Motor Parts Company Incorporated",
  "County of Alameda American International Group",
  "County of Fresno",
  "County of Humboldt (California)",
  "County of Kern",
  "County of Los Angeles (AIMS Santa Clarita)",
  "County of Los Angeles (Tristar Santa Ana)",
  "County of Los Angeles California",
  "County of Marin",
  "County of Sacramento - Emergency Medical Services Fund",
  "County of San Diego",
  "County of Santa Barbara (California)",
  "County of Shasta (California)",
  "County of Sonoma (California)",
  "County of Tulare (California)",
  "County Santa Barbara CSAC (California)",
  "County Santa Barbara Non-CSAC (California)",
  "CountyCare",
  "Courtyard Health Center",
  "Covenant Administrators Incorporated (Atlanta, Georgia)",
  "Covenant Management Systems",
  "Covenant Management Systems Employee Benefit Plan",
  "Coventry Health Care CareLink Medicaid",
  "Coventry Health Care of Florida",
  "Coventry/Denex Dental",
  "CoventryCares - JVHL",
  "COVET",
  "Covet Health",
  "COVID-19 Health Resources and Services Administration Uninsured Testing and Treatment Fund",
  "COVID-19 HRSA Uninsured Testing and Treatment Fund",
  "Cow Creek Band of Umpqua Tribe of Indians (CCBUTI)",
  "Coworx Staffing LLC",
  "Cox Construction Company",
  "Cox Health Plan",
  "CPE Professional Employer Organization Incorporated Doing Business As California",
  "CPR Share Plans",
  "CPS Security Solutions",
  "Cr and R",
  "Craftsman Office Furniture Incorporated",
  "CREATE",
  "Create Health Plans",
  "Creative Benefits Incorporated",
  "Crescent Health Solutions",
  "Crestbrook Insurance Company",
  "Crossway HealthShare",
  "Crown City Medical Group",
  "Crown City Medical Group (CCMG)",
  "Crum & Forster Indemnity Company",
  "Crum and Forster Indemnity Company",
  "Crystal City Independent School District",
  "Crystal Run Health Plans",
  "CSI Life Insurance Company",
  "CTL Environmental Services",
  "Cucamonga School District (California)",
  "Culinary Health Fund",
  "Culinary Health Fund UNITE HERE Health",
  "CuraeChoice",
  "Curative",
  "Custom Design Benefits",
  "CustomCare (Prudential)",
  "CVS Accountable Care",
  "CVS Caremark Minute Clinic",
  "CWI Benefits, Inc.",
  "Cypress Ancillary Benefits",
  "Cypress Benefit Administrators",
  "Cypress Insurance Company (Member BHHC)",
  "Dahls Foods",
  "DaimlerChrysler Corporation",
  "Dakota Fire",
  "Dalhart Independent School District",
  "Dallas County Community College District",
  "Dallas Independent School District",
  "Dameron Hospital Association",
  "Dan's Landscape Services Incorporated",
  "Danaher Corporation",
  "Dantel Incorporated",
  "Darigold",
  "Davies(Alternative Service Concepts LLC)",
  "Davis Mechanical Systems",
  "Davis Vision",
  "Daylight Transport",
  "DBA League Medical Concepts",
  "DC Risk Solutions",
  "DCHP - Texas Medicaid",
  "De Bartolos Incorporated",
  "Deaconess Health System",
  "Dean Health Plan",
  "Dean Health Plans",
  "Dearborn National",
  "DeCare Dental Health Insurance",
  "DeCare FEP Dental",
  "Decent",
  "Decent Health",
  "Definity Health",
  "Del Taco LLC",
  "Del Valle Independent School District",
  "Delaware First Health",
  "Dell Children's Health Plan",
  "Delos",
  "Delta Dental (Individual Plans)",
  "Delta Dental (Maryland, Pennsylvania)",
  "Delta Dental - DDIC",
  "Delta Dental Arizona",
  "Delta Dental Arkansas",
  "Delta Dental California",
  "Delta Dental Colorado",
  "Delta Dental Federal Employees Dental Program",
  "Delta Dental Illinois",
  "Delta Dental Indiana",
  "Delta Dental Michigan",
  "Delta Dental New Mexico",
  "Delta Dental New York",
  "Delta Dental North Carolina",
  "Delta Dental of Alabama",
  "Delta Dental of Alaska",
  "Delta Dental of Colorado (Individual)",
  "Delta Dental of Connecticut",
  "Delta Dental of Connecticut (Individual)",
  "Delta Dental of Delaware",
  "Delta Dental of Delaware - Only ERA",
  "Delta Dental of District of Columbia",
  "Delta Dental of District of Columbia (D.C.)",
  "Delta Dental of District of Columbia (D.C.) - Only ERA",
  "Delta Dental of Florida",
  "Delta Dental of Georgia",
  "Delta Dental of Idaho",
  "Delta Dental of Illinois (Group Plans)",
  "Delta Dental of Illinois (Individual)",
  "Delta Dental of Iowa",
  "Delta Dental of Iowa - Dental Wellness Plan",
  "Delta Dental of Iowa - Dental Wellness Plan (DWP)",
  "Delta Dental of Kansas",
  "Delta Dental of Kentucky",
  "Delta Dental of Louisiana",
  "Delta Dental of Maine",
  "Delta Dental of Maryland",
  "Delta Dental of Massachusetts",
  "Delta Dental of Minnesota",
  "Delta Dental of Minnesota - Only ERA",
  "Delta Dental of Mississippi",
  "Delta Dental of Missouri",
  "Delta Dental of Montana",
  "Delta Dental of Nebraska",
  "Delta Dental of Nebraska - Only ERA",
  "Delta Dental of Nevada",
  "Delta Dental of New Hampshire",
  "Delta Dental of New Jersey",
  "Delta Dental of New Jersey (Individual)",
  "Delta Dental of New Mexico - Only ERA",
  "Delta Dental of North Dakota",
  "Delta Dental of Northeast",
  "Delta Dental of Northeast (Maine, New Hampshire, Vermont)",
  "Delta Dental of Ohio",
  "Delta Dental of Ohio - Only ERA",
  "Delta Dental of Oklahoma",
  "Delta Dental of Oregon",
  "Delta Dental of Pennsylvania",
  "Delta Dental of Puerto Rico",
  "Delta Dental of Puerto Rico - Only ERA",
  "Delta Dental of Rhode Island",
  "Delta Dental of South Carolina",
  "Delta Dental of South Dakota",
  "Delta Dental of Tennessee",
  "Delta Dental of Tennessee - Only ERA",
  "Delta Dental of Texas",
  "Delta Dental of Utah",
  "Delta Dental of Vermont",
  "Delta Dental of Virginia",
  "Delta Dental of Virginia (Individual)",
  "Delta Dental of Washington",
  "Delta Dental of West Virginia",
  "Delta Dental of West Virginia - Only ERA",
  "Delta Dental of Wisconsin",
  "Delta Dental of Wisconsin (Individual)",
  "Delta Dental of Wyoming",
  "Delta Dental Plan of Arkansas",
  "Delta Health",
  "Delta Health Systems",
  "DeltaCare USA (claims)",
  "DeltaCare USA / Pacific Mutual Insurance - Encounters",
  "DeltaCare USA / PMI - Claims",
  "DeltaCare USA / PMI - Encounters",
  "DeltaCare USA / Private Medical Insurance - Claims",
  "Demko William M (An Individual)",
  "Denfran Systems Incorporated",
  "Dental Benefits Providers",
  "Dental Blue Select",
  "Dental Blue Select (BCBSNC)",
  "Dental Care Plus",
  "Dental Care Plus (DentaQuest)",
  "Dental Health and Wellness - Envolve Dental",
  "Dentalcare Plus - Group",
  "Dentalcare Plus - Individual",
  "DentaQuest",
  "Denti-Cal",
  "Dentical",
  "Dentist Direct",
  "Denver City Independent School District",
  "Denver Health and Hospital Authority",
  "Denver Health Medical Plan",
  "Denver Health Medical Plan Incorporated (Medicare Choice)",
  "Denver Public Schools",
  "Department of Homeland Security Immigration Enforcement",
  "Department of Labor and Industry (Washington)",
  "Department of Labor Black Lung (77104)",
  "Department of Water and Power of the City of Los Angeles (LADWP)",
  "Depositors Insurance Company",
  "Deseret Mutual Benefit Administrators",
  "Deseret Mutual Benefit Administrators (DMBA)",
  "Desert Hospital District",
  "Desert Medical Group",
  "Desert Oasis Healthcare (DOHC) (Regal)",
  "Desert Princess",
  "Desert Valley Medical Group",
  "Designs by Mark",
  "DeSoto Independent School District",
  "Detego Health",
  "Devoted Health",
  "DEW Management Services Incorporated",
  "DH Cook (Northwell)",
  "DH Cook Associates",
  "DHMN - Preferrred IPA Hospital Risk",
  "DHMN Santa Cruz",
  "Diablo Hills Golf Association",
  "Diamond Bar Medical Group",
  "Diamond Farming Company",
  "Diamond W Floor Covering Incorporated",
  "Dignity Global",
  "Dignity Health Care Los Angeles",
  "Dignity Health Management Services Organization",
  "Dignity Health Management Services Organization (DHSMO)",
  "Dignity Health Medical Group (Inland Empire)",
  "Dignity Health Medical Network (Santa Cruz)",
  "Dignity Health Sacramento Hospital",
  "Dignity Health Sacramento Hospital Select Health Option",
  "Dignity Health Woodland Clinic",
  "Dignity HealthCare Los Angeles",
  "Dilley Independent School District",
  "Dimension Benefit Management",
  "Dinuba Lumber Company (A Corporation)",
  "Direct Care Administrators",
  "DirectCare",
  "Directors Guild of America",
  "Directory Distributing Association",
  "Discount Tire",
  "Discover Re (Burger King)",
  "Discover Risk Evaluation (Burger King)",
  "Discovery Hy Vee",
  "Disneyland Resorts (BUNCH)",
  "District No. 9 of International Association of Machinists and Aerospace Workers Welfare Trust",
  "District of Columbia Risk Solutions",
  "Diversified Group Administrators",
  "DME Jurisdiction C",
  "Doctors Healthcare Plans",
  "Dolton Medical Group",
  "Doral Dental of Wisconsin",
  "Douglas County",
  "Downey Select Independent Practice Association",
  "DPC Core Incorporated",
  "DPSC Inc.",
  "Driscoll Children's Health Plan",
  "Dufour Incorporated",
  "Duly Health and Care",
  "Dumas Independent School District",
  "Duncanville Independent School District",
  "Dunn and Associates Benefits Administrators",
  "Dunn Edwards Corporation",
  "Dunn-Edwards Corporation",
  "Dupree Incorporated",
  "Durango Coffee Company",
  "Dustrol",
  "Dy-Dee Services Pasadena Incorporated",
  "Dynamex Incorporated",
  "E. B. Manning and Son Incorporated",
  "E. H. Summit Incorporated",
  "Eagle Claims",
  "Eagle Creek Medical Plaza",
  "Eagle Mountain-Saginaw Independent School District",
  "Eagle Pass Independent School District",
  "Early Intervention Central Billing",
  "East Boston Neighborhood Program of All-Inclusive Care for the Elderly",
  "East Carolina Behavioral Health",
  "East San Gabriel Valley ROP (California)",
  "East West Administrators",
  "Eastern Alliance",
  "Eastern Dentists Insurance Company",
  "Eastern Iowa Community Healthcare (EICH)",
  "Eastern Life and Health",
  "Eastern Maine Healthcare Systems (EMHS) Employee Health Plan",
  "Eastern Municipal Water District (California)",
  "EastGUARD Insurance Company - Berkshire Hathaway GUARD Insurance Companies Doing Business As",
  "Eastland Medical Group",
  "Eastland Medical Group Independent Practice Association (Regal)",
  "Eastman Kodak Company",
  "Easy Care Management Services Organization LLC",
  "Easy Choice Health Plan California",
  "EasyChoice Health Plan - Dental",
  "Eaton Benefits Ohio",
  "Eberle Vivian",
  "Ebix Health Administration Exchange (EHAE)",
  "EBSO, Inc.",
  "Echo Pacific Development",
  "Ecology Auto Wrecking",
  "Edenbridge of DC",
  "Edenbridge PACE  of West Baltimore",
  "Edinburg Consolidated Independent School District",
  "Edinger Medical Group",
  "Edison Revolution",
  "Educators Mutual (EMIA)",
  "Edward Claims Administration (Texas)",
  "El Camino Health Alliance",
  "El Camino Health Medical Network",
  "El Macero Country Club",
  "El Paso Community College (Texas Jurisdiction)",
  "El Paso First Health Plan HCO Healthcare Options",
  "El Paso First Health Plan Healthcare Options",
  "El Paso First Health Plans CHIP",
  "El Paso First Health Plans Premier Plan Star Medicaid HMO",
  "El Paso Health Advantage Dual SNP (HMO D-SNP)",
  "El Paso Health Advantage Dual Special Needs Plan (Health Maintenance Organization Dual Special Needs Plan)",
  "El Paso Water Utilities Texas Jurisdiction",
  "El Paso Water Utility Texas Jurisdiction",
  "El Pollo Loco",
  "El Proyecto de Barrio",
  "El Proyecto del Barrio",
  "ELC Electric Incorporated",
  "Elderhaus Inc.",
  "Elderhaus, Inc.",
  "ElderPlan",
  "Elderserve Health",
  "Elderwood Health",
  "Electric Welfare Trust Fund",
  "Electrical Rebuilders Sales Incorporated",
  "Electrical Welfare Trust",
  "Electrical Workers Insurance Fund Local 5800",
  "Element Care Incorporated",
  "Elips Life Insurance Company",
  "Elite Comprehensive",
  "Elite Leather Company",
  "ELMCO LLC",
  "Elmira Savings Bank (UCS)",
  "Emanate Health Independent Practice Association",
  "EmblemHealth",
  "EmblemHealth - Group Health Incorporated",
  "EmblemHealth Plan",
  "EMC Insurance Company Workers' Compensation Only",
  "EMC Property and Casualty Auto Only",
  "EMC Property and Casualty Liability Only",
  "EMC Property and Casualty Workers' Compensation Only",
  "EMC Risk Services",
  "EMCASCO Insurance Company Auto Only",
  "EMCASCO Insurance Company Liability Only",
  "EMCASCO Insurance Company Workers' Compensation Only",
  "EMCO Fluid Systems Incorporated",
  "Emerald Health Network",
  "Emerald Health Network Incorporated",
  "Emergency Medical Services Fund (EMSF)",
  "Emergency Physicians Medical Group",
  "Emergency Room Management Corporation",
  "Emeritus Corporation",
  "EMI - KP Ambulance Claims",
  "EMI Health",
  "EMI KP Ambulance Claims",
  "EmoryCare (Prudential)",
  "Emphesys",
  "EMPI Incorporated",
  "Empire Blue Cross Blue Shield - Anthem Blue Cross Blue Shield New York",
  "Empire Blue Cross Blue Shield - Anthem Blue Cross Blue Shield New York (Medicaid Reclamation)",
  "Empire Dental",
  "Empire Healthcare Independent Practice Association",
  "Empire Healthcare IPA",
  "Empire Physicians Medical Group",
  "Empire Plan (NYSHIP)",
  "Employee Benefit Logistics",
  "Employee Benefit Management Corporation",
  "Employee Benefit Management Services",
  "Employee Benefit Management Services (EBMS)",
  "Employee Benefit Services",
  "Employee Benefit Services Incorporated",
  "Employee Benefit Services Incorporated (EBSI)",
  "Employee Benefit Services South Carolina",
  "Employee Benefit Systems",
  "Employee Benefits Administration and Management Company",
  "Employee Benefits Plan Administrator Incorporated (EBPA)",
  "Employee Health Systems",
  "Employee Plans LLC",
  "Employee Retirement Income Security Act Administrative Services",
  "Employer Coalition on Health - ECOH",
  "Employer Direct Healthcare",
  "Employer Driven Insurance Services (EDIS)",
  "Employer Insurance Group",
  "Employer Insurance Group (EIG)",
  "Employer Plan Services Incorporated (EPSI)",
  "Employers Assurance Company",
  "Employers Claim Services Incorporated City of Naperville",
  "Employers Coalition on Health (ECOH)",
  "Employers Compensation Insurance Company",
  "Employers General Insurance Group",
  "Employers Health Coalition (HealthSCOPE)",
  "Employers Health Cooperative (EHC)",
  "Employers Health Network",
  "Employers Insurance (Bunch)",
  "Employers Mutual Casualty Auto Only",
  "Employers Mutual Casualty Liability Only",
  "Employers Mutual Casualty Workers' Compensation Only",
  "Employers Preferred Insurance Company",
  "Empower Arkansas",
  "EnableComp Commercial",
  "EnableComp Motor Vehicle Accident",
  "EnableComp OOS Medicaid",
  "EnableComp Out of State Medicaid",
  "EnableComp Veterans Administration",
  "EnableComp Workers Compensation",
  "EnableComp Workers Compensation services",
  "Encara",
  "Encore Health Network - The Healthcare Group",
  "Endeavor Health",
  "Engen Enterprises Incorporated",
  "Enhancedcare MD",
  "ENSTAR Natural Gas GP61",
  "Enterprise Group Planning",
  "Entrust",
  "EnviroSource",
  "Envision Radiology LLC",
  "Envolve Benefit Options (Vision)",
  "Envolve Health",
  "Envolve Vision Benefits Puerto Rico",
  "Eon Health",
  "Epic Assistance",
  "Eplica Incorporated",
  "EPRO Paramount",
  "Equicor / Equitable",
  "Equicor Equitable",
  "Equicor Preferred Provider Organization",
  "Equitable (UCCI)",
  "Equitable Financial Life Insurance Company",
  "Equity Hotel and Supply Company",
  "ER Medical Consulting",
  "Ergon Incorporated",
  "Erickson-Hall Construction",
  "Erie Family Life Insurance Company",
  "Ernest Paper Products Incorporated",
  "ES Beveridge and Associates",
  "ESIS (A Risk Management Services Company)",
  "ESIS (Environmental Services and Insurance Solutions)",
  "ESIS (First American Insurance Company)",
  "ESIS Kelly Services",
  "ESIS Lockheed Martin Corporation",
  "Esperanza Independent Practice Association",
  "Esperanza IPA",
  "Esperanza PACE",
  "Essence Healthcare",
  "Essential Health Partners",
  "Essential Health Partners Independent Practice Association",
  "Essential Health Partners Independent Practice Association (IPA)",
  "Esurance Insurance Company",
  "Eternal Health",
  "Evercare",
  "Everence Financial",
  "Everest Reinsurance Company",
  "Evergreen Health Cooperative",
  "Evernorth",
  "EverPointe",
  "Eversana Life Sciences Services",
  "eviCore",
  "Evolent Specialty - Cardiology",
  "Evolent Specialty - Oncology",
  "Evolent Specialty - Radiation Oncology",
  "Evolent Specialty - Urology",
  "Evolent Specialty Institutional",
  "Evolution Insurance Company",
  "Evolutions Healthcare Systems",
  "Evry Health",
  "Exceedent LLC",
  "Exceedent, LLC",
  "Excellus Blue Cross Blue Shield New York Central",
  "Excellus Blue Cross Blue Shield New York Rochester Area",
  "Excellus Blue Cross Blue Shield New York Utica Watertown",
  "Excellus BlueCross BlueShield New York",
  "Excellus BlueCross BlueShield New York Central",
  "Exceptional Care Medical Group (ECMG)",
  "ExclusiCare",
  "Exclusive Care - County of Riverside",
  "Exemplar",
  "Exemplar Health Insurance Company (Medicare)",
  "ExxonMobil Corporation",
  "EyeMed",
  "Eyequest",
  "EYLEA4U Commercial Copay and Card Program",
  "Ezell Nursery Supply Incorporated",
  "F&G Guaranty Insurance Company Main Street Program Colorado",
  "Facey Medical Foundation",
  "Facility Masters Incorporated (A Corporation)",
  "Factory 2 U",
  "Fair Price",
  "Fairbanks North Star Borough",
  "Fairbanks North Star Borough School District Plan A",
  "Fairbanks North Star Borough School District Plan B",
  "Fairchild Fasteners",
  "Fairfax County Government",
  "Fairmont Specialty Insurance Company Texas",
  "Fairview Health Services",
  "Falling Colors",
  "Fallon Community Health Plan",
  "Family Care Specialists",
  "Family Choice Medical Group",
  "Family Health Alliance",
  "Family Health and Housing",
  "Family Health Center of Puerto Rico",
  "Family Health Centers of Puerto Rico",
  "Family Health Network",
  "Family Healthcare PACE",
  "Family HealthCare Program of All-Inclusive Care for the Elderly",
  "Family Practice Medical Group",
  "Family Seniors Medical Group",
  "Family Toyota Family Honda",
  "FamilyCare Medicaid Mental Health",
  "Familycare Specialist Medical Group",
  "FAMSA Incorporated",
  "Farm Bureau Health Plans MAPD",
  "Farm Bureau Mutual Insurance Company (Minnesota Only)",
  "Farmers Civic Property and Casualty Company",
  "Farmers Exact Property and Casualty Company",
  "Farmers Fire Insurance Exchange",
  "Farmers Insurance (Auto Only)",
  "Farmers Insurance Commercial (Commercial Only)",
  "Farmers Insurance Exchange (Commercial Only) (Auto Only)",
  "Farmers Insurance Exchange (Workers' Compensation Only)",
  "Farmers Mid Century Insurance Company",
  "Farmers Mid-Century Insurance Company",
  "Farmers Neighborhood Spirit Property and Casualty Company",
  "Farmers Truck Insurance Exchange",
  "Farmland Mutual Insurance Company",
  "Fast Undercar Thousand Oaks",
  "FCCI",
  "FCE Benefit Administrators Incorporated",
  "Feather River Wood and Glass",
  "Federal Employee Program Texas (FEP)",
  "Federated Claims Services Corporation",
  "Federated Department Stores Incorporated",
  "Federated Linen and Uniform",
  "Federated Mutual Insurance Company",
  "Federated Rural Electric (Texas)",
  "Federated Services Insurance Company",
  "FedEx Freight East",
  "FedEx Freight Health Benefit",
  "Felix Manufacturing Company",
  "Fenix Medical Group",
  "Fenyx Health",
  "FEP BlueCross",
  "Ferrari Dan (An Individual)",
  "FFVA Mutual Insurance",
  "Fidelis Care New Jersey",
  "Fidelis Care New York",
  "Fidelis Secure Life",
  "Fidelity Security Life Insurance Company",
  "Fire Department City New York World Trade Center Health Plan",
  "Firefly Health",
  "Firefly Health Plan",
  "Fireman's Fund Insurance Company",
  "Firemen's Insurance Company",
  "First Agency",
  "First Ameritas Life Insurance Corporation of New York",
  "First Ameritas New York",
  "First Auto and Casualty",
  "First Carolina Care",
  "First Choice by Select Health South Carolina",
  "First Choice Health Network",
  "First Choice Health Plans of Connecticut",
  "First Choice MA Plans",
  "First Choice Medical Group",
  "First Choice Medical Group (Meritage)",
  "First Choice Medicare Advantage Plans",
  "First Choice Next",
  "First Choice Next, A Product of Select Health South Carolina, Inc.",
  "First Choice VIP Care (South Carolina Dual-Eligible Special Needs Plan)",
  "First Choice VIP Care (Special Needs Plan) by Select Health of South Carolina, Inc.",
  "First Choice VIP Care Plus South Carolina",
  "First Coast (FCSO) - Florida",
  "First Coast (FCSO) - Puerto Rico",
  "First Commonwealth",
  "First Community Health Plan",
  "First Continental Life And Accident",
  "First Great-West Life and Annuity Insurance Company",
  "First Medical Health Plan Incorporated (IMC)",
  "First Medical Health Plan Incorporated (International Medical Center)",
  "First Medical Network",
  "First Medical Puerto Rico Government Health Plan (VITAL)",
  "First Plan Blue",
  "First Reliance Standard Life - New York",
  "First Reliance Standard Life Insurance Company - New York",
  "First United American Insurance Company",
  "FirstCare",
  "FirstCare Star Medicaid",
  "FirstComp",
  "FirstMedicare Direct",
  "Fiserv Wausau",
  "FKI Industries Incorporated",
  "Flex Compensation",
  "FlexCare",
  "Floresville Independent School District",
  "Florida Blue (Blue Cross Blue Shield of Florida)",
  "Florida Blue Medicare",
  "Florida Combined Life Insurance Company",
  "Florida Community Care",
  "Florida Complete Care",
  "Florida Construction Credit Insurance",
  "Florida Fruit and Vegetable Association",
  "Florida Fruit and Vegetable Association Mutual Insurance",
  "Florida Health Administrators Third Party Administrator The Assistance Fund",
  "Florida Health Administrators Third-Party Administrator The Assistance Fund",
  "Florida Health Care Plans",
  "Florida Health Care Plans (FHCP)",
  "Florida Hospital",
  "Florida Hospital Waterman",
  "Florida Hospital Waterman Employees",
  "Florida Managed Care Organization Primary Health Care/Preferred Provider Organization",
  "Florida Managed Care Organization Primary Healthcare Provider/Public Health Provider",
  "Florida Power and Light (Prudential)",
  "Florida Program of All-Inclusive Care for the Elderly Center",
  "Florida True Health",
  "Flume Health",
  "Flume Health Inc",
  "Flume Health Inc.",
  "Forecast Group L.P.",
  "Foremost",
  "Forest County Potawatomi Insurance Department",
  "Forethought Life Insurance Company",
  "Forge Industrial Staffing",
  "Forney Independent School District",
  "Fort Sam Houston Independent School District",
  "Foundation for Medical Care of Tulare and Kings Counties",
  "Foundation Health",
  "Fountain Valley Independent Practice Association",
  "Fox Everett Inc",
  "Fox Everett, Inc",
  "Fox Everett, Incorporated",
  "Fox Valley Medicine Site 199",
  "Franciscan Alliance",
  "Franciscan Purdue",
  "Franciscan Senior Health and Wellness PACE",
  "Franco Construction",
  "Frankenmuth Mutual",
  "Frates Benefit Administrators",
  "Freedom Blue Medicare Advantage",
  "Freedom Blue Medicare Advantage Institutional",
  "Freedom Blue Medicare Advantage Professional",
  "Freedom Claims Management",
  "Freedom Health Incorporated",
  "Freedom Health Plan",
  "Freedom Life Insurance Company",
  "Freedom Life Insurance Company of America",
  "Freedom Life Insurance of America",
  "Freeman Raymond K",
  "Frenship Independent School District",
  "Fresenius Medical Care",
  "Fresno County Office of Education",
  "Fresno County Self Insurance Group",
  "Fresno PACE",
  "Fresno Program of All-Inclusive Care for the Elderly",
  "Friant and Associates LLC",
  "Friday Health Plan",
  "Friday Health Plans",
  "Fringe Benefit Coordinators",
  "Fringe Benefit Group",
  "Fringe Benefit Group Inc.",
  "Frio County",
  "FrontPath",
  "FSL Admin by KBA",
  "Fulcrum",
  "Fuller Theological Seminary",
  "Fullerton Union High School District (CA)",
  "G L Veneer Company Incorporated",
  "Gab Robbins Incorporated",
  "GAB Robins (for Van Tuyl Companies Only)",
  "Gainesville Independent School District",
  "Gallagher Bassett",
  "Galveston County Indigent Health Care",
  "Garden Grove Unified School District",
  "Garden Regional Hospital and Medical Center Incorporated",
  "Garden State Life Insurance Company",
  "Garner Independent School District",
  "Garrison Mike (An Individual)",
  "Gate Gourmet 836",
  "GateGourmet 836",
  "Gates Corporation DBA Gates Rubber Company",
  "Gates Corporation Doing Business As Gates Rubber Company",
  "Gates O Doherty",
  "Gates O Doherty G and G",
  "Gateway Health Plan",
  "Gateway Health Plan Dental",
  "Gateway Health Plan Medicaid Pennsylvania",
  "Gateway Health Plan Medicare Assured",
  "Gateway Health Plan Medicare Ohio Assured",
  "Gateway Independent Practice Association (Pinnacle Health Resources)",
  "Gateway Learning Corporation",
  "Gateway to Better Health Plan (Medicaid Missouri)",
  "Gateway Trans Incorporated",
  "GBS Group Benefit Services Incorporated",
  "GE Group Life / Administrators / Financial",
  "GEHA",
  "Geisinger Health Plan",
  "Geisinger Health Plan Gold",
  "GemCare",
  "GemCare Health Plan",
  "GemCare Medical Group (Managed Care Systems)",
  "General American Life Insurance Company",
  "General Electric Auto",
  "General Electric Automotive",
  "General Hospital (Humboldt Del Norte)",
  "General Parts International",
  "Generations",
  "Genesee County Health Plan (MB) - Joint Venture Hospital Laboratory",
  "Genesee County Health Plan (MB) - JVHL",
  "Genesis Construction",
  "Genesys-Oconee Detention Center SC",
  "Genex Care for Ohio",
  "Genworth Life Insurance Company",
  "GEO",
  "Georgetown Independent School District",
  "Georgia DCH",
  "Georgia Department of Community Health",
  "Georgia Health Advantage",
  "Georgia Health Advantage Effective January 1, 2020",
  "Georgia Health Partnership",
  "Gettysburg Health Administrators",
  "GHA Orthopedic Providers Inc",
  "GHA Orthopedic Providers, Inc",
  "GHI Group Health Incorporated",
  "GIC (Indemnity Plan)",
  "Gillette Children's Specialty Healthcare",
  "Gilsbar Inc",
  "Glassworkers Health and Welfare",
  "Glendale Adventist Medical Center",
  "Glendale Associates Ltd.",
  "Glendale Elementary School District 40",
  "Glendale Food Services Incorporated",
  "Glendale Memorial Group (Regal)",
  "Glendale Physicians Medical Group (Regal)",
  "Global Benefits Group",
  "Global Care (Nicaraguan American Medical Care International)",
  "Global Care (North American Medical Center, Inc. - NAMCI)",
  "Global Care Incorporated",
  "Global Care Medical Group Independent Practice Association",
  "Global Care Medical Group IPA",
  "Global Excel Management",
  "Global Healthcare",
  "Global Healthcare Alliance",
  "Global Life Insurance Keybank",
  "Global Medical Management International Customer Care",
  "Global One Ventures",
  "Global Repricing Solutions",
  "Global TBSP",
  "Global Women's Health Providers Inc.",
  "GlobalHealth",
  "GlobalHealth Texas",
  "GlobalHealthcare",
  "Globe Life and Accident Insurance Company",
  "Globe Life Insurance Company of New York",
  "Glorida Gates",
  "GMAC Insurance Company Online Incorporated",
  "GMAC Insurance Management Corporation",
  "GMMI, LLC",
  "GMP Employers Retiree Trust",
  "GMR Healthcare",
  "GMS Inc",
  "GMS Inc.",
  "GMS Incorporated",
  "Godley Independent School District",
  "Gold Coast Health Plan",
  "Gold Kidney Health Plan",
  "Gold Kidney of Arizona",
  "Golden Coast Management Services Organization",
  "Golden Coast MSO",
  "Golden Corral Corporation",
  "Golden Eagle",
  "Golden Rule",
  "Golden Rule Insurance Company",
  "Golden State Medical Group",
  "Golden State Medicare Health Plan - Dental",
  "Golden State Supply",
  "Golden Triangle Physician Alliance SelectCare Texas",
  "Golden West Dental",
  "Gomez Jose Luna",
  "Gonzaba Medical Group",
  "Good Samaritan Hospital",
  "Good Samaritan IPA (Coastal Healthcare Management)",
  "Goodrich",
  "Goodwill Industries",
  "Grady Healthcare Incorporated",
  "Graford Independent School District",
  "Grand River Insurance",
  "Grange Mutual Casualty Company",
  "Grange Workers' Compensation",
  "Granite State Health Plan",
  "Graphic Arts Mutual",
  "Grass Valley Ford Lincoln Maine",
  "Gravie",
  "Gravie Administrative Services",
  "Great American Alliance Insurance Company",
  "Great American Assurance Company",
  "Great American Insurance Company",
  "Great American Insurance Company of New York",
  "Great American Life Assurance Company",
  "Great American Life Insurance Company (Medicare Supplement)",
  "Great Central",
  "Great Divide Insurance",
  "Great Southern Life Insurance Company",
  "Great West Healthcare",
  "Greater Covina Medical Group",
  "Greater Los Angeles Healthcare",
  "Greater Newport Physicians",
  "Greater Orange Medical Group",
  "Greater Oregon Behavioral Health",
  "Greater Oregon Behavioral Health Incorporated",
  "Greater San Diego Air Conditioning",
  "Greater San Gabriel Medical Group",
  "Greater San Gabriel Valley Physicians",
  "Greater Valley",
  "Green Diamond Washington",
  "Greene Rad Maloney",
  "Greer Construction Company",
  "Greif Brothers Corporation",
  "Greve Clifford Wengel and Paras",
  "Griffin Produce Incorporated",
  "Grimmway Enterprises Incorporated",
  "Grinnell Reinsurance Company",
  "Grinnell Select",
  "Group Administrators Limited",
  "Group Administrators Ltd",
  "Group and Pension Administrators",
  "Group Benefit Administrators Incorporated",
  "Group Benefit Services (GBS)",
  "Group Benefit Services Incorporated (GBS)",
  "Group Benefits",
  "Group Benefits Louisiana",
  "Group Health Cooperative of Eau Claire",
  "Group Health Cooperative of South Central Wisconsin",
  "Group Health Incorporated Group Health",
  "Group Health Incorporated Health Maintenance Organization",
  "Group Health Plan (GHP)",
  "Group Hospitalization and Medical Services",
  "Group Insurance Service Center Incorporated",
  "Group Management Services Incorporated",
  "Group Marketing Services",
  "Group Pension Administrators (Imagine360)",
  "Group Resources",
  "GroupLink",
  "Grundfos Manufacturing Corporation",
  "Gruver Independent School District",
  "GS Metals",
  "GSE Lining Technology Incorporated",
  "Guarantee Trust Life",
  "Guarantee Trust Life Insurance Company",
  "Guardian",
  "Guardian Dental",
  "GuideOne Elite Insurance",
  "GuideOne Mutual Insurance",
  "Gulf Guaranty",
  "Gulf Quest Renaissance",
  "Gulf South",
  "GWH Cigna (Great West Healthcare)",
  "Gwinnett County Public School",
  "H J Company",
  "H L Heggstad Incorporated",
  "H P Development Incorporated",
  "H P Envirovision Incorporated",
  "H R N Services Incorporated",
  "H&R Block",
  "Hagen Renaker Incorporated",
  "Haight Brown and Bonesteel",
  "Halcyon Behavioral Health",
  "Hamaspik Choice",
  "Hamaspik Choice (Managed Long-Term Care)",
  "Hamaspik Inc. (Medicare Choice)",
  "Hamaspik Inc. (Medicare Select Health Maintenance Organization Dual-Eligible Special Needs Plan)",
  "Hamilton Mutual Auto",
  "Hamilton Mutual Liability",
  "Hamilton Mutual Workers' Compensation",
  "Hannaford",
  "Hanover Insurance Company",
  "Hanover Lloyds Insurance Company",
  "HAP CareSource (JB) - JVHL",
  "HAP CareSource - Joint Venture Hospital Laboratory",
  "HAP CareSource MI Health Link (Medicare-Medicaid Plan)",
  "Haralambos Beverage Company",
  "Harbob South Incorporated",
  "Harbor Health",
  "Harleysville Insurance Company",
  "Harmony Health Plan",
  "Harrimon Jones",
  "Harrington Health",
  "Harrington Health-Kansas (formerly known as Fiserv Health-Kansas)",
  "Hartford Accident and Indemnity Company",
  "Hartford Casualty Insurance Company",
  "Hartford Dealership Advantage Program Workers' Compensation",
  "Hartford Fire Insurance Company",
  "Hartford Insurance Company Illinois",
  "Hartford Insurance Company of the Midwest",
  "Hartford Insurance Company of the Southeast",
  "Hartford Life and Accident Insurance Company",
  "Hartford Life and Annuity Insurance Company",
  "Hartford Life Insurance Company",
  "Hartford Underwriters Insurance Company",
  "Harvard Community Health Plan",
  "Harvard Pilgrim Health Care",
  "Harvard Pilgrim Passport Connect",
  "Hastings College of the Law",
  "Hawaii Dental Service",
  "Hawaii Dental Services (Delta Dental of Hawaii)",
  "Hawaii Mainland Administrators",
  "Hawaii Management Alliance Association",
  "Hawaii Management Alliance Association (HMAA)",
  "Hawaii Medical Assurance Association (Hawaii-Western Management Group)",
  "Hawaii Medical Assurance Association (HMAA Hawaii-Western Management Group)",
  "Hawaii Medical Service Association",
  "Hawaii Medical Service Association (HMSA)",
  "Hawkeye",
  "Hawthorne Financial Corporation",
  "Hayhoe Construction",
  "HCA Hospital Corporation of America",
  "HCC Life Insurance",
  "HCHA Albuquerque",
  "Headsup Healthcare",
  "Health 2 Business",
  "Health Alliance Medical Plan Illinois",
  "Health Alliance Medical Plans",
  "Health Alliance Medical Plans of Illinois",
  "Health Alliance Plan (HAP)",
  "Health Alliance Plan CareSource MI Health Link (Medicare-Medicaid Plan)",
  "Health Alliance Plan Michigan",
  "Health America Incorporated Health Assurance Advantra",
  "Health and Human Service National Disaster Medical System",
  "Health and Human Services National Disaster Medical System",
  "Health Benefit Claims Department",
  "Health Care LA IPA (HCLA)",
  "Health Care Los Angeles Independent Practice Association (HCLA)",
  "Health Choice BCBS of Arizona ACA",
  "Health Choice Generations",
  "Health Choice Pathway",
  "Health Choice Utah",
  "Health Claims Services (HCS)",
  "Health Cost Solutions",
  "Health Design Plus (Hudson, Ohio)",
  "Health Equity",
  "Health Excel Independent Practice Association",
  "Health First",
  "Health First Colorado",
  "Health First Health Plan",
  "Health First Health Plans",
  "Health First Health Plans - National",
  "Health First Insurance",
  "Health First Third Party Administrator Tyler",
  "Health First Third-Party Administrator Tyler",
  "Health First TPA Austin",
  "Health In Tech",
  "Health Insurance Plan New York",
  "Health Insurance Plan of Greater New York",
  "Health Maintenance Organization Blue",
  "Health Maintenance Organization Blue Texas",
  "Health Management Concepts",
  "Health Net - Commercial",
  "Health Net - Healthy Families Dental A, B & C",
  "Health Net - LA & Sacramento Dental",
  "Health Net - Los Angeles PHP Dental",
  "Health Net - Sacramento GMC Dental",
  "Health Net Claims (California Oregon)",
  "Health Net Medicare Advantage",
  "Health Network One",
  "Health Network Solutions (HNS) - Blue Cross Blue Shield North Carolina",
  "Health Network Solutions (HNS) - MedCost NC",
  "Health Network Solutions (HNS) - MedCost North Carolina",
  "Health Network Solutions - Cigna North Carolina",
  "Health New England",
  "Health Now Administrative Service (previously Brokerage Concepts)",
  "Health Options of Illinois",
  "Health Partners PA",
  "Health Partners Philadelphia",
  "Health Payment Systems Incorporated",
  "Health Plan Nevada",
  "Health Plan of Nevada - Encounters",
  "Health Plan of San Joaquin",
  "Health Plan of San Mateo (CA Medicaid MCO)",
  "Health Plan of Upper Ohio Valley",
  "Health Plan San Joaquin (HPSJ)",
  "Health Plan San Mateo",
  "Health Plan Services",
  "Health Plans Incorporated",
  "Health Plus Private Health Services Plan",
  "Health Resources Inc",
  "Health Services for Children with Special Needs",
  "Health Services Management",
  "Health Services Management (HSM)",
  "Health Services Preferred (HSP) by Emerald Health",
  "Health Share Oregon",
  "Health Special Risk Incorporated",
  "Health Texas Medical Group",
  "Health Valley Provider Network",
  "Health Value Management",
  "HealthAmerica Incorporated HealthAssurance Advantra",
  "HealthBridge",
  "Healthcare Alliance (Sears)",
  "Healthcare Association Albuquerque",
  "Healthcare Association Albuquerque - Self Funded",
  "Healthcare Benefits",
  "HealthCare Highways Health Plan",
  "Healthcare Management Administrators (HMA)",
  "Healthcare Management Systems",
  "Healthcare Network Wisconsin (HCN)",
  "HealthCare Partners",
  "HealthCare Partners IPA",
  "HealthCare Partners Nevada",
  "Healthcare Resources Northwest",
  "HealthCare Solutions Group (HSG)",
  "Healthcare Strategic Initiatives",
  "HealthCare's Finest Network",
  "HealthChoice Arizona",
  "Healthchoice Dept of Corrections and Rehab",
  "Healthchoice of AZ",
  "Healthchoice of Connecticut",
  "HealthChoice of Oklahoma",
  "HealthChoice Select",
  "Healthcomp",
  "HealthComp (Community First Star Health Plan)",
  "HealthComp Incorporated (West)",
  "HealthComp South",
  "HealthE Exchange",
  "HealthEase",
  "HealthEase Kids",
  "HealthEdge Administrators",
  "HealthEdge Administrators (Bakersfield California)",
  "HealthEZ",
  "Healthfirst - Tyler, TX",
  "Healthfirst Health Plan New Jersey",
  "Healthfirst Incorporated New York",
  "Healthgram Incorporated",
  "HealthGroup Limited",
  "HealthLink",
  "Healthlink PPO",
  "Healthly Medical Group",
  "HealthNow Blue Cross Blue Shield New York Northeastern",
  "HealthNow Blue Cross Blue Shield New York Western",
  "HealthNow New York Incorporated",
  "HealthPartners",
  "HealthPartners (Minnesota)",
  "HealthPartners (MN)",
  "HealthPartners Insurance Vanderbilt",
  "HealthPartners Pennsylvania",
  "HealthPlans Incorporated",
  "Healthplex",
  "HealthPlus Managed Long Term Care",
  "HealthPlus Michigan",
  "HealthScope",
  "HealthSCOPE Benefits",
  "HealthScope Benefits Incorporated",
  "HealthSCOPE Benefits Incorporated (Morris Associates)",
  "HealthSCOPE Benefits National Health Plan",
  "HealthSmart",
  "HealthSmart (American Administrative Group)",
  "HealthSmart Accel",
  "HealthSmart Benefit Solutions",
  "HealthSmart Management Services Organization",
  "HealthSmart Management Services Organization Incorporated",
  "HealthSmart MyDecision",
  "Healthsmart OKC(Oklahoma City)",
  "HealthSmart Preferred Care Inc.",
  "HealthSmart Preferred Care Incorporated",
  "HealthSource Georgia",
  "HealthSource Kentucky",
  "HealthSource Management Services Organization",
  "HealthSource MSO",
  "HealthSource Ohio",
  "Healthsource Provident",
  "HealthSource Tennessee",
  "HealthSpan Integrated Care",
  "HealthSpring HMO Medicare Choice",
  "HealthSun Health Plan",
  "HealthSun Health Plans",
  "HealthTeam Advantage",
  "Healthways WholeHealth Networks",
  "HealthWorx",
  "Healthy Alliance Life Insurance - PPO Dental",
  "Healthy Blue Dual Advantage",
  "Healthy Blue Dual Advantage of Louisiana",
  "Healthy Blue Kansas",
  "Healthy Blue Louisiana",
  "Healthy Blue Missouri",
  "Healthy Blue North Carolina",
  "Healthy Blue South Carolina",
  "Healthy Indiana Plan",
  "Healthy Missisippi",
  "Healthy New Life Medical Corporation",
  "Healthy Partners Sacramento County",
  "Healthy San Francisco",
  "Healthy York Network",
  "HealthyCT Incorporated",
  "Heartland Employment Services LLC",
  "Heartland Express",
  "Heartland National Life Insurance Company",
  "Helmsman Management Services",
  "Hemet Community Medical Group",
  "Hemet Unified School District (California)",
  "Hennepin Health",
  "HereIU Welfare Pension Funds",
  "Heritage Consultants",
  "Heritage Group",
  "Heritage Independent Practice Association",
  "Heritage Physician Network (Houston)",
  "Heritage Provider Network (Regal)",
  "Heritage Victor Valley Medical Group",
  "HETS",
  "Hidalgo Independent School District",
  "Higgins Brick Company",
  "High Desert Medical Group",
  "High Desert Medical Group (Regal)",
  "High Desert PACE",
  "High Desert Primary Care Premier",
  "High Desert Program of All-Inclusive Care for the Elderly",
  "Highland Golf",
  "Highline Medical Services Organization",
  "Highmark Blue Cross Blue Shield",
  "Highmark Blue Cross Blue Shield (New York) - Commercial and Medicare Advantage",
  "Highmark Blue Cross Blue Shield (New York) - Medicaid and CHP",
  "Highmark Blue Cross Blue Shield (NY) - Medicaid and Child Health Plus",
  "Highmark Blue Cross Blue Shield (NY) - Medicaid and CHP",
  "Highmark Blue Cross Blue Shield Delaware Health Options Incorporated",
  "Highmark Blue Cross Blue Shield of Delaware",
  "Highmark Blue Cross Blue Shield of Western New York",
  "Highmark Blue Cross Blue Shield Pennsylvania",
  "Highmark Blue Cross Blue Shield Pennsylvania Institutional",
  "Highmark Blue Cross Blue Shield Pennsylvania Professional",
  "Highmark Blue Cross Blue Shield Pennsylvania Western",
  "Highmark Blue Cross Blue Shield West Virginia",
  "Highmark Blue Shield",
  "Highmark Blue Shield (New York) - Commercial and Medicare Advantage",
  "Highmark Blue Shield - SEPA",
  "Highmark Blue Shield of Northeastern New York",
  "Highmark BlueCross BlueShield Pennsylvania Western",
  "Highmark Health Options Dual Plan",
  "Highmark Health Options West Virginia",
  "Highmark of Pennsylvania",
  "Highmark Senior Health Company",
  "Highmark Senior Solutions",
  "Highmark Senior Solutions Company West Virginia",
  "Highmark Wholecare",
  "Highmark Wholecare (Medicaid)",
  "Hill Physicians Aetna Preferred Provider Organization",
  "Hill Physicians Blue Cross PPO",
  "Hill Physicians Blue Shield PPO",
  "Hill Physicians Blue Shield Preferred Provider Organization",
  "Hill Physicians Health Net PPO",
  "Hill Physicians Health Network Preferred Provider Organization",
  "Hill Physicians Medical Group",
  "Hill Physicians Medical Group Cigna PPO",
  "Hill Physicians Medical Group Cigna Preferred Provider Organization",
  "Hill Physicians United Healthcare PPO",
  "Hill Physicians UnitedHealthcare Preferred Provider Organization",
  "Hilliard Corporation (UCS)",
  "Hillshire Brands",
  "Hilmar Cheese Company",
  "Hinsdale Medicare Advantage",
  "HIP Health Insurance Plan of Greater New York",
  "Hispanic Physicians Independent Practice Association - Encounters Only",
  "Hispanic Physicians Independent Practice Association - Fee For Service",
  "HM Care Advantage Admin by KBA",
  "HMC HealthWorks",
  "HMO Colorado",
  "HMSHost",
  "HMSO Highline Medical Services Organization",
  "HN1 Therapy Network",
  "Hoag Affiliated Physicians",
  "Hoag Clinic (Hoag Physician Partners)",
  "Hogan Motor Leasing",
  "Hogan Personnel",
  "Holista",
  "Holistic Psychealth LLC",
  "Holly Farms Corporation",
  "Hollywood Presbyterian Medical Center - Preferred (HPMC - PMG)",
  "Hollywood Presbyterian Medical Group",
  "Home State Health Plan",
  "Home Sweet Home",
  "Homeland Security (Deportation)",
  "Homelink",
  "Homelink HealthPartners",
  "Hometown Health Network",
  "Hometown Health Plan MA HMO (P3 Health Partners Nevada)",
  "Hometown Health Plan Nevada",
  "Hometown Health Providers",
  "Homewood Resorts (UCS)",
  "Homewood Resorts (United Community Services)",
  "Homexx International Corporation",
  "Hoosier Healthwise",
  "Hope Select Care PACE",
  "Horizon Blue Cross Blue Shield New Jersey",
  "Horizon New Jersey Health",
  "Horizon PACE",
  "Horizon Valley Medical Group",
  "Hortica Florist Mutual Insurance",
  "Hospital Corporation of America",
  "Hospital Housekeeping Systems",
  "Hospital Sisters Health System Medical Group Independent Practice Association",
  "Hotel Employees and Restaurant Employees Health Trust",
  "Hotel Employees and Restaurant Employees International Union Welfare Pension Funds",
  "Houck Gregory (Partner) Winn",
  "Household Merch National Nursing Institute",
  "Household Merchandising NNI",
  "Housing Authority El Paso (Texas)",
  "Houston Hunters Patrol Incorporated",
  "Houston Steak Delivery 1 LLC",
  "Howard County",
  "Howard County Government (Maryland)",
  "HP Administrative Services LLC",
  "HPI Vanderbilt",
  "HRI Dental and Vision",
  "HSA Health Insurance Company",
  "HSHS Medical Group IPA",
  "Hudson Health Plan",
  "Hudspeth County",
  "Huffman Independent School District (ISD)",
  "Hughes Redwood Company Incorporated",
  "Hughes Tool Company",
  "Humana",
  "Humana (KV) - Joint Venture Hospital Laboratory",
  "Humana (KV) - JVHL",
  "Humana - Healthy Horizons (Ohio Medicaid)",
  "Humana Careington",
  "Humana Dental",
  "Humana Encounters",
  "Humana Long Term Care",
  "Humana Military",
  "Humana of Florida",
  "Humana Puerto Rico",
  "Humboldt Del Norte Foundation IPA",
  "Huntington Park Mission Medical Group",
  "Huron PACE",
  "HUSKY Health Connecticut",
  "Hutchinson Technology",
  "Hy Vee",
  "Hydroform USA Incorporated",
  "I E Shaffer (West Trenton New Jersey)",
  "IBG Administrators Incorporated",
  "IBM Business Toisc",
  "IBM Insurance Outsourcing Services",
  "IBM Medical Plans",
  "iCare (Independent Care Health Plan",
  "iCare (Independent Care Health Plan)",
  "iCare Health Options Third Party Administrator",
  "iCare Health Options TPA",
  "iCircle Care",
  "ICW (Insurance Company of the West)",
  "Ideal Auto Parts Incorporated",
  "IDS Property Casualty Insurance Company",
  "IH Plans, Inc.",
  "IHS Gateway Payer South",
  "IlliniCare Health Plan",
  "Illinois Casualty",
  "Illinois EMCASCO",
  "Illinois Medicaid",
  "Illinois Physicians Alliance Independent Practice Association",
  "Illinois Physicians Alliance Independent Practice Association (IPA)",
  "IMA Incorporated",
  "Imagine360 Administrators (Group & Pension Administrators)",
  "ImCare",
  "Immigration and Naturalization Health Services (Immigration Health Services)",
  "Impact Health AMPS",
  "Impact Health Share Inc.",
  "Imperial Health Holdings Medical Group",
  "Imperial Health Nevada",
  "Imperial Health Plan of California Incorporated",
  "Imperial Health Plan of California, Incorporated",
  "Imperial Insurance Companies Inc - Arizona Exchange",
  "Imperial Insurance Companies Inc - Texas Exchange",
  "Imperial Insurance Companies Inc Exchange - Utah",
  "Imperial Insurance Company Texas",
  "Imperial Irrigation District",
  "Imperial Valley Lumber Company",
  "IMX Easy",
  "IncentiCare",
  "Inconen Corporation",
  "Indecs Corporation",
  "Independence Administrators",
  "Independence American Insurance Company",
  "Independence American Insurance Company Life",
  "Independence Blue Cross",
  "Independence Blue Cross Dental Plan – Blueextrasm",
  "Independence Blue Cross Pennsylvania",
  "Independence Blue Cross Pennsylvania Personal Choice",
  "Independence Medical Group (Tulare County)",
  "Independence Medical Group - Kern County",
  "Independent Clinics of Washington (ICW)",
  "Independent Health",
  "Independent Living Systems (ILS Lead Agency)",
  "Independent Living Systems (Independent Living Services Lead Agency)",
  "Indian Health Service Gateway Payer South",
  "Indian Health Services",
  "Indiana Insurance",
  "Indiana Medicaid",
  "Indiana Pro Health Network",
  "Indiana University Health Plan - Medicare Advantage",
  "Indiana University Health Plans - Commercial",
  "Individual Assurance Company Life",
  "Inetico Incorporated",
  "Ingham Health Plan Corporation",
  "Ingles Markets",
  "Inland Empire Health Plan",
  "Inland Empire Health Plan (Covered California)",
  "Inland Faculty Medical Group",
  "Inland Valley Hospice",
  "Innermark TPA",
  "Innov OSF Healthcare Central",
  "InnovAge",
  "Innovante Benefit Administrators",
  "Innovate OSF Healthcare Central",
  "Innovation Aetna",
  "Innovation Health",
  "Innovations Successful Salon S",
  "Innovative Claim Solutions (ICS) Rancho Cordova",
  "Innovative Claim Solutions (ICS) San Ramon",
  "Innovative Integrated Health",
  "Innovative Partners LP",
  "Insilco Corporation",
  "Insite By Security Health Plan",
  "Inspira Health Network Life",
  "Inssolen",
  "Insurance Administrator of America Incorporated",
  "Insurance Company of the West (ICW)",
  "Insurance Design Administrators",
  "Insurance Management Administrators Louisiana Incorporated",
  "Insurance Management Services Texas",
  "Insurance Program Managers Group",
  "Insurance Services Lubbock",
  "Insurance Systems Incorporated",
  "Insurance Third Party Administrator",
  "InsuranceTPA.com",
  "Insurers Administrative Corporation",
  "Integon Casualty Insurance Company",
  "Integon General Insurance Corporation",
  "Integon Indemnity Corporation",
  "Integon National Insurance Company",
  "Integon Preferred Insurance Company",
  "Integra Administrative Group",
  "Integra Group",
  "IntegraNet",
  "Integrated Health Partners (IHP)",
  "Integrated Homecare Services",
  "Integrated Medical Solutions",
  "Integrated Mental Health Services",
  "Integrity Mutual Insurance Company",
  "Integrity Workers' Compensation",
  "Inter County Health Plan",
  "Inter Valley Health Plan",
  "Interactive Medical Systems",
  "Intercare",
  "Intercare Health Plans Incorporated",
  "InterCommunity Health Network",
  "InterCounty Hospitalization Plan",
  "Interface Employee Assistance Program",
  "InterGroup Services Corporation",
  "Interinsurance Exchange of the Automobile Club",
  "International Bay Clubs Incorporated",
  "International Benefit Administration",
  "International Brotherhood of Electrical Workers (IBEW) Local Number One Health and Welfare Fund",
  "International Brotherhood of Electrical Workers Local 38",
  "International Brotherhood of Electrical Workers Local No. 1 Health and Welfare (Mental Health)",
  "International Brotherhood of Electrical Workers Local No. 1 Health and Welfare Fund",
  "International Funding",
  "International Medical Group",
  "InterWest Health Preferred Provider Organization Montana",
  "Inventory Control System",
  "IOM Holdings Incorporated (A Corporation)",
  "Iowa Health Advantage",
  "Iowa Screening Program",
  "Iowa Total Care",
  "IPMG Claims Management",
  "Iqvia",
  "Irex Corporation",
  "Iron Road Healthcare",
  "Ironworking Contract I P",
  "Ironworking Contract IP",
  "Island Home Insurance",
  "Island Home Insurance Company",
  "ISO International Student Health Insurance",
  "ISurity",
  "Itasca Medical Care",
  "J C Wattenbarger and Sons Incorporated",
  "J D Mechanical",
  "J H McCormack Construction",
  "J T Contractors Incorporated",
  "J. B. Hunt Transport Incorporated",
  "J.B. Hunt Transport Incorporated",
  "J.P. Farley Corporation",
  "J1 Legacy",
  "Jackson Care Connect",
  "JAI Medical Systems",
  "JAI Medical Systems Healthcare",
  "Janico Building Maintenance Company",
  "JCV Tacos Incorporated",
  "Jefferson County Texas",
  "Jefferson Health Plans",
  "Jericho Share",
  "Jerry Solomon Enterprises Incorporated",
  "JHS Community",
  "JI Specialty Services",
  "JLS Family Enterprises",
  "John Hopkins Home Care Group",
  "John Morrell",
  "John Muir Health",
  "John Muir Health Network",
  "John Muir Trauma Physicians",
  "Johns Eastern Company Inc",
  "Johns Hopkins Advantage Maryland",
  "Johns Hopkins Advantage MD",
  "Johns Hopkins Employee Health Plan",
  "Johns Hopkins Employer Health Programs (EHP)",
  "Johns Hopkins HealthCare LLC",
  "Johns Hopkins Home Care Group",
  "Johns Hopkins Priority Partners",
  "Johns Hopkins U.S. Family Health Plan (USFHP)",
  "Johns Hopkins US Family Health Plan (USFHP)",
  "Johnson Larry (An Individual)",
  "Johnston Schools",
  "Jones Truck Lines Incorporated",
  "Joplin Claims",
  "Joppa Health Share",
  "Jordan Valley Senior Care",
  "JP Farley Corporation",
  "JP Specialities",
  "Judson Independent School District",
  "Junction Independent School District (ISD)",
  "Juvenile Jail Facility Management",
  "Kaiser - Self Funded",
  "Kaiser CSI California Select for Individuals",
  "Kaiser Foundation Colorado",
  "Kaiser Foundation Health Plan Colorado",
  "Kaiser Foundation Health Plan Georgia",
  "Kaiser Foundation Health Plan Hawaii",
  "Kaiser Foundation Health Plan Mid-Atlantic",
  "Kaiser Foundation Health Plan Northern California",
  "Kaiser Foundation Health Plan Northwest",
  "Kaiser Foundation Health Plan Southern California",
  "Kaiser Foundation Health Plan Washington",
  "Kaiser Foundation Health Plan Washington Options",
  "Kaiser Foundation Northwest",
  "Kaiser Health Plan Incorporated Georgia Region",
  "Kaiser Permanente Georgia",
  "Kaiser Permanente Health Plan Hawaii",
  "Kaiser Permanente Northern California",
  "Kaiser Permanente of Washington (KPWA)",
  "Kaiser Self Funded Plan Harrington Fiserv",
  "Kalos Health",
  "KanCare",
  "Kane County Independent Physicians Association",
  "Kane County Independent Practice Association",
  "Kansas (Blue Cross Blue Shield of Kansas)",
  "Kansas City Life Insurance Company and Healthy Choices",
  "Kansas Health Advantage",
  "Karnes City Independent School District (ISD)",
  "Katy Medical Claims",
  "Katy Medical Group",
  "Katy Medical Group (SelectCare Texas)",
  "Kautz Vineyards",
  "KB Medical Practice PC - Empire Medical Practice PC",
  "KCI Holdings USA",
  "Keenan and Associates",
  "Keenan and Associates (Excluding City of Pasadena)",
  "Keiser (A Corporation)",
  "Kellogg Companies",
  "Kelsey-Seybold",
  "Kemper Health",
  "Kemper Preferred",
  "Kempton Company Kempton Group Administrator",
  "Ken Davis Industries Incorporated",
  "Kennedale Independent School District (ISD)",
  "Kentucky Health Administrators",
  "Kern Health Systems",
  "Kern Legacy Health Plan",
  "Key Benefit Administrators",
  "Key Benefit Administrators (Indianapolis, Indiana)",
  "Key Health Medical Solutions Incorporated",
  "Key Healthy Partners",
  "Key Medical Group",
  "Key Risk Management Services LLC",
  "Key Select",
  "Key Solution",
  "KeyCare Maryland",
  "Keystone",
  "Keystone First",
  "Keystone First Aligned",
  "Keystone First CHIP",
  "Keystone First Community HealthChoices",
  "Keystone First Pennsylvania Community HealthChoices",
  "Keystone First VIP Choice",
  "Keystone Health (Lakeside - Glendale, California) (Regal)",
  "Keystone Health Plan East",
  "Keystone Mercy Health Plan",
  "Kinetic Concepts",
  "King Pak Potato Company LLC",
  "King Ranch",
  "Kirkland's Incorporated",
  "Kirklands Incorporated",
  "Kisx Card LLC",
  "Kitsap Physician Services",
  "Klais and Company",
  "Klais and Company (Part A and Part B)",
  "KM Strategic Management (KMSM)",
  "Know The Costs",
  "Koan Risk Solutions",
  "Kordye Turner and Company Incorporated",
  "Korean American Medical Group",
  "Kova Healthcare Incorporated",
  "Krieger Bertie (An Individual)",
  "KSKJ Life",
  "KTA Construction (COSD2)",
  "Kurt Bohmer Plumbing Incorporated",
  "Kurtz Finan Auto Supply Incorporated",
  "Kuspuk School District",
  "Kustom Fit Manufacturing Company",
  "L.A. Care Health Plan (California)",
  "LA Care",
  "LA Care Health Plan - Dental",
  "LA Care HealthNet by Medpoint",
  "La Vernia Independent School District (ISD)",
  "La Villa Independent School District (ISD)",
  "LACH HealthNet by MedPoint",
  "Lackland Independent School District (ISD)",
  "Laclede Chain",
  "Laclede Steel",
  "Lafayette Consolidated Government",
  "Lago Vista Independent School District (ISD)",
  "Lake Area Community Health Plan (VHS)",
  "Lake Arrowhead Country Club",
  "Lake Elsinore School District",
  "Lake Region Community Health Plan",
  "Lakes Area Community Health Plan",
  "Lakeside Community Healthcare (Regal)",
  "Lakeside Health Services",
  "Lakeside Medical Group",
  "Lakeside Medical Group (Regal Lakeside)",
  "Lakewood Independent Practice Association",
  "Lamar Consolidated Independent School District",
  "Lamesa Independent School District",
  "Landmark Golf Course",
  "Landmark Grading and Paving",
  "Landmark Health Plan of California",
  "Landmark Healthcare",
  "Landry's",
  "Landstar BCO Workers' Compensation Program",
  "Lane County",
  "Lantern Surgery Care",
  "Larimer County Workers' Compensation",
  "Las Vegas Firefighters Health and Welfare Trust",
  "LaSalle Medical Group",
  "Lassen Municipal Utility District",
  "Lasso Healthcare Managed Services Agreement",
  "Lasso HealthCare MSA",
  "Laticrete International Incorporated",
  "Laundry Workers",
  "Lawndale Christian Health Center",
  "Lawndale PACE",
  "LB Auto Pacific Parts",
  "LB Auto Pacific Supply",
  "League of Minnesota Cities Insurance Trust",
  "Ledtronics Incorporated",
  "Leisure World Union 76 Incorporated",
  "Lekos Electric",
  "Leon Health Plans",
  "Leon Medical Center Health Plan",
  "Levelland Independent School District (ISD)",
  "Levin Enterprises Incorporated",
  "Lewisville Independent School District Self Insured",
  "LFP Corporation",
  "Liberty Advantage North Carolina",
  "Liberty Bankers Life Insurance Company",
  "Liberty Dental Plan",
  "Liberty Eylau Independent School District (ISD)",
  "Liberty HealthShare",
  "Liberty Mutual",
  "Liberty Mutual Middle Markets",
  "Liberty National Life Insurance Company",
  "Liberty Northwest",
  "Liberty Wausau",
  "Life and Health Insurance Company of America",
  "Life Armstrong",
  "Life Beaver PACE",
  "Life Butler",
  "Life Investors of America (Long Term Care)",
  "Life Pittsburgh",
  "Life St. Francis",
  "Life St. Joseph of the Pines",
  "Life St. Mary",
  "Life Trac",
  "LifeCare Assurance Company",
  "Lifemap",
  "Lifepath Hospice",
  "Lifeprint Network",
  "LifeRe",
  "LifeShield National Insurance Co.",
  "LifeShield National Insurance Company",
  "LifeTrac",
  "Lifewise Arizona",
  "LifeWise Assurance Company",
  "LifeWise Health Plan of Washington",
  "Lifeworks Advantage",
  "Lifeworks Advantage (Institutional Special Needs Plan)",
  "Lighthouse Health Plan",
  "Lights of America Incorporated",
  "Limric Plumbing, Heating & Air (UCS BASI)",
  "Lincoln Financial Group (Salt Lake City)",
  "Lincoln Heritage",
  "Lincoln National",
  "Line Construction Benefit (LINECO)",
  "Little Company of Mary",
  "Livingston Independent School District",
  "Lockard Williams Insurance Services",
  "Lodging Development and Management",
  "Lodi Memorial Hospital",
  "Loma Linda University Health - Managed Care",
  "Lone Star TPA",
  "Long Beach Memorial Independent Practice Association (MHCAN)",
  "Long Beach Unified School District",
  "Long Term Care",
  "Long's Drugs",
  "Longevity Colorado",
  "Longevity Florida",
  "Longevity Health Plan of Florida",
  "Longevity Health Plan of Illinois",
  "Longevity Health Plan of Massachusetts",
  "Longevity Health Plan of New Jersey",
  "Longevity Health Plan of New York",
  "Longevity Health Plan of North Carolina",
  "Longevity Health Plan of Oklahoma",
  "Longevity Illinois",
  "Longevity Michigan",
  "Longevity New Jersey",
  "Longevity New Jersey (NJ)",
  "Longevity New York",
  "Longevity North Carolina",
  "Longevity Oklahoma",
  "Longs Drugs",
  "Loren Cook",
  "Los Alamos Total Care (Prudential)",
  "Los Altos Golf and Country Club",
  "Los Angeles Care Health Plan (California)",
  "Los Angeles Medical Center (LAMC)",
  "Louisiana Health Exchange",
  "Louisiana Healthcare Connections",
  "Louisiana State University",
  "Louisiana Workers Compensation Corporation (LWCC)",
  "Louisiana Workers' Compensation Corporation (LWCC)",
  "Lowe's",
  "Lower Kuskokwim School District",
  "Loyal American Life Insurance Company",
  "Loyola Physician Partners",
  "LSG Sky Chefs International",
  "LUBA Casualty Insurance Company",
  "Lucent Health",
  "Lucent Health - Nashville",
  "Lucent Health - North America Administrators NAA",
  "Lucent Health California",
  "Lumbermens Underwriting Alliance",
  "Lumico Life Insurance Company",
  "Luminare Health",
  "Luminare Health (Arizona Minnesota)",
  "Luminare Health (Maryland Pennsylvania Illinois)",
  "Luminare Health (North Carolina Indiana)",
  "Luminare Health (Ohio)",
  "Luminare Health Detroit",
  "Luminare Health Internal",
  "Luminare Health Internal(fka Trustmark Health Benefits)",
  "Luminare Health Kansas City",
  "Luminare Health Little Rock",
  "Lundeen Pacific Corporation",
  "Lutheran Advanced PPO",
  "Lutheran Services Carolinas",
  "LutheranAdvanced PPO",
  "Lynwood Unified School District (California)",
  "Lynx",
  "Mabuhay Medical Group",
  "Mackinaw Administrators",
  "Macneal Health Providers CHS",
  "Macy's (Daly City)",
  "Macy's (Newport Beach)",
  "Macy's Corporate Services Incorporated",
  "Madera Community Hospital",
  "Madison Research Corporation",
  "Maestro Health Plan",
  "Magan Medical Clinic",
  "Magellan Behavioral Health",
  "Magellan HealthCare",
  "MagnaCare",
  "Magnolia Health",
  "Magnolia Health Plan",
  "Main Street America Group America Assurance",
  "Main Street America Group Austin Mutual",
  "Main Street America Group Grain Dealers Mutual",
  "Main Street America Group Great Lakes Casualty",
  "Main Street America Group Insurance Protection",
  "Main Street America Group National Grange Mutual (NGM)",
  "Main Street America Group NGM",
  "Main Street America Group Old Dominion Company",
  "Main Street America Group Spring Valley Mutual",
  "Main Street America Group Surplus Non-Admitted",
  "Maine Community Health Options",
  "Maine Employers' Mutual Insurance Company",
  "Maine Medicaid",
  "Maintenance Pacesetters Incorporated",
  "Major League Baseball 8",
  "Mallis Associates Incorporated",
  "MAMSI Health Plan",
  "Managed Care Indemnity",
  "Managed Care of North America (MCNA) Dental",
  "Managed Care Services",
  "Managed Care Services California Department of Corrections and Rehabilitation",
  "Managed Care Services Nevada",
  "Managed Care Systems (Gemcare)",
  "Managed Health Networks",
  "Managed Health Networks (MHN - Non Behavioral Health Services)",
  "Managed Health Services Indiana",
  "Managed Health Services Insurance Corporation",
  "Managed Healthcare Associates",
  "Managed Healthcare Associates (MHCA)",
  "Managed Prescriptions Services",
  "Managed Provider Alliance - Custom Provider Network",
  "Manhattan Life Assurance Company of America",
  "Manhattan Life Insurance & Annuity Company",
  "Maniglia Landscape Incorporated",
  "Manufacturers Alliance Insurance Company",
  "Mapfre Canada Life",
  "MAPFRE Life Insurance Company of Puerto Rico",
  "Marble Falls Independent School District (ISD)",
  "March Vision Care Inc",
  "Marcotte and Hearne",
  "Marfield Company Incorporated",
  "Maricopa County Community College District",
  "Maricopa Health Plan",
  "MARICOPA HEALTH PLAN (UAHP)",
  "Maricopa Health Plan - Maricopa Care Advantage",
  "Marin Headlands Medical Group",
  "Marin Independent Practice Association",
  "Marin Radiology Group",
  "Mariposa County",
  "Markrist Engineers",
  "Marlin Independent School District (ISD)",
  "Marpai Health",
  "Marrick Mement Finance",
  "Marriott",
  "Martin's Point Health Care",
  "Martins Point Health Care",
  "Mary Washington Health Plan",
  "Maryland Casualty Company (Commercial Only)",
  "Maryland Physicians Care",
  "Maryland Public Behavioral Health System (PBHS)",
  "Mashantucket Pequot Tribal Nation",
  "Mass Advantage",
  "Mass General Brigham Health Plan",
  "Massachusetts Bay Insurance Company",
  "Massachusetts Behavioral Health (Behavioral Health Organization)",
  "Massachusetts Behavioral Health Partnership (Behavioral Health Organization)",
  "Master, Mates, and Pilots",
  "Matagorda County",
  "Matheson Trucking",
  "Matrix Absence Management",
  "Maverick Medical Group",
  "Maxim Crane Works",
  "Maxsys Technologies Corporation",
  "Mayo Clinic Florida and Georgia",
  "Mayo Clinic Recovery and Claims Services",
  "MBA CLM",
  "MBA Wyoming",
  "MBACLM",
  "MCA - Sedgwick WTC Health Program",
  "MCA Administrators Inc",
  "MCC Health",
  "McDonald's McOpCo",
  "McGee Electric Incorporated",
  "McLaren ABC Thoroughbred Horsemen's Plan Corporation",
  "McLaren ABC THPC",
  "McLaren Advantage Benefit Way Network Health Plan (NHP)",
  "McLaren Advantage By WellCare New Health Plan",
  "McLaren Advantage SNP",
  "McLaren Advantage Special Needs Plan",
  "McLaren Health Advantage",
  "McLaren Health Plan",
  "McLaren Health Plan (K7) - Joint Venture Hospital Laboratory",
  "McLaren Health Plan (K7) - JVHL",
  "McLaren Medicaid",
  "McLaren Medicare Supplement",
  "MD Anderson Physician Network",
  "MDsave",
  "MDSI Physicians Group Incorporated",
  "MDwise Medicare Advantage",
  "MDX Hawai'i",
  "MDX Hawaii",
  "Meadowbrook Insurance Group",
  "Med Pay",
  "Med Point Management Prospect (MPM)",
  "MED3000 Centers for Medicare & Medicaid Services Title 19 Reform",
  "MED3000 Centers for Medicare & Medicaid Services Title 21",
  "Medbenefixx Incorporated",
  "Medco Containment Insurance Company of New York",
  "MedCom",
  "MedConnection (Marriott)",
  "MedCore Health Plan",
  "MedCore HP",
  "MedCost",
  "Medcost of North Carolina",
  "Medequip Inc",
  "MedFocus",
  "Medi-Share",
  "Medica",
  "Medica (formerly WellFirst)",
  "Medica (UnitedHealthcare)",
  "Medica Dental",
  "Medica Government Programs",
  "Medica Health Care Plan",
  "Medica Health Plan Solutions",
  "Medica Healthcare Plan Florida",
  "Medica Individual and Family",
  "Medica Medicare Supplement",
  "MEDICA of Minnesota",
  "MEDICA Public Programs",
  "Medica Public Programs - Dental",
  "Medica2",
  "Medica2 IFB",
  "Medicaid Alabama",
  "Medicaid Alaska",
  "Medicaid Arizona",
  "Medicaid Arkansas",
  "Medicaid California Medi-Cal",
  "Medicaid Colorado",
  "Medicaid Connecticut",
  "Medicaid Delaware",
  "Medicaid District of Columbia",
  "Medicaid Florida",
  "Medicaid Georgia",
  "Medicaid Hawaii",
  "Medicaid Idaho",
  "Medicaid Illinois",
  "Medicaid Illinois Dental",
  "Medicaid Illinois IDPA",
  "Medicaid Indiana",
  "Medicaid Iowa",
  "Medicaid Kansas",
  "Medicaid Kentucky",
  "Medicaid Louisiana",
  "Medicaid Louisiana - Non-Emergency Transportation [.NAM]",
  "Medicaid Louisiana - Rehabilitation [.REH]",
  "Medicaid Louisiana Durable Medical Equipment Claims",
  "Medicaid Maine",
  "Medicaid Maryland",
  "Medicaid Massachusetts",
  "Medicaid Michigan",
  "Medicaid Michigan - BCCP",
  "Medicaid Michigan Encounters",
  "Medicaid Minnesota",
  "Medicaid Mississippi",
  "Medicaid Missouri",
  "Medicaid Montana",
  "Medicaid Nebraska",
  "Medicaid Nevada",
  "Medicaid New Hampshire",
  "Medicaid New Jersey",
  "Medicaid New Mexico",
  "Medicaid New Mexico Presbyterian Salud",
  "Medicaid New York",
  "Medicaid North Carolina",
  "Medicaid North Dakota",
  "Medicaid of Kentucky (Region 3 - Doral Dental)",
  "Medicaid of Massachusetts (Mass Health)",
  "Medicaid Ohio",
  "Medicaid Ohio - Buckeye",
  "Medicaid Ohio - Humana DentaQuest",
  "Medicaid Ohio - Humana EyeMed",
  "Medicaid Ohio - United Healthcare OH Medicaid",
  "Medicaid Oklahoma",
  "Medicaid Oregon",
  "Medicaid Oregon (Department of Human Services Office of Medical Assistance Programs)",
  "Medicaid Oregon (DHS Office of Medical Assistance Programs)",
  "Medicaid Pennsylvania",
  "Medicaid Rhode Island",
  "Medicaid South Carolina",
  "Medicaid South Dakota",
  "Medicaid Tennessee",
  "Medicaid Tennessee BlueCare TennCare Select",
  "Medicaid Texas (Long Term Care)",
  "Medicaid Texas (LTC)",
  "Medicaid Texas - Acute",
  "Medicaid Texas - CHIP",
  "Medicaid Texas Health Steps",
  "Medicaid Texas MCNA Dental",
  "Medicaid United States Virgin Islands",
  "Medicaid Utah",
  "Medicaid Vermont",
  "Medicaid Virginia",
  "Medicaid Washington",
  "Medicaid Washington (ProviderOne)",
  "Medicaid West Virginia",
  "Medicaid Wisconsin",
  "Medicaid Wyoming",
  "Medical Associates Health Plan",
  "Medical Associates Health Plan Health Choices",
  "Medical Benefit Administration",
  "Medical Benefits Administration",
  "Medical Benefits Administrator",
  "Medical Benefits Administrators",
  "Medical Benefits Mutual Life Insurance Company",
  "Medical Card System (MCS)",
  "Medical Control",
  "Medical Home Network",
  "Medical Mutual",
  "Medical Mutual of Ohio",
  "Medical Network of Colorado Springs",
  "Medical Payment",
  "Medical Payments",
  "Medical Plan of Kansas City",
  "Medical Provider Association - Custom Provider Network",
  "Medical Reimbursements of America",
  "Medical Service Company Group Incorporated (MSC)",
  "Medical Transport Solutions",
  "Medical Transportation Services",
  "Medical Value Plan Ohio",
  "Medicare Advantage Pennsylvania",
  "Medicare Alabama Part A",
  "Medicare Alabama Part B",
  "Medicare Alaska Part A",
  "Medicare Alaska Part B",
  "Medicare American Health Advantage of Missouri (formerly Missouri Select)",
  "Medicare American Samoa Part A",
  "Medicare American Samoa Part B",
  "Medicare and Much More Florida Incorporated (MMM Florida)",
  "Medicare Arizona Part A",
  "Medicare Arizona Part B",
  "Medicare Arkansas Part A",
  "Medicare Arkansas Part B",
  "Medicare Blue HMO PPO",
  "Medicare California Part A",
  "Medicare Colorado Part A",
  "Medicare Colorado Part B",
  "Medicare Connecticut Part A",
  "Medicare Connecticut Part B",
  "Medicare Delaware Part A",
  "Medicare District of Columbia Part A",
  "Medicare District of Columbia Part B (J12 Highmark)",
  "Medicare Durable Medical Equipment Regional Carrier (DMERC) Region B",
  "Medicare Durable Medical Equipment Regional Carrier Jurisdiction A",
  "Medicare Durable Medical Equipment Regional Carrier Jurisdiction B",
  "Medicare Durable Medical Equipment Regional Carrier Jurisdiction C",
  "Medicare Durable Medical Equipment Regional Carrier Jurisdiction D",
  "Medicare Durable Medical Equipment Regional Carrier Region A",
  "Medicare Durable Medical Equipment Regional Carrier Region C",
  "Medicare Durable Medical Equipment Regional Carrier Region D",
  "Medicare Florida Blue",
  "Medicare Florida Part A",
  "Medicare Florida Part B",
  "Medicare Georgia Part A",
  "Medicare Georgia Part B (J10 Cahaba)",
  "Medicare Georgia Part B (Jurisdiction 10 Cahaba)",
  "Medicare Guam Part A",
  "Medicare Guam Part B",
  "Medicare Hawaii Part A",
  "Medicare Hawaii Part B",
  "Medicare HHH (Home Health and Hospice) J15 (CGS)",
  "Medicare Home Health and Hospice J15 (CGS)",
  "Medicare Home Health and Hospice Part A",
  "Medicare Idaho Part A",
  "Medicare Idaho Part B",
  "Medicare Illinois Part A",
  "Medicare Illinois Part B",
  "Medicare Indiana Part A",
  "Medicare Indiana Part B (J8)",
  "Medicare Indiana Part B (Jurisdiction 8)",
  "MEDICARE INDIANA PART B (WPS)",
  "Medicare Iowa Part A (Wisconsin Physicians Service)",
  "Medicare Iowa Part A (WPS)",
  "Medicare Iowa Part B (J5 Wisconsin Physicians Service)",
  "Medicare Kansas",
  "Medicare Kansas Part A Wisconsin Physicians Service",
  "Medicare Kansas Part A WPS",
  "Medicare Kansas Part B WPS",
  "Medicare Kentucky Part A (J15)",
  "Medicare Kentucky Part A (Jurisdiction 15)",
  "Medicare Kentucky Part B (J15)",
  "Medicare Louisiana Part A",
  "Medicare Louisiana Part B",
  "Medicare Maine Part A",
  "Medicare Maine Part B",
  "Medicare Maryland Part A",
  "Medicare Maryland Part B",
  "Medicare Massachusetts Part A",
  "Medicare Massachusetts Part B",
  "Medicare Michigan Part A",
  "Medicare Michigan Part B (Wisconsin Physicians Service)",
  "Medicare Minnesota Part A",
  "Medicare Minnesota Part B",
  "Medicare Mississippi Part B",
  "Medicare Missouri Part A (Wisconsin Physicians Service)",
  "Medicare Missouri Part B (J5 WPS)",
  "Medicare Montana Part A",
  "Medicare Montana Part B",
  "Medicare Nebraska Part A",
  "Medicare Nebraska Part B (J5 WPS)",
  "Medicare Nevada Part A",
  "Medicare Nevada Part B",
  "Medicare New Hampshire Part A",
  "Medicare New Hampshire Part B",
  "Medicare New Jersey Part B",
  "Medicare New Mexico Part A",
  "Medicare New Mexico Part B",
  "Medicare New York Downstate",
  "Medicare New York Part A",
  "Medicare New York Part B Queens",
  "Medicare New York Part B Upstate",
  "Medicare North Carolina Part A",
  "Medicare North Carolina Part B",
  "Medicare North Carolina Part B (Jurisdiction 11)",
  "Medicare North Dakota Part A",
  "Medicare North Dakota Part B",
  "Medicare Northern California Part B",
  "Medicare Northern Marianas Part A",
  "Medicare Northern Marianas Part B",
  "Medicare Ohio Part A",
  "Medicare Ohio Part B",
  "Medicare Oklahoma Part A",
  "Medicare Oklahoma Part B",
  "Medicare Oregon Part A",
  "Medicare Oregon Part B",
  "Medicare Part A Home Health and Hospice Palmetto",
  "Medicare Part A J04911",
  "Medicare Part A Legacy Wisconsin Physicians Service (Colorado, New Mexico, Texas, Oklahoma)",
  "Medicare Part A Legacy WPS (Colorado New Mexico Texas Oklahoma)",
  "Medicare Part A Puerto Rico",
  "Medicare Part A Rhode Island",
  "Medicare Part B - Delaware",
  "Medicare Part B - District of Columbia",
  "Medicare Part B Puerto Rico (First Coast)",
  "Medicare Part B – Delaware",
  "Medicare Pennsylvania Part A",
  "Medicare Pennsylvania Part B",
  "Medicare Preferred Provider Organizations (PPO)",
  "Medicare Railroad",
  "Medicare Rhode Island Part A",
  "Medicare Rhode Island Part B",
  "Medicare South Carolina Part A",
  "Medicare South Carolina Part B",
  "Medicare South Dakota Part A",
  "Medicare South Dakota Part B",
  "Medicare Southern California Part B",
  "Medicare Tennessee Part A",
  "Medicare Tennessee Part A (Cahaba)",
  "Medicare Tennessee Part B (Cahaba)",
  "Medicare Texas Part A",
  "Medicare Texas Part B",
  "Medicare Utah Part A",
  "Medicare Utah Part B",
  "Medicare Vermont Part A",
  "Medicare Vermont Part B",
  "Medicare Virgin Islands",
  "Medicare Virgin Islands Part A",
  "Medicare Virginia Part A",
  "Medicare Virginia Part B",
  "Medicare Washington D.C. Part A",
  "Medicare Washington D.C. Part B",
  "Medicare Washington Part A",
  "Medicare Washington Part B",
  "Medicare West Virginia Part A",
  "Medicare West Virginia Part B",
  "Medicare Wisconsin Part A",
  "Medicare Wisconsin Part B",
  "Medicare Wyoming Part A",
  "Medicare Wyoming Part B",
  "Medicare y Mucho Mas (MMM)",
  "Medicare y Mucho Más (MMM)",
  "MediChoice Independent Practice Association",
  "Medicina Familiar Medical Group",
  "Medico Insurance Company",
  "Medico Life and Health Insurance Company",
  "MediGold",
  "MediGold Health Plans",
  "MediStreams",
  "Mediview CMSEB UB",
  "Mediview Galveston County Indigent Care",
  "MediView Galveston County Indigent Care UB",
  "MediView Sendero IdealCare",
  "MediView The University of Texas Medical Branch 3",
  "MediView UTMB",
  "Mediview UTMB Care UB",
  "MedLogix Managed Service Organization - Americo Independent Practice Association",
  "MedLogix Management Services Organization - Americo Independent Practice Association",
  "MedPartners",
  "MedPartners Administrative Services",
  "MedPartners Administrative Services (Indiana)",
  "Medpay First One",
  "MedPlus",
  "MedRisk",
  "MedSolutions Incorporated",
  "MedStar Family Care",
  "MedStar Family Choice District of Columbia",
  "MedStar Family Choice Maryland HealthChoice",
  "MedStar Health Plan",
  "Medxoom",
  "Meemic",
  "Member Select Insurance Company",
  "MEMIC",
  "Memorial Clinical Associates",
  "Memorial Clinical Associates SelectCare Texas",
  "Memorial Health Services",
  "Memorial Healthcare Independent Practice Association",
  "Memorial Hermann Bundle Program",
  "Memorial Hermann Health Insurance Company",
  "Memorial Hermann Health Network",
  "Memorial Hermann Health Solutions",
  "Memorial Medical Group",
  "MemorialCare Medical Foundation",
  "MemorialCare Medical Foundation (Cap Services)",
  "MemorialCare Medical Foundation (UC Irvine)",
  "MemorialCare Medical Foundation (University of California, Irvine)",
  "Memorialcare Select Health Plan",
  "Mendota Insurance Company",
  "Menifee Valley Community Medical Group",
  "Mental Health Consultants Incorporated",
  "Mercalis",
  "Mercedes Independent School District (ISD)",
  "Merchant Benefit Administration",
  "Merchants Benefit Administration",
  "Mercy Benefit Administrators",
  "Mercy Care Arizona",
  "Mercy Care Plan (Arizona Health Care Cost Containment System)",
  "Mercy Care Plan (AZ Health Care Cost Containment System)",
  "Mercy Care Plan (AZHCCS)",
  "Mercy Care Regional Behavioral Health Authority",
  "Mercy Health Plan of New Jersey",
  "Mercy Maricopa Integrated Care",
  "Mercy Physicians Medical Group",
  "Mercy Provider Network",
  "Meridian Construction Program",
  "Meridian Health Plan Illinois",
  "Meridian Health Plan Illinois Complete",
  "Meridian Health Plan Illinois Medicaid",
  "Meridian Health Plan Michigan",
  "Meridian Health Plan Michigan Complete",
  "Meridian PACE Solutions",
  "Meritage Corporation",
  "Meritain",
  "Meritain Eldorado",
  "Meritain Health",
  "Meritain Health Minneapolis",
  "Meritain LuminX",
  "Mesa County Colorado",
  "Mesa County Valley School District 51",
  "Metairie Lousiana",
  "Metcare Health Plans",
  "MetLife Dental Family",
  "Metro Health Plan",
  "MetroPlus Health Plan",
  "Metropolitan Council",
  "Metropolitan Property and Casualty Insurance Company",
  "Metropolitan Transit Authority",
  "Mexia Independent School District (ISD)",
  "Mexicana Airlines",
  "Meyling Albert",
  "MFC and HealthPlus Peoria",
  "MGM Resorts International - Dental",
  "MHS Health Wisconsin",
  "MHS Wisconsin Health",
  "Miami Behavioral Health",
  "Miami Children's Health Plan",
  "MIC General Insurance Corporation",
  "MIC Property and Casualty Insurance Corporation",
  "Michael Hogan Association",
  "Michael McElroy",
  "Michael Reese",
  "Michael Reese Physicians Group",
  "Michigan Complete Health",
  "Michigan Complete Health (Fidelis Secure Life)",
  "Michigan Laborers Health Care Fund",
  "Michigan Laborers' Health Care Fund",
  "MiChild Michigan",
  "Mid America Associates Incorporated",
  "Mid American Benefits",
  "Mid Cities Independent Practice Association",
  "Mid-America Associates, Inc.",
  "Mid-Atlantic Medical Services, Inc. Health Plan",
  "Mid-Century Insurance Company",
  "Midland County",
  "Midland National Life Insurance Company",
  "Midlands Choice",
  "Midsouth Mutual Insurance Company",
  "MidSouth Mutual Insurance Company (MMIC)",
  "Midwest Drywall",
  "Midwest Family Mutual (Auto Only)",
  "Midwest Family Mutual Insurance Company",
  "Midwest Insurance",
  "Midwest Operating Engineers Health and Welfare",
  "Midwest Operating Engineers Welfare Fund",
  "Midwest Public Risk Management Association",
  "Millard Refrigerated",
  "Millette Administrators Inc. (Michigan)",
  "Millette Administrators, Inc.",
  "Millsap Independent School District (ISD)",
  "Minneapolis Prudential",
  "Minnesota Counties Insurance Trust",
  "Minnesota Department of Health",
  "Minnesota Department of Labor and Industry Claims",
  "Minnesota Power",
  "Mirra Healthcare LLC",
  "Mission Aviation Fellowship",
  "Mission Community Independent Practice Association",
  "Mission Community IPA",
  "Mission Consolidated Independent School District (CISD)",
  "Mission Consolidated Independent School District (ISD)",
  "Mission Corps International Incorporated",
  "Mission Heritage Medical Group",
  "Mission Hospital Affiliated Physicians",
  "Mission Lodge Sanitarium",
  "Mission Organics",
  "Mississippi Children's Health Insurance Program",
  "Mississippi Medicare Part A Jurisdiction 7",
  "Mississippi Physicians Care Network",
  "Mississippi Select Health Care",
  "Mississippi Select HealthCare",
  "Missoula Cart Company",
  "Missoula County Medical Benefits",
  "Missoula County Medical Benefits Plan",
  "Missouri Care",
  "Missouri Care Managed Care",
  "Mitchell Energy and Development",
  "Mitsui Sumitomo Insurance Group",
  "Mitsui Sumitomo Insurance USA Incorporated",
  "MMM Multi Health",
  "Moda Health",
  "Moda Health (ODS Health Plan)",
  "Moda Health (Oregon Dental Service Health Plan)",
  "Moda Health Plan",
  "Modesto Irrigation District",
  "Moffatt Contracting Incorporated",
  "Molina Complete Care DSNP",
  "Molina Complete Care Dual Eligible Special Needs Plan",
  "Molina Complete Care of Virginia",
  "Molina Healthcare",
  "Molina Healthcare - Administered by Liberty Dental Plan",
  "Molina Healthcare - Affinity by Molina Healthcare",
  "Molina HealthCare Arizona",
  "Molina Healthcare California",
  "Molina Healthcare Florida",
  "Molina HealthCare Idaho",
  "Molina Healthcare Illinois",
  "Molina Healthcare Michigan",
  "Molina Healthcare Mississippi",
  "Molina Healthcare Nebraska",
  "Molina HealthCare Nevada",
  "Molina Healthcare New Mexico",
  "Molina Healthcare New York (Total Care New York)",
  "Molina Healthcare of Iowa",
  "Molina Healthcare of Kentucky",
  "Molina Healthcare of New York",
  "Molina HealthCare Ohio",
  "Molina Healthcare South Carolina",
  "Molina Healthcare Texas",
  "Molina Healthcare Utah",
  "Molina HealthCare Washington",
  "Molina Healthcare Wisconsin",
  "Molina Ohio Medicaid Managed Care Entity",
  "Monarch Independent Practice Association",
  "Monarch Plumbing Company Incorporated",
  "Monitor Life Insurance",
  "Montefiore Contract Management Organization",
  "Montgomery",
  "Montgomery Country Government Self Insurance Program (MCSIP)",
  "Montgomery County Texas",
  "Monument Administrators Cornerstone Comp",
  "Monument Administrators Cornerstone Compensation",
  "Monument Administrators Elite Country Club",
  "Monumental Life Insurance Company",
  "Monumental Life Insurance Company, Little Rock, Arkansas",
  "Moody Independent School District (ISD)",
  "MoreCare",
  "Moreno Valley Pontiac",
  "Morongo Basin Transit Authority California",
  "Morris Associates",
  "Morris Material Handling",
  "Morrison Healthcare Incorporated",
  "Morton Independent School District (ISD)",
  "Mosaic IPA Medical Group",
  "Mothers Nutritional Center",
  "Motion Picture and Television Fund",
  "Motion Picture Industry Pension and Health Plans",
  "MotivHealth",
  "MotivHealth Insurance Company",
  "Motors Insurance Corporation",
  "Mount Carmel Health Plan",
  "Mountain Health Co-op",
  "Mountain Health Co-op (administered by Wipro)",
  "Mountain State Blue Cross Blue Shield West Virginia",
  "Mountaineer Preferred Managed Benefits Association",
  "MPE Employee Benefit Services Incorporated",
  "MPower Bundle",
  "mPower Fee-for-Service",
  "MRH Enterprises",
  "MSA Care Guard",
  "Mt Sinai Eldercare",
  "Muleshoe Independent School District (ISD)",
  "MultiCare Connected Care",
  "MultiCare PACE",
  "MultiCare Program of All-Inclusive Care for the Elderly",
  "MultiPlan Incorporated",
  "Multiplan New Orleans Division",
  "MultiPlan Wisconsin Preferred Provider Network (WPPN)",
  "Multnomah County",
  "Munford Incorporated",
  "Municipal Health Benefit Fund",
  "Musco",
  "Mutual Assurance Administrators",
  "Mutual Commercial",
  "Mutual Group The United States",
  "Mutual Health Services",
  "Mutual of Omaha",
  "Mutually Preferred",
  "MVP Child Health Plus",
  "MVP Health Care",
  "MVP Health Plan",
  "MVP Health Plan New York",
  "MVP Medicaid Managed Care",
  "MVP Select Care",
  "My Family Medical Group",
  "MyTruAdvantage",
  "Nacogdoches Independent School District (ISD)",
  "NAP Tools",
  "NaphCare",
  "Nascentia Health Plan",
  "Nassau Life Insurance Company of Kansas",
  "Nassau Life Insurance Company of Texas",
  "Natalia Independent School District (ISD)",
  "Natel Engineering Company Incorporated",
  "National Accident and Health General Agency Incorporated",
  "National Allied Workers Union Local 831",
  "National American Insurance Company (NAICO)",
  "National Asbestos Medical Fund",
  "National Association of Letter Carriers (NALC)",
  "National Automatic Sprinkler Industry",
  "National Capital Preferred Provider Organization (NCPPO)",
  "National Casualty Company",
  "National Centers for Medicare & Medicaid Services",
  "National Claims Administrative Services Charlotte",
  "National Claims Administrative Services Charlotte North Carolina",
  "National Elevator Industry Benefit Plan",
  "National Elevator Industry Benefit Plan (NEIB)",
  "National Farmers Union Property and Casualty Company",
  "National Financial Insurance Company",
  "National Foundation Life Insurance",
  "National Foundation Life Insurance Company",
  "National General",
  "National General Insurance Online Incorporated (GMAC)",
  "National Government Services",
  "National Government Services (NGS) - Connecticut",
  "National Government Services (NGS) - Maine",
  "National Government Services (NGS) - Massachusetts",
  "National Government Services (NGS) - New Hampshire",
  "National Government Services (NGS) - New York",
  "National Government Services (NGS) - Rhode Island",
  "National Government Services (NGS) - Vermont",
  "National Guardian Life Insurance",
  "National Health Administrators Incorporated (NHAI)",
  "National Health Benefit",
  "National Health Benefit Corporation Auxiant",
  "National HealthCare Corporation Advantage",
  "National Imaging Associates Healthcare (NIA)",
  "National Interstate",
  "National Jewish Health",
  "National Liability and Fire Insurance Company",
  "National Loss Prevention Incorporated",
  "National Maintenance Incorporated",
  "National Pacific Dental (California)",
  "National Pacific Dental (Texas)",
  "National Pacific of Texas (NCFLEX)",
  "National Rural Letter Carrier Association (NRLC)",
  "National Telecommunications Cooperative Association",
  "National Telecommunications Cooperative Association (NTCA)",
  "National Telecommunications Cooperative Association (NTCA) Staff Members",
  "National Telecommunications Cooperative Association Staff Members",
  "National Vision",
  "Nationwide Affinity Insurance Company of America",
  "Nationwide Agribusiness Insurance Company",
  "Nationwide Insurance Companies",
  "Nationwide Insurance Company of America",
  "Nationwide Insurance Mitchell",
  "Nationwide Mutual Fire Company",
  "Nationwide Mutual Insurance Company",
  "Nationwide Property and Casualty Insurance Company",
  "Native Care Health LLC",
  "NBCUniversal",
  "NCAS Fairfax Virginia",
  "Nebraska Total Care",
  "Neighborhood Health Partnership",
  "Neighborhood Health Partnership (NHP)",
  "Neighborhood Health Plan",
  "Neighborhood Health Plan Rhode Island",
  "Neighborhood Health Plan Rhode Island Exchange",
  "Neighborhood Healthcare PACE",
  "Neighborhood Healthcare Program of All-Inclusive Care for the Elderly",
  "Nelson Nameplate Company",
  "NetCare Life and Health Insurance",
  "NetWell",
  "Network Administrators",
  "Network Health",
  "Network Health Insurance Corporation Medicare (NHIC)",
  "Network Health Insurance Corporation Medicare NHIC",
  "Network Health Plan",
  "Network Medical Management",
  "Network Solutions Independent Practice Association",
  "NeueHealth",
  "Nevada Pacific Dental",
  "New Avenues Incorporated",
  "New Caney Independent School District (ISD)",
  "New Century Auto Group",
  "New Century Health",
  "New Directions Behavioral Health",
  "New England Financial",
  "New Era Life Insurance Company",
  "New Era Welfare Benefit Plan Trust",
  "New Hampshire Healthy Families",
  "New Horizons PACE",
  "New Jersey Manufacturing",
  "New Jersey Manufacturing - Workers' Compensation",
  "New Koosharem Corporation Select Staffing",
  "New Life Medical Group Incorporated",
  "New South Insurance Company",
  "New York Hotel Funds MHAP",
  "New York Hotel Trade Council",
  "New York Life",
  "New York Medical Imaging Most Valuable Provider",
  "New York Medical Imaging MVP",
  "New York Medical Indemnity Fund",
  "New York Network Management",
  "New York Preferred Care",
  "New York State Department of Health United Cerebral Palsy (NYS)",
  "New York State Insurance Fund (NYSIF)",
  "Nexillo Health",
  "Next Level Health Partners",
  "NextBlue",
  "NextBlue of North Dakota",
  "NextPA",
  "NHC Advantage LLC",
  "Nickolas Environmental",
  "Nippon Life Benefits (NLIA)",
  "Nippon Life Insurance Company",
  "Nippon Life Insurance Company of America",
  "Nivano Physicians Independent Practice Association",
  "NJ Medicare Part A (J12 - Highmark)",
  "Noble Community Medical Associates Los Angeles",
  "Noble Mid-Orange County (HealthSmart)",
  "Nomi Health Gateway",
  "Nonprofit Insurance Trust",
  "Nordstrom Incorporated",
  "NorGUARD Insurance Company - Berkshire Hathaway GUARD Insurance Companies",
  "Noridian (NHS) - Alaska",
  "Noridian (NHS) - American Samoa",
  "Noridian (NHS) - Arizona",
  "Noridian (NHS) - California",
  "Noridian (NHS) - Idaho",
  "Noridian (NHS) - Montana",
  "Noridian (NHS) - Nevada",
  "Noridian (NHS) - North Dakota",
  "Noridian (NHS) - Oregon",
  "Noridian (NHS) - South Dakota",
  "Noridian (NHS) - Utah",
  "Noridian (NHS) - Washington",
  "Noridian (NHS) - Wyoming",
  "North American Administrators",
  "North American Administrators Nashville, Tennessee (NAA)",
  "North American Insurance Company (Oxford Life)",
  "North American Medical Management (NAMM) Northern California",
  "North American Video Corporation",
  "North Bay Schools Insurance Authority (NBSIA)",
  "North Carolina Farm Bureau",
  "North Carolina Guarantee Insurance Association",
  "North Carolina Health Choice",
  "North Carolina League of Municipalities (NCLM)",
  "North Carolina Medicaid",
  "North Clackamas School District 12",
  "North Colorado School Districts Workers' Compensation Pool",
  "North County Transit District",
  "North Dakota Department of Human Resources",
  "North River Insurance Company",
  "North Shore Long Island Jewish CareConnect Insurance Company Incorporated",
  "North Star Administrators",
  "North West Orange County Medical Group",
  "Northcoast Healthcare",
  "Northeast Iowa Area Agency",
  "Northeast Iowa Community Health Plan",
  "Northeast Medical Services (NEMS)",
  "Northern California Advantage Medical Group",
  "Northern California Physician Group",
  "Northern California Physicians Group",
  "Northern California Pipe Trades Trust",
  "Northern Claims Management",
  "Northern Illinois Health Plan",
  "Northern Kentucky University",
  "Northern Nevada Trust Fund",
  "Northern Plains Preferred Health Plan Commercial",
  "Northland Auto",
  "Northridge Medical Group",
  "Northwell Direct",
  "Northwest Administrators Inc",
  "Northwest Dental Services",
  "Northwest Diagnostic Clinic SelectCare Texas",
  "Northwest Insurance",
  "Northwest Ironworkers Health and Security Health Fund",
  "Northwest Physicians PHP OHP",
  "Northwest Plumbers and Pipefitters Health and Welfare Trust",
  "Northwest Roofers and Employers Health and Security Trust Fund",
  "Northwest Suburban Independent Practice Association Illinois",
  "Northwest Textile Processors",
  "Northwestern Medicine Physicians Network",
  "Northwood Healthcare",
  "Norwood",
  "Nova Dealership Advantage Program",
  "Nova Elite Compensation Program",
  "Nova Healthcare",
  "Nova Metals Advantage Plus Program",
  "Nova Pro Risk Solutions",
  "Novant Health Direct to Employers Episodes",
  "NovaPro Risk Solutions",
  "NovaSys Health Network",
  "NovaWell",
  "Novitas - Arkansas",
  "Novitas - Colorado",
  "Novitas - Delaware",
  "Novitas - District of Columbia",
  "Novitas - Louisiana",
  "Novitas - Maryland",
  "Novitas - Mississippi",
  "Novitas - New Jersey",
  "Novitas - New Mexico",
  "Novitas - Oklahoma",
  "Novitas - Texas",
  "NP PHP Commercial",
  "NP PHP Medicare",
  "NTCA Staff Members",
  "Nuestra Family Medical Group",
  "Nuevo Engineering",
  "Numero Uno Market Incorporated",
  "Nurse Practitioner Public Health Plan Oregon Health Plan",
  "Nurse Practitioner Yamhill County Coordinated Care Organization",
  "Nx Health Network",
  "O'Reilly Auto Parts",
  "Oak River (Berkshire Hathaway Homestate Companies (BHHC))",
  "Oak Street Health",
  "Oak West Physician Association",
  "Oakwood Interiors Incorporated",
  "Oasis Independent Practice Association (Regal)",
  "OCCH, Orange County Health Services Department Corrections Health, Orange County Corrections",
  "Occupational Eyewear Network Incorporated",
  "Ochsner Health Plan",
  "OCRW Ryan White Program",
  "ODS Community Dental",
  "OEA Choice Trust",
  "Office and Professional Employees International Union (OPEIU) Locals 30 and 536",
  "Ogden Benefits Administration",
  "Ohana Health Plan",
  "Ohana Health Plan - Dental",
  "Ohio Casualty Group",
  "Ohio Connect",
  "Ohio Health Choice",
  "OhioHealthy",
  "Oklahoma Complete Health",
  "Oklahoma Department of Corrections",
  "Oklahoma Department of Corrections Department of Rehabilitative Services",
  "Oklahoma Department of Rehabilitative Services",
  "Oklahoma DRS",
  "Old Republic Insurance Company",
  "Old Surety Life Insurance Company",
  "Olympus Management Health Care",
  "Omni - JVHL",
  "Omni Administrators",
  "Omni Healthcare (Humboldt Del Norte)",
  "Omni Independent Practice Association",
  "Omni Independent Practice Association (IPA)",
  "OmniCare Medical Group (Omni)",
  "On Lok Senior Health Services Incorporated",
  "Oncology Network Orange County",
  "Oncology Physicians Network of CA",
  "One Beacon",
  "One Call Durable Medical Equipment",
  "One Call Medical",
  "One Call Medical - Diagnostic",
  "One Call Medical Diagnostic",
  "One Health Plan",
  "One Health Plan California",
  "One Health Plan Georgia",
  "One Health Plan Illinois",
  "One HomeCare Solutions",
  "One Stop Brake Supply Santa Ana",
  "One Stop Undercar Riverside",
  "OneBeacon",
  "OneBeacon Insurance Auto",
  "Ontario Metal Recycling Incorporated",
  "Ontrak Health",
  "Onyx Acceptance Corporation",
  "Operating Engineers Local 139 Health Benefit Fund",
  "Operating Engineers Locals 302 and 612 Health and Security Fund",
  "Opticare Vision Services",
  "Optima Health Behavioral Health",
  "Optima Health Community Care",
  "Optimed Health",
  "Optimum Healthcare Incorporated",
  "Optimum Healthcare, Incorporated",
  "Option Services Group",
  "Optum - Complex Medical Conditions (CMC)",
  "Optum Behavioral Health Salt Lake County",
  "Optum Behavioral Health SLCO",
  "Optum Care Network",
  "Optum Care Network - Monarch IPA",
  "Optum Care Network Connecticut",
  "Optum Care Network KS-MO",
  "Optum Health Physical Health",
  "Optum Health Vision",
  "Optum Maryland Behavioral Health",
  "Optum Medical Network",
  "Optum Salt Lake County Public Sector",
  "Optum San Diego Public Sector Behavioral Health",
  "Optum San Diego Public Sector County",
  "Optum UnitedHealth Behavioral Solutions",
  "OptumCare",
  "OptumCare Network Connecticut",
  "OptumHealth Behavioral Solutions",
  "OptumHealth Care Solutions",
  "OptumHealth Physical Health - includes Oxford",
  "OptumHealth Salt Lake County",
  "OptumHealth Vision",
  "Orange Coast Memorial Independent Practice Association",
  "Orange County Advantage Medical Group",
  "Orange County Fire Authority",
  "Oregon Health Authority",
  "Oregon Health Authority - HRSN",
  "Oregon Health Plan",
  "Orica",
  "Orica Incorporated",
  "Original Sid Blackman Plumbing",
  "Orthonet Uniformed Services Family Health Plan",
  "Orthonet US Family Health Plan",
  "Oscar Health",
  "OSF Care Advantage",
  "OSF Health Plan",
  "OSF Health Plan Care Advantage",
  "OSF Healthcare East",
  "OSI Group LLC",
  "OSI Systems Incorporated",
  "OSU Aetna Better Health",
  "OSU Centene Oklahoma Complete Health",
  "OSU Humana Healthy Horizons",
  "Other Blue Plans Premera BlueExchange (Shared Administration)",
  "Our Lady of the Lake Regional Medical Center",
  "Outrigger Lodging",
  "Overhill Farms Incorporated",
  "Oxford",
  "Oxford Health Plans",
  "Oxford Level Funded (CT, NJ, NY)",
  "Oxford Life Insurance",
  "Ozark Health Plan - Dental",
  "P3 Health Partners Nevada",
  "P3 Health Partners-Arizona",
  "P5 Health Plan Solutions Utah",
  "PACE at Hudson Headwaters",
  "PACE Central New York",
  "PACE Nebraska",
  "PACE of SouthWest Michigan",
  "PACE Southwest Iowa",
  "Pace Your Life",
  "Pacific Administrators",
  "Pacific Benefits Services Oregon Peninsula Airways",
  "Pacific Coast Building Products",
  "Pacific Compensation Insurance Company",
  "Pacific Data Electric, Incorporated",
  "Pacific Dental Services",
  "Pacific Gas and Electric (PG&E)",
  "Pacific Gas and Electric 115",
  "Pacific Health Alliance Anthem Health Maintenance Organization",
  "Pacific Health Alliance Anthem HMO",
  "Pacific Health Alliance Hazel Hawkins Hospital",
  "Pacific Health Alliance Medical",
  "Pacific Health MSO",
  "Pacific Healthcare Independent Practice Association",
  "Pacific Hydrotech Corporation",
  "Pacific Independent Practice Association",
  "Pacific Insurance Company Ltd",
  "Pacific Life",
  "Pacific Lumber Company (Marathon)",
  "Pacific Motor Company",
  "Pacific Partners Management Services Incorporated",
  "Pacific Partners Management Services, Incorporated",
  "Pacific Southwest Administrators (PSWA)",
  "Pacific Specialty Insurance",
  "Pacific Sunwear",
  "Pacific Union (California)",
  "Pacific Union Dental (California)",
  "Pacifica of the Valley Hospital",
  "PacifiCare Dental & Vision Plan",
  "PacifiCare Health",
  "PacificSource Administrators",
  "PacificSource Community Solutions",
  "PacificSource Health Plans",
  "PacificSource Medicaid",
  "PacificSource Medicare",
  "Painters Union Insurance Fund",
  "Pajaro Valley Community Health Trust",
  "Paladin Insurance Services Limited",
  "Paladin ISL",
  "Paladin Managed Care Services Incorporated",
  "Pallet Depot",
  "Palmetto GBA (PGBA) - Alabama",
  "Palmetto GBA (PGBA) - Georgia",
  "Palmetto GBA (PGBA) - North Carolina",
  "Palmetto GBA (PGBA) - South Carolina",
  "Palmetto GBA (PGBA) - Tennessee",
  "Palmetto GBA (PGBA) - Virginia",
  "Palms Casino Resort - Dental",
  "Palo Alto Hills Golf and Country Club",
  "Palo Alto Medical Foundation",
  "Palomar Pomerado Hospital",
  "Pan American Life Insurance",
  "Pan American Life Insurance Group",
  "Pan American Life Puerto Rico (PALIC)",
  "Pan-American Life Insurance Group",
  "Panamerican Palic Puerto Rico",
  "Papa John's International Incorporated",
  "Papa John’s International Incorporated",
  "Paradigm",
  "Paragon Benefits Inc",
  "Paramount",
  "Paramount Health",
  "Paramount IPA",
  "Park District Risk Management Association (PDRMA)",
  "Park Management Group, Incorporated",
  "Parkland Community Health Plan",
  "Parkview Signature Care",
  "Partner Health Management Physical Health",
  "Partners Behavioral Health Management",
  "Partners Health Management Physical Health",
  "Partners Health Plan",
  "Partners in Health",
  "Partners Insurance Company Medicare PPO",
  "Partners National Health Plans North Carolina",
  "Partners National Health Plans of North Carolina Inc",
  "Partnership Health Plan California",
  "Partnership HealthPlan of California",
  "Pas Coffee Roasters",
  "Pasadena Primary Care Physicians Group",
  "Passport Advantage",
  "Passport by Molina Healthcare",
  "Passport Health Plan",
  "Passport Health Plan by Molina Healthcare",
  "Pastabravo Restaurants, Incorporated",
  "Path Administrators (David H. Evans)",
  "Path Administrators (DH Evans)",
  "Patient Advocates",
  "Patriot Dental",
  "Patterson Brothers Lighting",
  "Paul Mueller",
  "Payer Compass Kern County",
  "Payer Fusion",
  "PayerFusion Holdings, LLC",
  "PaySign",
  "PBS Oregon Alaska Industrial Hardware",
  "PBS Oregon Alaska Rubber and Supply",
  "PBS Oregon Cascade Rubber Products",
  "PBS Oregon Construction Machinery Industrial",
  "PCA Health Plan Florida",
  "PCA Health Plans Texas",
  "PCA HealthPlans of Texas",
  "PCA Star Medicaid",
  "PDQ Automatic Transmission Parts",
  "PeaceHealth Laboratories",
  "Peach State Health Plan",
  "Peak Benefit Administrators",
  "Peak Health",
  "Peak Medicare Advantage",
  "Peak PACE Solutions",
  "Peak Program of All-Inclusive Care for the Elderly Solutions",
  "Pearsall Independent School District (ISD)",
  "Pebble Health",
  "Pediatric Associates",
  "Peerless",
  "PEG Discover Re",
  "PEG Discover Re (Food Merchant)",
  "Pegasus Medical Group (Regal)",
  "Pegasus Risk Management California",
  "Pegi Family Dining",
  "PEHP -CHIP",
  "Pekin Insurance",
  "Peninsula Pontiac GMC Buick",
  "Penn Behavioral Health",
  "Penn Millers Insurance Company",
  "Penn Treaty Life Insurance (CHCS Services)",
  "Penn Treaty Network America Insurance Company",
  "Pennsylvania Health and Wellness",
  "Pennsylvania Manufacturers Association Insurance Company",
  "Pennsylvania Manufacturers Indemnity Company",
  "Pennsylvania Manufacturing Associates",
  "Pennsylvania PACE",
  "Pennsylvania Program of All-Inclusive Care for the Elderly",
  "People 2.0",
  "People First",
  "People First Health Strategies",
  "People One Health",
  "People's Health Network",
  "PeopleOne Health",
  "Peoples Health Choices (Preferred Provider Organization)",
  "Peoples Health Choices 65 (Health Maintenance Organization - Point of Service) Southland",
  "Peoples Health Choices 65 (Health Maintenance Organization-Point of Service) Greater New Orleans and Baton Rouge Area",
  "Peoples Health Choices 65 (Health Maintenance Organization-Point of Service) Northshore",
  "Peoples Health Choices 65 (Health Maintenance Organization-Point of Service) Rural Southeast",
  "Peoples Health Choices Gold (Health Maintenance Organization - Point of Service)",
  "Peoples Health Group Medicare (Health Maintenance Organization - Point of Service)",
  "Peoples Health Group Medicare (Health Maintenance Organization - Point of Service) Office of Group Benefits",
  "Peoples Health Medicare Advantage LA-0004 (Health Maintenance Organization - Point of Service)",
  "Peoples Health Patriot (Preferred Provider Organization)",
  "Peoples Health Secure Complete (Health Maintenance Organization - Point of Service Dual Eligible Special Needs Plan)",
  "Peoples Health Secure Health (Health Maintenance Organization - Point of Service Dual Eligible Special Needs Plan)",
  "Pequot Pharmaceutical Network",
  "Perennial Advantage of Colorado",
  "Perennial Advantage of Ohio",
  "Performance Contracting Incorporated",
  "Performance Contracting, Incorporated",
  "Performance Health",
  "PerformCare Select Health Mental Health Substance Abuse",
  "Perlman Medical Group",
  "Perma",
  "Perryton Independent School District (ISD)",
  "Personal Choice",
  "Personal Insurance Administrator Incorporated Agoura Hills",
  "PersonalLink Martin Luther King",
  "Personify Health",
  "Petaluma Valley Hospital",
  "Petro Chem Industries, Incorporated",
  "Pflugerville Independent School District",
  "Pharmacist Mutual Insurance Company",
  "PharmaKinnex",
  "PHH Fleet America",
  "Philadelphia American Life Insurance Company",
  "Phoenix American",
  "PHP Third Party Administrator Services",
  "Physician Health Partners",
  "Physician Health Plan (PHP)",
  "Physicians Associates of the Greater San Gabriel Valley",
  "Physicians Care Alliance Health Plan Florida",
  "Physicians Care Network (Polyclinic)",
  "Physicians Care Network Rockford Illinois",
  "Physicians Choice Medical Group of Santa Maria",
  "Physicians Choice Medical Group San Luis Obispo",
  "Physicians Data Trust",
  "Physicians Health Association Illinois",
  "Physicians Health Network",
  "Physicians Health Network (PHN)",
  "Physicians Health Plan (PHP) Michigan Medicare",
  "Physicians Health Plan (PHP) Northern Indiana",
  "Physicians Health Plan Management Systems",
  "Physicians Health Plan Mid Michigan",
  "Physicians Health Plan Third Party Administrator Services",
  "Physicians HealthWays Independent Practice Association",
  "Physicians Healthways IPA",
  "Physicians Management Group",
  "Physicians Medical Group of San Jose",
  "Physicians Mutual Insurance Company",
  "Physicians of Southwest Washington",
  "Physicians United Plan (PUP) - Dental",
  "Physmetrics",
  "Piedmont Community Health Plan",
  "Pier 1 Incorporated USA",
  "Pima County",
  "Pinnacle Claims Management Inc",
  "Pinnacle Claims Management Inc.",
  "Pinnacle Health Resources",
  "Pinnacle Medical Group",
  "Pinnacle Physician Management",
  "Pioneer Provider Network",
  "Pipefitters Local 597 Welfare Fund",
  "Pipeline Industry Benefit Fund",
  "Pittsburgh Care Partnership Inc.",
  "Pittsburgh Care Partnership Incorporated",
  "PJ Cal 1, Incorporated",
  "Plains Independent School District (ISD)",
  "Plainview Independent School District",
  "Plan de Bienestar UTM-PRSSA",
  "Plan de Salud Bella Vista",
  "Plan de Salud Hospital Menonita",
  "Plan De Salud Menonita",
  "Plan de Salud Menonita GHP (Vital)",
  "Plan de Salud Menonita Government Health Plan (Vital)",
  "Plan de Socios Auxilio Mutuo",
  "Plan Handlers",
  "Planned Administrators",
  "Planned Administrators Incorporated",
  "Planstin",
  "Plemons Stinnett Phillips Consolidated Independent School District (CISD)",
  "PLICO",
  "Plott Healthcare",
  "Plumber & Amp Fitters Local 295",
  "Plumbers and Pipefitters United Association Local 350",
  "Plumbers Local 130",
  "Plumbers Union Local No. 12 Welfare Fund",
  "PMC Government Health Plan GHP (Vital)",
  "PodAmerica",
  "Podiatry First Incorporated",
  "Podiatry Plan Incorporated",
  "Point C",
  "Point C Health",
  "Point Comfort Underwriters - ORR Unaccompanied Childrens Programs",
  "Point Comfort Underwriters - Refugee Medical Assistance Program (RMA)",
  "Point Comfort Underwriters Travel - PCG Travel Programs",
  "Polish Falcons of America",
  "Poly America",
  "Poly America Medical Benefits Plan",
  "Poly Pak America, Incorporated",
  "Poly-America",
  "Pomeroy Investments, Incorporated",
  "Pomona Valley Medical Group",
  "Ponderosa Landscape",
  "Pool Administrators",
  "Pool Administrators - California Administrators",
  "Pool Administrators Oregon Professional Primary",
  "Pool Administrators Primary",
  "Pool Administrators Secondary",
  "Pool Oregon  - Secondary",
  "Pool Oregon - Primary",
  "Pool Water Products",
  "Poolville Independent School District (ISD)",
  "Popular Textile Corporation",
  "Populytics",
  "Port of Oakland California",
  "Port of Oakland, California",
  "Porteous Fastener Company",
  "Porter Scott",
  "Positive Health Care (PHC) California",
  "Positive Healthcare Florida",
  "Poth Independent School District (ISD)",
  "Potter County",
  "PPO Plus LLC",
  "Prairie Meadows",
  "Prairie States Enterprises Incorporated",
  "Pre Med Defender",
  "Pre-Med Defender",
  "Preferred Administrators",
  "Preferred Administrators Children's Hospital",
  "Preferred Benefit Administrators",
  "Preferred Benefit Administrators Longwood Florida",
  "Preferred Care Network",
  "Preferred Care Network Health",
  "Preferred Care Partners Florida",
  "Preferred Community Choice",
  "Preferred Employers",
  "Preferred Employers Group",
  "Preferred Employers Insurance Company (PEI)",
  "Preferred Health Plan",
  "Preferred Health Plan of Carolinas (PHPC)",
  "Preferred Health Professionals",
  "Preferred Independent Physician Association",
  "Preferred Independent Practice Association",
  "Preferred Medical Claims Services",
  "Preferred Medicare Choice",
  "Preferred Medicare Choice (PMC)",
  "Preferred Provider Organization One",
  "Preferred Provider Organization Plus LLC",
  "PreferredOne",
  "PreferredOne Minnesota",
  "Premera Blue Cross (Washington)",
  "Premera Blue Cross Alaska",
  "Premera Blue Cross Blue Shield Alaska and Washington",
  "Premera Blue Cross Blue Shield of Alaska",
  "Premera Blue Cross Blue Shield Washington State",
  "Premera Blue Cross HMO",
  "Premera Blue Cross of Washington",
  "Premera Dental",
  "Premera Federal Employee Program (FEP)",
  "Premier Access Inc",
  "Premier Access Insurance (CA)",
  "Premier Administrative Solutions",
  "Premier Care Independent Practice Association (ProCare Management Services Organization)",
  "Premier Care of Northern California",
  "Premier Eye Care",
  "Premier Health",
  "Premier Healthcare Exchange",
  "Premier Healthcare Exchange (PHX) - Preferred Administrators",
  "Premier Healthcare Exchange Incorporated (PHX)",
  "Premier Physician Alliance",
  "Premier Physician Network",
  "Premier Physicians Alliance",
  "Premier Physicians Network",
  "PrenLink Martin Luther King Jr.",
  "Presbyterian (New Mexico)",
  "Presbyterian Health Plan",
  "Presbyterian Health Plan (Commercial)",
  "Presence ERC",
  "Presence Health Partners",
  "Presidential Life Insurance Company",
  "Prestige Health Choice",
  "Preston Holmes, Incorporated",
  "Prevea360",
  "Prezzo",
  "Primary Care & Pediatric Independent Practice Association (PCP IPA)",
  "Primary Care Associates California",
  "Primary Care Associates Medical Group",
  "Primary Care Coalition",
  "Primary Health Network",
  "Prime Benefits System",
  "Prime Community Care Central Valley",
  "Prime Health Choice",
  "Prime Healthcare",
  "PrimeCare Medical Group of Chino Valley",
  "PrimeCare Medical Network",
  "PrimeCare Medical Network Chino",
  "PrimeCare Medical Network Citrus Valley",
  "PrimeCare Medical Network Corona",
  "PrimeCare Medical Network Hemet",
  "PrimeCare Medical Network Inland Valley",
  "PrimeCare Medical Network Moreno Valley",
  "PrimeCare Medical Network NAMM",
  "PrimeCare Medical Network Redlands",
  "PrimeCare Medical Network Riverside",
  "PrimeCare Medical Network San Bernardino",
  "PrimeCare Medical Network Sun City",
  "PrimeCare Medical Network Temecula",
  "PrimeSource Health Networks",
  "PrimeWest Health",
  "PrimeWest Health Plan",
  "Prince George's County Government Maryland",
  "Princeton Premier Independent Practice Association",
  "Principal Financial Group",
  "Principal Life Insurance (Dental)",
  "Principal Life Insurance Co",
  "Priority Health",
  "Priority Partners",
  "Prism Network Incorporated",
  "Prism Univera",
  "Private Healthcare Systems (PHCS Savility)",
  "Pro-Claim Plus Inc",
  "ProCare (Prospect)",
  "ProCare Texas",
  "Prodegi Corporate Benefit Services",
  "Productive Programming Incorporated",
  "Productive Programming Incorporated (PPI)",
  "Professional Benefit Administrators Incorporated (Oak Brook)",
  "Professional Benefit Administrators Incorporated (Oak Brook, Illinois)",
  "Professional Benefit Services Oregon Construction Machinery Industrial",
  "Professional Benefit Services Oregon Peninsula Airways",
  "Professional Claims Management",
  "Professional Health Care Network",
  "Professional Review Committee - Utah Navajo Health System",
  "Program of All-Inclusive Care for the Elderly (PACE) Greater New Orleans",
  "Program of All-Inclusive Care for the Elderly (PACE) of Southwest Michigan Incorporated",
  "Program of All-Inclusive Care for the Elderly Central Iowa",
  "Program of All-Inclusive Care for the Elderly Central New York",
  "Program of All-Inclusive Care for the Elderly Greater New Orleans",
  "Program of All-Inclusive Care for the Elderly Kansas City",
  "Program of All-Inclusive Care for the Elderly Nebraska",
  "Program of All-Inclusive Care for the Elderly of Southwest Michigan Incorporated",
  "Progressive",
  "Progressive Classic Insurance Company",
  "Progressive Commercial Casualty Company",
  "Progressive Direct Insurance Company",
  "Progressive Max Insurance Company",
  "Progressive Northern Insurance Company",
  "Progressive Northwestern Insurance Company",
  "Progressive Preferred Insurance Company",
  "Progressive Premier Insurance Company",
  "Progressive Specialty Insurance Company",
  "Progyny",
  "Prominence Administrative Services",
  "Prominence Health Plan",
  "Prominence Health Plan of Nevada",
  "Prominence Health Plan of Texas",
  "Prominence HealthFirst of Florida",
  "Promise Health Plan",
  "Prompt Food Services, Incorporated",
  "Prospect Health Network",
  "Prospect Health Services Texas",
  "Prospect Medical Group",
  "Prospect Provider Group Rhode Island",
  "Prospect Sherman Oaks Medical Group",
  "Prosperity Life",
  "Protective Insurance Company",
  "Providence Business Services Oregon Alaska Industrial Hardware",
  "Providence Choice Option",
  "Providence Facility Claims",
  "Providence Health Assurance (Oregon Medicaid)",
  "Providence Health Assurance Medicaid",
  "Providence Health Assurance Medicare Supplement",
  "Providence Health Plan",
  "Providence Insurance and Administrative Services",
  "Providence PACE CA",
  "Providence Preferred PPO",
  "Providence Program of All-Inclusive Care for the Elderly California",
  "Providence Program of All-Inclusive Care for the Elderly, California",
  "Provident American Life & Health Insurance Company",
  "Provident American Life and Health Insurance Company",
  "Provident Life & Accident Insurance Company of America",
  "Provident Life & Casualty Ins. Co.",
  "Provident Life and Accident Ins. Co.",
  "Provident Preferred Network",
  "Provider Network of America (PNOA)",
  "Provider Partners Health Plan Illinois",
  "Provider Partners Health Plan Missouri",
  "Provider Partners Health Plan of Maryland",
  "Provider Partners Health Plan of North Carolina",
  "Provider Partners Health Plan of Ohio",
  "Provider Partners Health Plan of Texas",
  "Provider Partners Health Plan Pennsylvania",
  "Provider Partners Health Plans of Indiana",
  "Providrs Care Network",
  "Prudent Medical Group",
  "Prudential",
  "Prudential Insurance Company of America",
  "Prudential Overall Supply",
  "Pruitt Health Premier (North Carolina, South Carolina)",
  "Pruitt Health Premier North Carolina and South Carolina",
  "PruittHealth Premier",
  "PruittHealth Premier Georgia",
  "PSKW",
  "Psychealth Care Management LLC",
  "Public Employees Health Plan (PEHP)",
  "Public Employer Risk Management Association",
  "Publix Super Markets Incorporated",
  "Puget Sound Benefits Trust",
  "Puget Sound Electrical Workers",
  "Puget Sound Health Partners",
  "Purchased/Referred Care - Utah Navajo Health System",
  "Pure Fill Corporation",
  "Puritan Life Insurance",
  "QAD, Incorporated",
  "QBE General Casualty Company of Wisconsin",
  "QBE General Casualty Eden Prairie",
  "QBE General Casualty Farmers Union",
  "QBE General Casualty Freeport",
  "QBE General Casualty Indianapolis",
  "QBE General Casualty Simsbury",
  "QBE General Casualty Sun Prairie",
  "QBE General Casualty West Des Moines",
  "QPS Employment Group",
  "Quad Cities Community Health Plan",
  "Quad City Community Healthcare",
  "Quad City Community Healthcare (QCCH)",
  "Qual Medical Colorado",
  "Qual Medical Portland",
  "QualCare (Managed Care Systems)",
  "QualCare Independent Practice Association",
  "QualChoice Arkansas",
  "Qualexa Healthcare",
  "Quality Care Convalescent",
  "Quality Care Partners",
  "Quality Health Medical Group",
  "QualMed Colorado",
  "QualMed Portland",
  "Quartz",
  "Quartz Health Benefit Plans Corporation",
  "Quartz Health Insurance Corporation",
  "Quartz Health Plan Corporation",
  "Quartz Health Plan MN Corporation",
  "Quartz Health Solutions, Inc.",
  "Queen of Angels Hollywood",
  "Quest Behavioral Health",
  "Quest EAP",
  "Quest Employee Assistance Program",
  "QuestCare Medical Services",
  "Quick Croft, Incorporated",
  "QuikTrip",
  "QuikTrip Corporation",
  "R Kids Tire and Services, Incorporated",
  "R. A. Phillips Industries, Incorporated",
  "Rabb Brothers Trucking, Incorporated",
  "Rady Children's Health Network",
  "Rady Children's Hospital",
  "Rady's Children's Specialists of San Diego",
  "Raley's Family of Fine Stores",
  "Ralph Lauren",
  "Ram Mutual Insurance Company",
  "Ramona Manor Convalescent Hospital",
  "Rampart Insurance Company",
  "Ramsey County Minnesota",
  "Rancho Santiago Community College District California",
  "Randall County",
  "Randmark Incorporated",
  "Ravenswood Physician Associates",
  "Raypak, Incorporated",
  "RCH Protective SNCC",
  "Recology",
  "Red Oak Independent School District",
  "Redirect Health Administration",
  "Redlands Community Hospital",
  "Redlands Yucaipa Medical Group",
  "Rednab, Incorporated",
  "Redwood Coast PACE",
  "Redwood Fire and Casualty Insurance Company",
  "Redwood Health Services",
  "Reeser Enterprises, Incorporated",
  "Reflect Health",
  "Regence Blue Cross Blue Shield Oregon",
  "Regence Blue Shield Washington",
  "Regence BlueCross BlueShield of Oregon",
  "Regence BlueCross BlueShield Utah",
  "Regence BlueShield Idaho",
  "Regence BlueShield of Washington",
  "Regence Group Administrators",
  "Regency Employee Benefits",
  "Regent Insurance Company QBE Doing Business As",
  "Regent Medical Group Incorporated (Regent Family Practice of Glendale)",
  "Regional Care Incorporated",
  "Regis Brands",
  "Rehab Center of Beverly Hills",
  "Reimbursement Specialists Inc",
  "RelayHealth Integrated Solutions Rx",
  "Reliable Services, Incorporated",
  "Reliance Building Services, Incorporated",
  "Reliance Community Care Partners (RCCP)",
  "Reliance Health Maintenance Organization Incorporated Effective January 1, 2020",
  "Reliance Standard Life",
  "Reliance Standard Life Insurance",
  "Reliance Standard Life Insurance Company",
  "Reliastar (CA)",
  "Religious Order of Jehovah's Witness",
  "Religious Order of Jehovah's Witnesses",
  "Renaissance Life and Health Insurance Company of America",
  "Republic Franklin Insurance",
  "Republic Indemnity Company of America",
  "Republic Western Insurance Company",
  "ResCare Incorporated",
  "Reserve National Insurance",
  "Residential Services Group",
  "Resolute Forest Products",
  "ResourceOne Administrators",
  "Restaurant Reinsurance Limited",
  "Restoration Professionals",
  "Resurrection Physician Providers Group",
  "Return to Work (RTW)",
  "RevClaims",
  "Revived Medical Independent Practice Association",
  "Revived Medical IPA",
  "RevMed",
  "Rhode Island Medicaid",
  "Rhone Poulenc Incorporated",
  "Rick Concrete Construction",
  "Rick Hitch Plastering",
  "Rieth Riley Construction Company",
  "Right Care from Scott and White",
  "RightCare from Scott and White",
  "RightCare from Scott and White Healthplan",
  "Rio Grande",
  "Rios Southwest Medical Group",
  "Risk Administration Services",
  "Risk Enterprise Management",
  "Risk Reduction Strategies",
  "Risk Transfer Technologies Incorporated",
  "River City Medical Group",
  "River City Medical Group Senior",
  "River Road Independent School District (ISD)",
  "Riverport Insurance (Minnesota School Board Association)",
  "Riverport Insurance Company",
  "Riverside Health Maryland",
  "Riverside Medical Clinic",
  "Riverside Physicians Network",
  "RiverSpring Health Plans",
  "RMS Coordinated Operations",
  "RMSCO (Risk Management Services Company)",
  "Robert Mann Packaging, Incorporated",
  "Robstown Independent School District",
  "Rockford Mutual Insurance Company",
  "Rockwall Independent School District",
  "Rocky Mountain Colorado",
  "Rocky Mountain Health Plan",
  "Rocky Mountain Health Plans - Dental High & Low Plans",
  "Rocky Mountain HMO",
  "Rocky Mountain Life",
  "Rocky Mountain PACE (Program of All-Inclusive Care for the Elderly)",
  "Rose Garden Guest House",
  "Rosewood Equipment",
  "Rossi Concrete Incorporated",
  "Roth Staffing Companies (Carl Warren)",
  "Rothenberger USA, Incorporated",
  "Rountree Plumbing and Heating, Incorporated",
  "Royal Health Care (Extended Care Managed Treatment Center)",
  "Royal Health Care (Extended Care MTC)",
  "Royal Neighbors of America",
  "RSC Insurance Services Ltd.",
  "Rubicon Health Group",
  "Rural Special District Insurance Program",
  "Rush Prudential",
  "Rush Prudential Health Maintenance Organization",
  "Rush Prudential HMO",
  "Ryder Services Incorporated",
  "S and S Healthcare Strategies",
  "S USA Life Insurance Company",
  "S&S HealthCare Strategies",
  "SA Recycling LLC",
  "Sacramento IBS, Incorporated",
  "Safeco Insurance",
  "Safety Kleen Corporation",
  "Safety-Kleen Corporation",
  "Sagamore Health Network",
  "Sage",
  "Sage Technologies",
  "Saigon Medical Group Incorporated",
  "Saint Agnes Medical Group",
  "Saint John's Health Clinic",
  "Saint Johns Health Clinic",
  "Saint Joseph Heritage Healthcare",
  "Saint Louis County",
  "Saint Louis County Minnesota",
  "Saint Marys Independent Practice Association",
  "Salt Lake City Corporation",
  "Sam Kane Beef Processors Incorporated",
  "Samaritan Advantage",
  "Samaritan Choice Plans",
  "Samaritan Commercial Plan",
  "Samaritan Given",
  "Samaritan Health Plans",
  "SAMBA Health Benefit Plan",
  "SAMBA TeleHealth",
  "Samera Health",
  "San Angelo Independent School District (ISD)",
  "San Bernardino City Unified School District",
  "San Bernardino County Superintendent of Schools California",
  "San Bernardino Medical Group",
  "San Diego Community College District California",
  "San Diego County (Ryan White Care Act)",
  "San Diego County Medical Services (CMS)",
  "San Diego County Medical Services (County Medical Services)",
  "San Diego County Physician Emergency Services",
  "San Diego Hospice and Institute for Palliative Medicine",
  "San Diego Metropolitan Transit System",
  "San Diego Metropolitan Transit System (SCHIP Liability)",
  "San Diego PACE",
  "San Diego Physicians Medical Group",
  "San Diego Program of All-Inclusive Care for the Elderly",
  "San Diego Transit Corporation",
  "San Diego Trolley Incorporated",
  "San Francisco Battery, Incorporated",
  "San Francisco Health Plan",
  "San Francisco Municipal Transportation Agency",
  "San Joaquin County",
  "San Joaquin Health Administrators",
  "Sana Benefits",
  "SanData",
  "Sandhills Center",
  "Sandia Triple Optional Plus",
  "Sands Bethworks Gaming - Dental",
  "Sanford Health Medicare Advantage",
  "Sanford Health Plan",
  "Sansum Clinic IPA",
  "Santa Barbara Regional Health Authority",
  "Santa Barbara Select",
  "Santa Clara County Independent Practice Association Health Maintenance Organization",
  "Santa Clara County IPA PPO",
  "Santa Clara County Office of Education",
  "Santa Clara Family Health Plan",
  "Santa Clara Family Health Plan - Dental",
  "Santa Clara Valley Transportation Authority",
  "Santa Fe Extruders, Incorporated",
  "Santa Monica Unite Here Health Benefit Plan",
  "Sante Community Medical Centers",
  "Sante Community Physicians Medical Group Corporation",
  "Sante Health",
  "Sante Health System and Affiliates",
  "Santé Community Medical Centers",
  "Sanus Health Maintenance Organization Preferred Provider Organization St. Louis",
  "Satellite Dialysis Centers, Incorporated",
  "Saudi Health Mission",
  "SCAN Health Maintenance Organization California",
  "SCAN Health Plan Arizona",
  "SCAN Health Plan California",
  "SCAN HMO California",
  "Schaller Anderson Mercy Care Plan",
  "Schlumberger Technology",
  "Schneider Gain",
  "Schnuck Market Incorporated",
  "SCHS Alta Global Medical Care Group",
  "SCIF Arizona",
  "Scion Dental",
  "Scion Dental Commercial",
  "Scion Gateway Health Plan",
  "Scott & White Health Plan",
  "Scott and White Health Plan",
  "Scotts Miracle-Gro Company",
  "Scripps Health Plan Management Services Organization",
  "Scripps Health Plan Services",
  "SeaBright",
  "SeaBright Insurance Company",
  "Seaside Health Plan",
  "Seaview IPA",
  "SECUR Health Plan",
  "Secure Health",
  "SecureOne",
  "Securian",
  "Securian Dental",
  "Security Administrative Services",
  "Security Health Plan",
  "Security Life Insurance Company of America",
  "Sedgwick",
  "Sedgwick Cargill Incorporated",
  "Sedgwick Claims Management Services",
  "SeeChange Health Insurance",
  "Seeno Construction (Chartis)",
  "Seeno Homes",
  "SEIU Local 1 Cleveland Welfare Fund",
  "Sela Healthcare",
  "Select Administrative Services (SAS)",
  "Select Benefit Administrators",
  "Select Benefit Administrators (Des Moines Iowa)",
  "Select Benefit Administrators Incorporated",
  "Select Benefit Administrators Of America (Ashland Wisconsin)",
  "Select Energy Services",
  "Select Health",
  "Select Health Inc.",
  "Select Health South Carolina",
  "Select Health Utah",
  "Select Senior Clinic",
  "Select Staffing Koosharem",
  "Select Staffing Real Time Staffing",
  "Select Staffing Remedy",
  "Select Staffing Select Remedy and Westaff",
  "SelectCare Health Plan Health Maintenance Organization (North Texas)",
  "SelectCare Health Plan Health Maintenance Organization (Texas and Oklahoma Panhandle)",
  "SelectCare of Texas (Beaumont)",
  "SelectCare of Texas (Kelsey-Seybold)",
  "SelectCare of Texas (MCA)",
  "SelectCare Texas (Heritage Physicians Network)",
  "SelectCare Texas (Houston)",
  "SelectCare Texas Alliance (Kelsey-Seybold Greater Texas Physicians Alliance)",
  "Selective",
  "Selective Insurance (Work Comp)",
  "Self Insured Benefit Administrators",
  "Self-Insured Schools of California",
  "Self-Insured Schools of California (SISC)",
  "Self-Insured Services Company",
  "Selman and Company",
  "Selman Breitman",
  "Selman TRICARE",
  "Seminole Independent School District (ISD)",
  "Seminole Tribe of Florida",
  "Sempra Energy Employee Care Services",
  "Senior Care Action Network Health Plan Arizona",
  "Senior Care Partners PACE",
  "Senior Dimensions",
  "Senior Health Company Professional",
  "Senior Health Partners",
  "Senior Network Health",
  "Senior Whole Health",
  "Senior Whole Health Massachusetts",
  "Senior Whole Health New York",
  "Sentara Health Management",
  "Sentara Health Plans",
  "Sentinel Insurance Company Ltd",
  "Sentinel Management Services",
  "Sentinel Security Life Insurance",
  "Sentry Asset Management",
  "Sentry Auto",
  "Sentry Insurance",
  "Seoul Medical Group",
  "Sequoia Health Independent Practice Association",
  "Sequoia Health IPA",
  "Sequoia Health Plan (Tulare-Kings County)",
  "Serendipity Land Yachts",
  "Service Employees International Union Local 1 Cleveland Welfare Fund",
  "Service Lloyds Insurance Company",
  "Seton Employee Plan Active and Archive",
  "Seton Health Plan (Children's Health Insurance Program)",
  "Seton Star",
  "Seven Corners",
  "SFM Mutual Insurance Company",
  "SFN Group Mergis Group",
  "SFN Group Sourceright Solutions",
  "SFN Group Spherion",
  "SFN Group Tatum",
  "SFN Group Technisource",
  "SFN Group Todays Office Professionals",
  "Share HealthCare",
  "Shared Health",
  "Shared Health Mississippi",
  "Sharp Community Medical Group",
  "Sharp Health Plan",
  "Sharp Rees-Stealy Medical Group",
  "Sharyland Independent School District",
  "Shasta Administrative Services",
  "Shaw's Star Market",
  "Shaws StarMarket",
  "Sheet Metal Workers",
  "Shenandoah Life Insurance",
  "Shenandoah Life Insurance Company",
  "Sheppard Mullin Richter and Hampton",
  "Show Me Health Administrators LLC",
  "Sidecar Health",
  "Sieba",
  "Sierra Health and Life",
  "Sierra Health and Life - Encounters",
  "Sierra Health Services",
  "Sierra Medical Group (Regal)",
  "Sierra Nevada Medical Association",
  "Sierra Nevada Memorial",
  "Signature Advantage",
  "Significa Benefit Services",
  "Significa Benefits Services Incorporated",
  "SIHRTE",
  "Silberberger Engineering",
  "Silsbee Independent School District (ISD)",
  "Silver Cross Managed Care Organization",
  "Silver Star PACE",
  "SilverSummit",
  "Simple",
  "SimplePay",
  "Simply Healthcare",
  "Simpra Advantage Alabama",
  "Simpra Advantage Inc.",
  "SISCO",
  "SISCO (Worker's Compensation)",
  "SisCo Benefits",
  "Site Studios, Incorporated",
  "SKB Corporation",
  "Slaton Independent School District (ISD)",
  "Slovanska Podporujici Jednota Statu Texas (SPJST)",
  "Slovenian Catholic Union of America (KSKJ Life)",
  "Small World Toys",
  "Smart & Final",
  "Smart and Final",
  "SMHA",
  "Smith Administrators",
  "Smith Emery Company",
  "Smithcare, Incorporated",
  "Smoky Mountain Local Management Entity Managed Care Organization",
  "SMW Local 263 Health & Welfare Fund",
  "Snap-on Incorporated",
  "Snedeker Risk Management",
  "Snyder Independent School District (ISD)",
  "Sol's Brake Supply, LLC",
  "Solidarity HealthShare",
  "Solis Health Plans",
  "Solstice Benefits",
  "Solvay America Incorporated",
  "Somerset Independent School District (ISD)",
  "SOMOS (Anthem New York)",
  "SOMOS Independent Practice Association (Emblem Health)",
  "Sonder Health Plans",
  "Sonic Automotive Incorporated",
  "Sonoma Valley Health",
  "Sonoma Valley Healthcare District",
  "SoonerCare",
  "SOS Metals, Incorporated",
  "Sound Health",
  "Soundpath Health",
  "South Atlantic Medical Group",
  "South Bay Hotel Employees Restaurant Employees Health Trust",
  "South Carolina Healthy Connections",
  "South Central Preferred",
  "South Coast Area Transit (California)",
  "South Country Health Alliance",
  "South Dakota All Women Count",
  "South Dakota Medicaid - STARS",
  "South Tahoe Refuse",
  "Southeast Leasing (Packard Claims Administration)",
  "Southeast Michigan PACE",
  "Southeast Michigan Program of All-Inclusive Care for the Elderly",
  "Southeastern Indiana Health Organization",
  "Southern California Children's Healthcare Network",
  "Southern California Dairy",
  "Southern California Edison",
  "Southern California Health Systems Alta Pioneer by MedPoint",
  "Southern California Lumber",
  "Southern California Risk Management",
  "Southern California UFCW Unions and Food Employers",
  "Southern California United Food and Commercial Workers Unions and Food Employers",
  "Southern Illinois Healthcare Association",
  "Southern Textile Recycling Incorporated (California)",
  "Southland Advantage Medical Group Incorporated",
  "Southland Benefit Solutions LLC (Canopy Vision)",
  "Southland Independent School District (ISD)",
  "Southland San Gabriel Valley",
  "Southside Independent School District (ISD)",
  "Southwest Airlines (Southwest Airlines)",
  "Southwest Airlines (SWA)",
  "Southwest Gas Corporation",
  "Southwest Michigan Behavioral Health Mental Health",
  "Southwest Michigan Behavioral Health Substance Use Disorder",
  "Southwest Physicians Group",
  "Southwest Service Administrators",
  "Southwest Service Life",
  "Southwestern Bell (Medical)",
  "Spearman Independent School District (ISD)",
  "Special Agents Mutual Benefit Association",
  "Special Agents Mutual Benefit Association Health Benefit Plan",
  "Specialty Care Program",
  "Specialty Coffee",
  "Specialty Team Plastering, Incorporated",
  "Spectera UnitedHealthcare Vision",
  "Spectrum Administrators Incorporated Third Party Administrator (Allenton, Pennsylvania)",
  "Spectrum Administrators Incorporated TPA (Allenton, Pennsylvania)",
  "Spectrum Health",
  "Spencer Stuart (Advanced RISC Machines Ltd)",
  "Spencer Stuart (ARM Ltd)",
  "Spina Bifida VA Health Administration Center",
  "Spooners Woodworks",
  "Spring Air California Deluxe Bedding",
  "Springfield Insurance Company",
  "Springtown Independent School District (ISD)",
  "Sprouts Farmers Market Incorporated",
  "St Luke Health Plan Inc",
  "St Pauls PACE",
  "St. Francis - Allcare by MedPoint",
  "St. Francis - HCLA by MedPoint",
  "St. Francis - Health Care Los Angeles By Medpoint",
  "St. Francis Independent Practice Association",
  "St. Joseph Heritage Healthcare",
  "St. Joseph Heritage Medical Group",
  "St. Joseph Hospital Affiliated",
  "St. Jude Affiliated Physicians",
  "St. Jude Heritage Medical Group",
  "St. Mary High Desert",
  "St. Paul Insurance",
  "St. Peter Medical Group Incorporated",
  "St. Rose Hospital",
  "St. Therese Physician Association",
  "St. Vincent Catholic Medical Center",
  "St. Vincent Noble Tri-Cities Independent Practice Association",
  "Staff Benefits Management Administration (SBM)",
  "Standard Forwarding",
  "Standard Fruit and Vegetable",
  "Standard Insurance Company Oregon",
  "Standard Life & Casualty Insurance Company",
  "Standard Life and Accident Insurance Company",
  "Stanley Pest Control, Incorporated",
  "Stanley Steemer International Incorporated",
  "Stanley Works Incorporated",
  "Stanley Works, Incorporated",
  "Stant Corporation",
  "Starmed Administrators",
  "Starmount Dental",
  "Starr Companies Insurance Group",
  "State Accident Insurance Fund (SAIF) Corporation",
  "State and School Employees' Health Insurance",
  "State Compensation Insurance Fund (SCIF)",
  "State Compensation Insurance Fund Arizona",
  "State Farm",
  "State Farm Group Medical & Individual Health Ins Companies",
  "State Farm Insurance Companies",
  "State Government Insurance Corporation",
  "State Mutual",
  "State Mutual Med Supplement",
  "State Mutual-Lincoln Novation",
  "State of Idaho Department of Health and Welfare",
  "State of Idaho Women's Health Check",
  "State of Kansas",
  "State of Minnesota Department of Employee Relations",
  "State of North Carolina",
  "State Office of Risk Management",
  "Staywell",
  "StayWell Guam",
  "Staywell Kids",
  "Stedi Insurance Discovery",
  "Stedi Test Payer",
  "Stewart C. Miller & Company",
  "Stewart C. Miller and Company",
  "Stimson Lumber Company Montana Oregon Washington",
  "Stirling Benefits (Stirling & Stirling)",
  "Stockdale Independent School District (ISD)",
  "Stonebridge Life Insurance Company (Cedar Rapids Iowa)",
  "Stonebridge Life Insurance Company (Cedar Rapids)",
  "Stonebridge Life Insurance Company (Valley For)",
  "Stonebridge Life Insurance Company (Valley Forge Pennsylvania)",
  "Stones River Regional IPA Amerivantage",
  "Stones River Regional IPA- Wellcare",
  "Stonington Country Club",
  "Stratford Independent School District (ISD)",
  "Streamline Imaging - Streamline PT",
  "Striko Dynarad Corporation",
  "Student Insurance",
  "Student Resources (UnitedHealthcare)",
  "Styles for Less Corporation (California Only)",
  "SummaCare Health Plan",
  "Summit Administrators Incorporated",
  "Summit America Insurance Services, Inc",
  "Summit Community Care",
  "Summit Health Limited",
  "Summit Health Ltd",
  "Summit Holdings",
  "Sun Life",
  "SUN LIFE FINANCIAL - PHOENIX HOME LIFE",
  "Sun Life Financial/Phoenix Home Life",
  "Sun Mar Healthcare",
  "SunAmerica Life Insurance Company",
  "Sunflower Health Plan",
  "Sunray Independent School District (ISD)",
  "Sunrise Country Club",
  "Sunrise PACE",
  "Sunshine Health",
  "SunTrust Bank",
  "Sunz Insurance Company",
  "Superior Access Insurance Services",
  "Superior Choice Medical Group",
  "Superior HealthPlan",
  "Superior Industries International Incorporated",
  "Superior Insurance Services",
  "Superior Ready Mix",
  "Superior Vision Services",
  "Supreme Court of California",
  "Surego Administrative Services",
  "Surest",
  "Surface Mount Distribution",
  "Surface Protection Industries",
  "Surgery One Independent Practice Association",
  "Surgery One IPA",
  "Sutter Connect - Central Valley Med Group",
  "Sutter Connect - Sutter Gould Medical Foundation (SGMF)",
  "Sutter Connect East Bay Region Hospitals",
  "Sutter Connect Independent Physicians (SIP)",
  "Sutter East Bay Medical Foundation",
  "Sutter Health",
  "Sutter Health Aetna",
  "Sutter Health Plus",
  "Sutter Medical Foundation",
  "Sutter Medical Group (SMG)",
  "Sutter Medical Group of the Redwoods",
  "Sutter Pacific Medical Foundation",
  "Sutter Select",
  "Sutter Senior Care",
  "Sutter West Bay Medical Group",
  "Sutter West Medical Group (SWMG)",
  "Swedish Covenant Hospital",
  "Swift Transportation",
  "SYMETRA",
  "T H E Insurance",
  "TakeCare Insurance Company",
  "Talbert Medical Group",
  "Tall Tree Administrators",
  "Tan Medical Group",
  "Target Media Partners",
  "Tarrant Appraisal District",
  "Taylor Benefit Resource Incorporated",
  "Taylor Benefits",
  "TCC",
  "TD Tile",
  "TDS SRRIPA AMERIVANTAGE",
  "TDS SRRIPA WELLCARE",
  "Teachers Health Trust",
  "Team Choice AlphaCare Gold",
  "Teamsters (Utah, Idaho, Montana) Group Benefits Administrators",
  "Teamsters Joint Council #83 Of VA",
  "Technology Insurance Company",
  "Teddy Health",
  "Telamon",
  "Telehealth Options , LLC",
  "Temecula Valley Medical Group",
  "Tempest Technologies (UCS BASI)",
  "Tempest Technologies (University of California Santa Barbara Basic Automated Services Interface)",
  "Tempo Industries, Incorporated",
  "Tenn Dent",
  "Tervist",
  "Tethys Health Ventures",
  "Texan Plus (Beaumont)",
  "Texan Plus (Houston)",
  "Texan Plus (Kelsey-Seybold)",
  "Texan Plus (Southeast Texas Area)",
  "Texan Plus-SelectCare of Texas (Kelsey-Seybold)",
  "Texas A&M",
  "Texas Agricultural Benefit Administrators",
  "Texas Agricultural Cooperative Trust (TACT)",
  "Texas Association of School Boards (TASB)",
  "Texas Builders Insurance Company",
  "Texas Children's Health Plan",
  "Texas Children's Health Plan (Medicaid) STAR & STAR Kids",
  "Texas First Health Plan (North Texas)",
  "Texas First Health Plan North Texas",
  "Texas First Health Plan North Texas (SelectCare Health Plan Health Maintenance Organization (Topa))",
  "Texas First Health Plans (Tiopa)",
  "Texas First Health Plans (Topa)",
  "Texas Health Aetna",
  "Texas HealthSpring",
  "Texas Independence Health Plan",
  "Texas Independence Health Plan Effective January 1, 2020",
  "Texas Municipal League",
  "Texas Municipal League (TML) Intergovernmental Risk Pool",
  "Texas Mutual Insurance",
  "Texas Political Subdivisions Joint Self-Insurance Fund",
  "Texas Political Subdivisions Joint Self-Insurance Fund (JSIF)",
  "Texas Roadhouse Incorporated",
  "Texas Small Business Pool",
  "TexasPlus Southeast",
  "The Alliance",
  "The Auto Club Group",
  "The Basics At Jan Werner PACE",
  "The Benefit Group Incorporated",
  "The Boon Group",
  "The Care Network The Savannah Business Group",
  "The Cascade PACE, Inc., DBA Thome PACE",
  "The City of Odessa",
  "The Colorado Purchase Alliance",
  "The Dental Network of Maryland",
  "The Gap Incorporated",
  "The Garlic Company",
  "The General Insurance",
  "The Guardian Life Insurance Company of America",
  "The Hartford",
  "The Hartford Life and Annuity Insurance Company",
  "The Health Exchange Cerner Corporation",
  "The Health Plan of West Virginia",
  "The Health Plan of Western Illinois",
  "The Health Plan of Western Illinois (HOWI)",
  "THE Insurance",
  "The Jones Financial Companies Limited Liability Partnership",
  "The Jones Financial Companies LLP",
  "The Loomis Company",
  "The Macaluso Group",
  "The Men's Warehouse Incorporated",
  "The Men's Wearhouse Incorporated",
  "The Mutual Group",
  "The Physicians Alliance Corporation",
  "The Preferred HealthCare System PPO",
  "The Preferred Healthcare System Preferred Provider Organization",
  "The Salvation Army",
  "The Scotts Company",
  "The Ullico Family of Companies",
  "The Union Labor Life Insurance Company Family of Companies",
  "The University of Texas Medical Branch 3 Share Program",
  "The Venetian - Dental",
  "The Zenith",
  "The Zero Card",
  "TheraPhysics",
  "Therapy Direct Network",
  "Therapy Network of Puerto Rico",
  "Thomas H. Cooper & Company",
  "Thomas Staffing Services Incorporated Venturi Staffing",
  "Three Rivers Administrative Services - Three Rivers Health Plans",
  "Three Rivers Preferred",
  "Thrivent Financial Aid Association for Lutheran Medicare",
  "Thrivent Financial for Lutherans",
  "Tidewater Marine Western",
  "Tift Regional",
  "Tim's Auto Paint and Supply, Incorporated",
  "TLC Benefit Solutions",
  "TMG Health Insurance",
  "TMHP (LTC)",
  "TMHP(Acute)",
  "TMHP/Texas Medicaid & Health Partnership (Acute)",
  "TMHP/Texas Medicaid & Health Partnership (CHIP)",
  "TMHP/Texas Medicaid & Health Partnership (LTC)",
  "Today's Health",
  "Today's Options (American Progressive and Pyramid Health)",
  "Today's Options (American Progressive and Pyramid Life)",
  "Tom's Truck Center, Incorporated",
  "Tomco Auto Products, Incorporated",
  "Tomdan Enterprises",
  "Topa Insurance Company",
  "Topanga Roscoe Corporation",
  "Torrance Hospital Independent Practice Association",
  "Torrance Hospital IPA",
  "Torrance Memorial",
  "Total Community Care",
  "Total Petroleum Incorporated",
  "Total Plan Concepts",
  "Total Plan Services",
  "Total Plumbing Heating and Air",
  "Total Senior Care",
  "Touchpoint Solutions Touchpoint CRM",
  "TouchPoint Solutions TouchPoint Customer Relationship Management",
  "Touchstone Health Professional Service Organization",
  "Touchstone Health PSO",
  "Tower Energy Group",
  "Town of Colma (California)",
  "Tractor Supply Company",
  "TrailWest Bank (UCS Bank)",
  "TrailWest Bank (United Community Systems Basic)",
  "Trans Valley Transport",
  "TransactRX",
  "Transamerica Financial Life Insurance Company - Long Term Care",
  "TransAmerica Life Insurance (Little Rock, AR)",
  "TransAmerica Life Insurance Company",
  "Transchoice Key Benefit Administrators",
  "Transpacific Development Company",
  "Transplant Associates Baylor Billing (Synergen)",
  "Transportation Communications Union Los Angeles Metropolitan Transit Authority",
  "Transwestern Insurance Administrators Incorporated",
  "Travelers",
  "Travelers Auto",
  "Travis County MAP MediView",
  "Tres Health",
  "Tri Valley Orthopedic and Sports Medicine",
  "Tri-City Healthcare District",
  "Tri-City Linen Supply",
  "Tri-City Uniform",
  "Tri-State Insurance Company",
  "Triad Healthcare",
  "Trialcard",
  "Tribado",
  "Tribute (SelectCare Oklahoma)",
  "Tribute Health Plan",
  "Tribute Health Plan Oklahoma",
  "Tricare (CHAMPUS)",
  "TRICARE Civilian Health and Medical Program of the Uniformed Services",
  "Tricare Dental Plan (United Concordia Companies",
  "Tricare Dental Plan (United Concordia Companies, Inc.)",
  "TRICARE East",
  "TRICARE for Life",
  "Tricare North",
  "TRICARE Overseas",
  "Tricare Retiree Dental",
  "Tricare South",
  "Tricare West",
  "TRICARE West Region",
  "Trillium Community Health Plan",
  "Trillium Health Resources - Behavioral Health",
  "Trillium Health Resources - Physical Health",
  "Trillium Medicare 2016",
  "Trillium Staffing Solutions",
  "Trilogy Health Solutions",
  "Trilogy Health Solutions Incorporated",
  "Trinity Health PACE",
  "Trinity Universal Insurance",
  "Triple A",
  "Triple-S Advantage",
  "Triplefin LLC",
  "Tristar Benefit Administrators",
  "TRISTAR Risk Management",
  "TriState Benefit Solutions (TriHealth Physician Solutions)",
  "Triton HealthCare Partners",
  "Trivalley Medical Group Corporation",
  "TriWest Healthcare Alliance",
  "Triwest Tricare",
  "Troy Medicare",
  "Tru Blue Third Party Administrator",
  "Tru Community Care",
  "Truck Insurance Exchange (Commercial Only)",
  "True Blue Third Party Administrator",
  "True Health New Mexico",
  "True World Foods, Incorporated",
  "Truecare Mississippi Medicaid",
  "Truli for Health",
  "Trumball Insurance Company",
  "Trust Eligibility Network",
  "Trusteed Plan Services Corporation",
  "Trustmark Insurance Company",
  "Trustmark Small Business Benefits",
  "Tuality Health Alliance",
  "Tuality Health Select",
  "Tucker Administrators",
  "Tucson Unified School District Workers' Compensation",
  "Tufts Health Plan",
  "Twin Cities Fire Insurance Company",
  "Tyson Foods Incorporated",
  "U.S. Benefits",
  "U.S. Department of Labor",
  "U.S. Department of Labor (DOL) - Department of Energy",
  "U.S. Department of Labor (DOL) Department of Energy",
  "U.S. Family Health Plan (USFHP) Texas and Louisiana",
  "U.S. National Resources (AIG Risk Management)",
  "U.S. Networks and Administrative Services",
  "U.S. Sugar Corporation",
  "U.S. Wireless Corporation",
  "UC Care (University of California)",
  "UC Health Plan Administrators",
  "UCARE Individual and Family Plan",
  "Ucare Minnesota",
  "UCARE of Minnesota",
  "UCLA Medical Group",
  "UCLA Medicare Advantage Plan",
  "UCS (Wagner Meinert)",
  "UCS Basi Golden Eagle Construction",
  "UCS Basi Whitefish Credit Union",
  "UCS Basic Golden Eagle Construction",
  "UCS Beneficial Innovation",
  "UCS Benovation",
  "UCS Hockenbergos Equipment",
  "UCS Masonry Industry Trust",
  "UCS Nebraska Plastics Group",
  "UCS RTG Medical Group",
  "UCS Winston Hospitality",
  "Udelhoven Health Plan",
  "UFCW Local 655 Health and Welfare Fund",
  "UFCW National Fund",
  "UFT Welfare Fund",
  "UHA Health Insurance",
  "UHP Management",
  "UICI Administrators",
  "Ullico Incorporated (Valley Forge",
  "ULLICO Incorporated (Valley Forge Pennsylvania)",
  "Ultimate Health Plan",
  "Ultra Benefits",
  "UMC Health Plan (Lubbock)",
  "Umpqua Health Alliance",
  "UMR (UMR Wausau)",
  "UMR (United Medical Resources Onalaska)",
  "UMR (United Medical Resources Wausau)",
  "Underwriters Safety and Claims",
  "UniCare",
  "UniCare (Medicaid Reclamation)",
  "UniCare Dental",
  "UniCare Special Accounts",
  "Unified Comprehensive Services (The City of East Chicago)",
  "Unified Group Services",
  "Unified Health Plan TPA",
  "Unified Health Services",
  "Unified Independent Practice Association",
  "Unified Life Insurance",
  "Unified Physicians Network",
  "UnifiHealth",
  "Uniformed Services Family Health Plan St. Vincent Catholic Medical Centers of New York",
  "Unigard Insurance Company QBE Doing Business As",
  "Union Insurance Company",
  "Union Insurance Company of Providence",
  "Union Labor Life Insurance Company",
  "Union Pacific Railroad Employees Health Systems",
  "UNION SECURITY INSURANCE COMPANY",
  "Unite Health Share Ministries (UHSM)",
  "Unite Here Health Hospitality",
  "Unite Here Health Hospitality (UHH Hospitality)",
  "Unite Here Health – Las Vegas",
  "United Agriculture Benefit Trust",
  "United American Insurance Company",
  "United Americhoice Nebraska",
  "United Americhoice Wisconsin",
  "United Behavioral Health",
  "United Benefit Advisors",
  "United Care Medical Group (UCMG) (Regal)",
  "United Claim Solutions",
  "United Claim Solutions Insight Benefit Administrators",
  "United Clinical Services Hockenbergos Equipment",
  "United Community Services (The City of East Chicago)",
  "United Concordia - Dental Plus",
  "United Concordia Companies Inc",
  "United Concordia Federal Employees Program",
  "United Concordia Fee-for-Service",
  "United Contract Services (Coeur Leonard Holding Company)",
  "United Contractors and Staff Masonry Industry Trust",
  "United Convalescent",
  "United Dominion Realty Trust",
  "United El Segundo, Incorporated",
  "United Financial Casualty Company",
  "United Fire",
  "United Food and Commercial Workers Local 1000 & Kroger Dallas Health & Welfare Plan",
  "United Food and Commercial Workers National Fund",
  "United Food and Commercial Workers of Central Ohio",
  "United Food and Commercial Workers Unions and Food Employers Benefits Fund",
  "United Group Programs",
  "United Healthcare",
  "United HealthCare Community Plan Arizona",
  "United Healthcare Community Plan Michigan (Great Lakes Health Plan)",
  "United HealthCare Community Plan Missouri",
  "United HealthCare Dental",
  "United Healthcare Facets Pittsburgh Community & State",
  "United HealthCare Global (Inside U.S.)",
  "United HealthCare Ohio Medicaid Managed Care Entity (MCE)",
  "United HealthCare Secure Horizons Medicare",
  "United HealthCare SecureHorizons Medicare",
  "United Healthcare West Encounters (Pacificare)",
  "United Medical Alliance",
  "United Medical Resources (UMR Onalaska)",
  "United Medical Resources - Cincinnati",
  "United Medical Resources - Harrington",
  "United Medical Resources - San Antonio",
  "United Mine Workers of America Health and Retirement Funds",
  "United of Omaha",
  "United Physicians International (UPI)",
  "United Resource Networks",
  "United Security Health and Life",
  "United Self-Insured Services",
  "United Services Automobile Association (USAA)",
  "United Services Automobile Association Medicare Supplemental",
  "United States Cold Storage",
  "United States Department of Labor - Energy",
  "United States Family Health Plan",
  "United States Fire Insurance Company",
  "United States Health and Life Insurance Company",
  "United States Health and Life Insurance Company (USHL)",
  "United Surgical Partners International",
  "United Wisconsin Insurance Company",
  "UnitedHealthcare",
  "UnitedHealthcare - Harvard Pilgrim",
  "UnitedHealthcare - National Drug Code Home Infusion Specialty Pharmacy Claims - Claims Only",
  "UnitedHealthcare / Definity Health Plan",
  "UnitedHealthcare / Empire Plan",
  "UnitedHealthcare / Peoples Health",
  "UnitedHealthcare / UnitedHealthcare of the Mid-Atlantic, MD IPA, Optimum Choice and MAMSI Life and Health",
  "UnitedHealthcare / UnitedHealthcare Plan of the River Valley",
  "UnitedHealthcare All Savers Insurance",
  "UnitedHealthcare Community Care Indiana",
  "UnitedHealthcare Community Plan",
  "UnitedHealthcare Community Plan (AmeriChoice Pennsylvania Primary Care Provider)",
  "UnitedHealthcare Community Plan - Kansas (KanCare)",
  "UnitedHealthcare Community Plan - KS (KanCare)",
  "UnitedHealthcare Community Plan - Michigan",
  "UnitedHealthcare Community Plan - Michigan, Utah",
  "UnitedHealthcare Community Plan - South Carolina",
  "UnitedHealthcare Community Plan - South Carolina (Formerly Known As Unison)",
  "UnitedHealthcare Community Plan - Utah",
  "UnitedHealthcare Community Plan / KS - KanCare",
  "UnitedHealthcare Community Plan / UnitedHealthcare Dual Complete",
  "UnitedHealthcare Community Plan / UnitedHealthcare Dual Complete - Oxford Medicare Network",
  "UnitedHealthcare Community Plan / UnitedHealthcare Long Term Care",
  "UnitedHealthcare Community Plan Kansas (KanCare)",
  "UnitedHealthcare Community Plan Michigan (Great Lakes Health Plan)",
  "UnitedHealthcare Community Plan New Jersey",
  "UnitedHealthCare Community Plan of Tennessee",
  "UnitedHealthcare Community Plan South Carolina (Unison)",
  "UnitedHealthcare Community Plan Tennessee",
  "UnitedHealthCare Community Plan Tennessee (AmeriChoice Tennessee TennCare Secure Plus Complete)",
  "UnitedHealthcare Community Plan Texas",
  "UnitedHealthcare Community Plan TN",
  "UnitedHealthcare Definity Health Plan",
  "UnitedHealthcare Facets Detroit - Community and State",
  "UnitedHealthcare Freedom Insurance Company",
  "UnitedHealthcare Level Funded /UnitedHealthcare Level Funded / AK, AL, AR, AZ, CA, CO, CT, DC, DE, FL, ID, IN, MA, ME, MN, MT, ND, NH, NJ, NM, NV, NY, OR, PA, SD, TX, UT, VA, WA, WY",
  "UnitedHealthcare Life Insurance Company",
  "UnitedHealthcare MAHP Maryland Individual Practice Association Optimum Choice MAMSI",
  "UnitedHealthcare Medicare / Care Improvement Plus (CIP), XLHealth",
  "UnitedHealthcare Medicare / UnitedHealthcare Chronic Complete",
  "UnitedHealthcare Medicare / UnitedHealthcare Group Medicare Advantage",
  "UnitedHealthcare Medicare / UnitedHealthcare MedicareComplete",
  "UnitedHealthcare Medicare / UnitedHealthcare MedicareDirect",
  "UnitedHealthcare Medicare / UnitedHealthcare Nursing Home Plan",
  "UnitedHealthcare Medicare Solutions UHC Chronic Complete (Evercare)",
  "UnitedHealthcare Medicare Solutions UHC MedicareComplete (SecureHorizons)",
  "UnitedHealthcare Ovations (AARP)",
  "UnitedHealthcare Ovations Insurance Solutions (AARP)",
  "UnitedHealthcare Oxford",
  "UnitedHealthcare Plan of the River Valley",
  "UnitedHealthcare Shared Services - UHSS",
  "UnitedHealthcare Vision",
  "UnitedHealthcare West (PacifiCare Arizona Colorado Nevada)",
  "UnitedHealthcare West (PacifiCare Arizona, Colorado, Nevada)",
  "UnitedHealthcare West / UnitedHealthcare of CA, OK, OR, TX, WA and PacifiCare of AZ, CO, NV",
  "UnitedHealthOne",
  "UnitedHealthOne Golden Rule",
  "UnitedHealthOne PacifiCare Life and Health",
  "UnitedHealthOne UnitedHealthcare Life Insurance Company",
  "Unitrin Auto and Home Insurance",
  "Unitrin Direct Auto Insurance",
  "Unitrin Direct Property and Casualty Company",
  "Unitrin Safeguard Insurance",
  "Unity Health Insurance",
  "Unity Health Partners",
  "Univera",
  "Univera Community Health",
  "Univera Health Care Plan ChoiceCare (Buffalo)",
  "Univera Healthcare",
  "Univera Healthcare Hospital",
  "Univera Healthcare Plan ChoiceCare (Buffalo)",
  "Univera PPO",
  "Univera SSA WNY",
  "Universal American",
  "Universal Benefits Corporation",
  "Universal Benefits Corporation Cedar Rapids",
  "Universal Fidelity Administrators Company",
  "Universal Flooring Systems",
  "Universal Health Fellowship",
  "Universal Healthcare IPA",
  "University Clinical Health Solutions (Coeur Leonard Holding Company)",
  "University Credit System Basic Security Administration Whitefish Credit Union",
  "University Family Care",
  "UNIVERSITY FAMILY CARE MARICOPA",
  "UNIVERSITY FAMILY CARE MARICOPA HEALTH PLAN",
  "University Health Alliance",
  "University Health Alliance Health Insurance",
  "University Health Care Advantage",
  "University HealthCare Advantage",
  "University Medical Center",
  "University Medical Center Health Plan (Lubbock)",
  "University of Arizona Health Plan",
  "University of Arizona Health Plan - UHM",
  "University of California Davis Health System",
  "University of California Health Plan Administrators",
  "University of California, Los Angeles Medical Group",
  "University of Colorado",
  "University of Illinois",
  "University of Illinois at Chicago Division of Specialized Care for Children",
  "University of Kentucky Health Services",
  "University of Maryland Health Advantage",
  "University of Maryland Health Partners Inc.",
  "University of Massachusetts Medical School Health and Criminal Justice Program",
  "University of Pittsburgh Medical Center Dental Advantage",
  "University of Pittsburgh Medical Center Health Plan",
  "University of Southern California Health Services",
  "University of Texas Medical Board",
  "University of Texas Medical Branch 3 Share Program",
  "University of Utah Health Plan",
  "University of Utah Health Plans",
  "University of Washington Students and Graduate Appointments",
  "University Physicians Care Advantage",
  "University Physicians Healthcare Group",
  "Unum Dental",
  "Upland Medical Group",
  "UPMC Health Plan",
  "UPMC Health Plan (TriState)",
  "UPMC Vision Advantage",
  "Upper Peninsula Health Group (Third Party Administrator)",
  "Upper Peninsula Health Plan",
  "Upper Peninsula Health Plan (Medicaid)",
  "Uprise Health",
  "US Department of Labor",
  "US Family Health Plan",
  "US Family Health Plan (USFHP) Texas and Louisiana",
  "US FoodService Incorporated",
  "US HealthCare (Health Maintenance Organization)",
  "US Imaging Network",
  "US Imaging Network (New York)",
  "US Mobile Wireless",
  "US National Resources (AIG Risk Management)",
  "USAA (United States Automobile Association)",
  "USAA Medicare Supplemental",
  "USC Health Services",
  "USFHP St. Vincent Medical Center",
  "Utica",
  "Utica Mutual Insurance Company",
  "Utica National Insurance Company of Texas",
  "Uvalde Consolidated Independent School District (CISD)",
  "V and M Restoration",
  "VA Family Members Program Dental (VFMP)",
  "VA Fee Basis Program",
  "VA Health Administration Center",
  "VA Healthcare",
  "Vale U Health",
  "Vale University Health",
  "Valenz",
  "Valenzuela Engineering Incorporated",
  "Valhalla Builders and Developers",
  "Valir PACE Organization",
  "Valley Care Independent Practice Association",
  "Valley Care IPA",
  "Valley Care Program",
  "Valley Casework Incorporated",
  "Valley Fig Growers, Incorporated",
  "Valley Harvesting and Packing Incorporated",
  "Valley Health Plan",
  "Valley Health Plan (Commercial)",
  "Valley Health System",
  "Valley Healthcare Management Services LLC",
  "Valley Memorial Hospital",
  "Valley Physicians Network",
  "Valley Presbyterian Hospital",
  "Valley Presbyterian Hospital Community Family Care",
  "Valley Presbyterian Hospital Preferred Independent Practice Association",
  "Valley Presbyterian Hospital Preferred IPA",
  "Valor Health Plan",
  "Value Options Colorado Medicaid",
  "Value Options Pennsylvania Medicaid",
  "ValueOptions Colorado Medicaid",
  "ValueOptions Commercial",
  "ValueOptions Massachusetts Behavioral Health Partnership",
  "ValueOptions Pennsylvania Medicaid",
  "Van Lang Independent Practice Association-TECQ Partners",
  "Vanderbilt University Medical Center",
  "Vanliners Insurance Company",
  "Vantage Health Plan Incorporated",
  "Vantage Medical Group",
  "Vantage Medical Group Encounters",
  "Variable Protection Administrators",
  "Variable Protection Administrators (VPA)",
  "Varian HealthCare Plan",
  "Varipro",
  "Vault AMPS Administrative Services (Georgia Realtors Association)",
  "Vault Asset Management and Property Services Administrative Services (Georgia Realtors Association)",
  "Vaya Health",
  "Veg Land, Incorporated",
  "Vegetable Growers Supply, Incorporated",
  "Ventura County Health Care Plan",
  "Venture Pacific Development",
  "Verco Manufacturing, Incorporated",
  "Verda (TPHN)",
  "Verda HealthCare Texas",
  "Verdugo Hills Medical Group (Regal)",
  "Verity",
  "Verity Plus",
  "Vermeer",
  "Vertical Concrete",
  "VestaCare",
  "Veterans Affairs Community Care Network Region 1",
  "Veterans Affairs Community Care Network Region 2",
  "Veterans Affairs Community Care Network Region 3",
  "Veterans Affairs Fee Basis Program",
  "Veterans Affairs Field Service Commission Immigration and Customs Enforcement Health Service Corps",
  "VGM HomeLink",
  "Via Christi Hope (Valir Program of All-Inclusive Care for the Elderly Foundation)",
  "Vibra Health Plan",
  "Vicorp Restaurants Incorporated",
  "Vicro Mac",
  "Victor Plastics",
  "Victoria Independent School District",
  "Victoria Tire Center, Incorporated",
  "Vidacare",
  "VieCare Life Armstrong",
  "VieCare Life Beaver and Life Lawrence Counties",
  "Viecare Life Butler",
  "Villa Marina Unocal, Incorporated",
  "Village Family Physician",
  "Village Health Plan",
  "Village MD",
  "VillageCareMAX",
  "VIP Motor Cars, Ltd.",
  "Vipa",
  "Virginia Premier Health",
  "Virginia Surety Company Incorporated",
  "Visiting Nurse Association Homecare Options",
  "Visiting Nurse Service of New York Choice",
  "Vista Hills Country Club",
  "Vital Protection",
  "Vitori Health",
  "Vitruvian Care Incorporated",
  "Viva Health Incorporated",
  "Viva Health Plan",
  "Vivant Health",
  "VNS Health",
  "VNSNY CHOICE Medicare",
  "Volunteers of America National Service",
  "Volusia Health Network",
  "Vought Aircraft Industries",
  "VSP Vision Service Plan",
  "Vxtra Health Plan Inc.",
  "Vytalize Health",
  "Vytra",
  "Vytra Healthcare",
  "W. E. Behel, Incorporated",
  "W. T. Billard, Incorporated",
  "Wagner Meinert",
  "Walmart",
  "Walmart (BlueCard Carriers)",
  "Walter Anderson Plumbing, Incorporated",
  "Washington Apple Health",
  "Washington County",
  "Washington County Health and Human Services",
  "Washington General Fund",
  "Washington Hospital",
  "Washington National Insurance Company",
  "Washington State Department of Labor and Industry",
  "Watkins Manufacturing Corporation",
  "Watts HealthCare",
  "WattsHealth Foundation Incorporated (SNCC)",
  "Wawona Packing",
  "WCF Mutual Insurance Company",
  "WCP, Incorporated",
  "Weatherford Independent School District (ISD)",
  "Web TPA (Third Party Administrator)",
  "Webnburg Consolidated Independent School District (CISD)",
  "WebTPA",
  "WebTPA Employer Services LLC",
  "Weimar Independent School District (ISD)",
  "WelbeHealth",
  "Welcome Health",
  "Welfare Pension Admin Services (WPAS)",
  "Well Sense",
  "Wellborn Health Plans - Dental",
  "WellCare",
  "Wellcare (MM) - Joint Venture Hospital Laboratory",
  "Wellcare (MM) - JVHL",
  "WellCare - Dental",
  "WellCare by Allwell",
  "WellCare by Fidelis Care",
  "WellCare by Health Net",
  "WellCare by Ohana",
  "WellCare by Trillium Advantage",
  "WellCare Health Maintenance Organization",
  "WellCare Health Plan Incorporated (Encounters Only)",
  "WellCare Health Plans",
  "WellCare Illinois",
  "WellCare Michigan",
  "WellCare of California",
  "WellCare of Connecticut",
  "WellCare of Florida",
  "WellCare of Georgia",
  "WellCare of Kentucky",
  "WellCare of Michigan & WellCare of Illinois",
  "WellCare of Nebraska",
  "WellCare of New York",
  "WellCare of North Carolina",
  "Wellfleet Group LLC",
  "Wellmark Blue Cross Blue Shield (Iowa, South Dakota)",
  "Wellmark Blue Cross Blue Shield Dental (Iowa, South Dakota)",
  "Wellmark Blue Cross Blue Shield of Iowa and South Dakota",
  "WellMed",
  "WellMed (Encounters)",
  "WellMed Medical Encounters",
  "WellNet Health Plans",
  "WellNet Healthcare Administrators",
  "WellPoint",
  "WellPoint - Dental",
  "Wellpoint Dental",
  "WellPoint Maryland Incorporated",
  "WellSense Health Plan",
  "WellSpace Nexus LLC",
  "WellStar Health Plan",
  "WellSystems LLC",
  "Wesco Insurance Company",
  "Weslaco Independent School District",
  "Wessex Industries, Incorporated",
  "West Coast Hospitals Incorporated",
  "West Coast Stationary Engineers Health and Security Trust Fund",
  "West County Radiology Center",
  "West Covina Medical Group",
  "West Covina Medical Group (Regal)",
  "West Oso Independent School District",
  "West PACE",
  "West Suburban Health Providers",
  "West Texas Rural Counties Association Preferred Risk Pool Workers' Compensation",
  "West Virginia CareSource Marketplace",
  "West Virginia Medicaid",
  "West Virginia Public Employees Insurance Agency",
  "West Virginia Senior Advantage",
  "West Virginia Senior Choice",
  "WestAmerica Phil Long Dealerships",
  "Western Catholic Union",
  "Western Golf Properties, Incorporated",
  "Western Growers Assurance Trust",
  "Western Growers Insurance Company",
  "Western Health Advantage",
  "Western Mutual Insurance",
  "Western National Assurance",
  "Western National Insurance Group",
  "Western National Insurance Pioneer Specialities",
  "Western National Insurance Pioneer Specialties",
  "Western Oregon Advanced Health (CCO)",
  "Western Pennsylvania Electrical Employees Insurance Trust Fund",
  "Western Pennsylvania Teamsters Fund",
  "Western Sky Community Care",
  "Western Southern Financial Group",
  "Western Southern Financial Group (Cincinnati, OH)",
  "Westfield Insurance",
  "WestGUARD Insurance Company - Berkshire Hathaway GUARD Insurance Companies",
  "Weyco",
  "White Deer Independent School District (ISD)",
  "White Memorial Medical Center",
  "Whiteface Consolidated Independent School District (CISD)",
  "Widdicombe Enterprises, Incorporated",
  "Wilco Life",
  "Willamette View",
  "William C. Earhart Co Inc.",
  "William C. Earhart Company",
  "William C. Earhart Company Incorporated",
  "Williams and Sonoma",
  "Willow Health",
  "Wilmer Hutchins Independent School District Dallas Independent School District",
  "Wilson and Hampton Painting Contractors",
  "Wilson McShane",
  "Wilson Mutual Insurance",
  "Windsor Health Plan",
  "Windsor Medicare Extra",
  "Wisconsin Auto Truck Dealer Association (WATDA)",
  "Wisconsin Chronic Disease Program",
  "Wisconsin Commercial",
  "Wisconsin Department of Corrections",
  "Wisconsin Employers Group",
  "Wisconsin Physicians Service (WPS) - Illinois",
  "Wisconsin Physicians Service (WPS) - Indiana",
  "Wisconsin Physicians Service (WPS) - Iowa",
  "Wisconsin Physicians Service (WPS) - Kansas",
  "Wisconsin Physicians Service (WPS) - Michigan",
  "Wisconsin Physicians Service (WPS) - Minnesota",
  "Wisconsin Physicians Service (WPS) - Missouri",
  "Wisconsin Physicians Service (WPS) - Nebraska",
  "Wisconsin Physicians Service (WPS) - Wisconsin",
  "Wisconsin Physicians Service Group Health / WPS",
  "Wisconsin Physicians Service Health Plan",
  "Wisconsin Physicians Service Insurance Corporation (WPS)",
  "Wisconsin Well Woman Program",
  "WMI Mutual Insurance Company",
  "Women's Health Plan",
  "Women's Healthcare Associates",
  "Women's Integrated Network Incorporated (WIN Fertility)",
  "Womens Integrated Network Incorporated (WIN Fertility)",
  "Woodland Park West",
  "Woodmont Real Estate Services",
  "Workforce Safety and Insurance (WSI)",
  "Worksite Benefit Services LLC",
  "World Trade Center Health Program",
  "World Trade Center Health Program (WTCHP)",
  "Worldwide Medical Assurance Ltd Corp",
  "Worldwide Medical Assurance Ltd Corporation",
  "WPS Health Insurance",
  "WPS Health Plan",
  "Writer's Guild Industry Health",
  "Writers Guild Industry Health",
  "Wyman Gordon Companies",
  "Wyman-Gordon Companies",
  "Xcel Energy",
  "Xchanging Incorporated",
  "Ximed Medical Group",
  "XL Environmental Incorporated",
  "XO Health",
  "Yale University Health Plan",
  "Yamhill CCO Physical Health",
  "Yamhill Community Care Organization (CCO)",
  "Yamhill Community Care Organization (Coordinated Care Organization)",
  "Yamhill County Coordinated Care Organization Physical Health",
  "Yerington Paiute Tribe",
  "YesCare",
  "YMCA",
  "Yorktown Independent School District (ISD)",
  "YourCare Health Plan",
  "YouthCare HealthChoice Illinois",
  "Yuzu Health",
  "Zachry Construction",
  "Zenith Administrators (Minnesota)",
  "Zenith American Solutions Inc",
  "Zenith American Solutions Inc.",
  "Zenith LuminiX",
  "Zenith Lumix",
  "Zenith National Insurance",
  "Zing Choice IL (HMO)",
  "Zing Health",
  "Zurich Farmers",
  "Zurich Insurance North America",
] as const;

export type StediPayor = typeof STEDI_PAYORS[number];
